
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8rIQt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $17427f16dde00e98$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $8snXd = parcelRequire("8snXd");

var $hFFWh = parcelRequire("hFFWh");
/** @deprecated delete when cleaning up getWillShowNav4 */ const $17427f16dde00e98$var$MultiProjectSidebarCore = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8snXd.PerformanceMark), {
        id: (0, $8snXd.RENDER_START_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFFWh.default), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).CORE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8snXd.PerformanceMark), {
        id: (0, $8snXd.RENDER_END_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8snXd.PerformanceReport), null)));
var $17427f16dde00e98$export$2e2bcd8739ae039 = $17427f16dde00e98$var$MultiProjectSidebarCore;

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("8snXd", function(module, exports) {

$parcel$export(module.exports, "RENDER_START_MARK", () => $5e4f397416a402e4$export$8f8203e04f80aed);
$parcel$export(module.exports, "RENDER_END_MARK", () => $5e4f397416a402e4$export$dc795f9b21e2778a);
$parcel$export(module.exports, "PerformanceMark", () => $5e4f397416a402e4$export$b8228db3a01d9a76);
$parcel$export(module.exports, "PerformanceReport", () => $5e4f397416a402e4$export$c97ab321326d29f7);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");
const $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
const $5e4f397416a402e4$export$8f8203e04f80aed = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
const $5e4f397416a402e4$export$dc795f9b21e2778a = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
const $5e4f397416a402e4$var$segment = (0, $dGrdR.metrics).pageSegmentLoad({
    key: $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME,
    timings: [
        {
            key: 'tti',
            endMark: $5e4f397416a402e4$export$dc795f9b21e2778a
        }
    ]
});
const $5e4f397416a402e4$export$b8228db3a01d9a76 = ({ id: id })=>{
    const startedRef = (0, $5uXOq.useRef)(false);
    if (!false && !startedRef.current) {
        $5e4f397416a402e4$var$segment.startFromPageLoad();
        startedRef.current = true;
    }
    (0, $5uXOq.useEffect)(()=>$5e4f397416a402e4$var$segment.mark(id), [
        id
    ]);
    return null;
};
const $5e4f397416a402e4$export$c97ab321326d29f7 = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        $5e4f397416a402e4$var$segment.stop();
    }, []);
    return null;
};

});

parcelRegister("hFFWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $af0c023251a98909$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSUZZ = parcelRequire("cSUZZ");

var $cZpsT = parcelRequire("cZpsT");

var $doZTA = parcelRequire("doZTA");

var $6tzEU = parcelRequire("6tzEU");

var $aueMW = parcelRequire("aueMW");

var $iZNik = parcelRequire("iZNik");

var $NCdt4 = parcelRequire("NCdt4");

var $dCGEg = parcelRequire("dCGEg");

var $6KeQr = parcelRequire("6KeQr");

var $k5gug = parcelRequire("k5gug");
const $af0c023251a98909$var$MultiProjectMenu = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, $6tzEU.useSidebarData)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isPremiumUserSeat = (0, $cSUZZ.useIsPremiumUserSeat)();
    const [projectState] = (0, $cE2Qr.useProjectState)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
            starredProjectsCount: favorites.length,
            recentProjectsCount: recents.length,
            overviewsCount: overviews.length
        });
    // only run once on component mount
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // the currentProject data gets loaded async and thus it is null while
    // transitioning between projects. To allow expanding the right current
    // project when the data has not been resolved yet, we use the project
    // key from the URL instead.
    const currentProjectKey = projectKey ?? currentProject?.key;
    const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
    const projectsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", null, favorites.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KeQr.default), {
        sectionId: "starred",
        projects: favorites,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        showViewAllProjects: hasMoreFavorite,
        viewAllProjectsLabel: formatMessage((0, $NCdt4.default).viewAllStarred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KeQr.default), {
        sectionId: "recent",
        projects: recents,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        showViewAllProjects: true
    }));
    const isShowingCTA = projectState?.isSampleProject === true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SidebarWrapper, {
        "aria-label": formatMessage((0, $NCdt4.default).navigationLabel),
        isCrossProjectView: true
    }, shouldDisplayOverviews && (loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$OverviewsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCGEg.default), {
        overviews: overviews,
        hasError: Boolean(overviewsError)
    }))), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ProjectsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5gug.default), null), projectsContent), !loading && isShowingCTA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aueMW.CreateProjectCta), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Footer, {
        hasMargin: true
    }, currentProject != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Type, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
    }, currentProject.isSimplified ? formatMessage((0, $NCdt4.default).teamManagedProject) : formatMessage((0, $NCdt4.default).companyManagedProject)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iZNik.default), null)));
};
const $af0c023251a98909$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemAvatarSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonBase, null));
const $af0c023251a98909$var$OverviewsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
const $af0c023251a98909$var$ProjectsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4t3i1osq _1e0c1txw _2lx21bp4 _bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$SidebarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71exx _n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
            __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$SkeletonBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _bfhkm7j4 _4t3i1crf _1bsbqkoa _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$SkeletonSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$SectionHeaderSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb68cl _4t3i7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$ItemSkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$ItemAvatarSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$CollapsibleHeaderSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbys9h _18u0u2gc _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.hasMargin && "_18s8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af0c023251a98909$var$Type = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _y3gn1h6o _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _1tke7vkz _syaz131l",
            __cmplp.className
        ])
    });
});
const $af0c023251a98909$var$MemoMultiProjectMenu = /*#__PURE__*/ (0, $5uXOq.memo)($af0c023251a98909$var$MultiProjectMenu);
var $af0c023251a98909$export$2e2bcd8739ae039 = $af0c023251a98909$var$MemoMultiProjectMenu;

});
parcelRegister("cE2Qr", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $796be817ff5bbbfa$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $796be817ff5bbbfa$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $796be817ff5bbbfa$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $796be817ff5bbbfa$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $796be817ff5bbbfa$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $796be817ff5bbbfa$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $796be817ff5bbbfa$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $796be817ff5bbbfa$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $796be817ff5bbbfa$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $796be817ff5bbbfa$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $796be817ff5bbbfa$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $796be817ff5bbbfa$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $796be817ff5bbbfa$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $796be817ff5bbbfa$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $796be817ff5bbbfa$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $796be817ff5bbbfa$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $796be817ff5bbbfa$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $796be817ff5bbbfa$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $796be817ff5bbbfa$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $796be817ff5bbbfa$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $796be817ff5bbbfa$export$f4a2be940259bf95);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);

var $58GFP = parcelRequire("58GFP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8Bc5A = parcelRequire("8Bc5A");

var $6RAg1 = parcelRequire("6RAg1");

var $ieqoN = parcelRequire("ieqoN");

var $cGE52 = parcelRequire("cGE52");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");

const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $cGE52.initialState,
    actions: $6RAg1.actions
});
const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $51nlc.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $gg7kZ.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
});
const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$a943afa434e9487a
});
const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: null
});
const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$9d731f44f82af09f
});
const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN || userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)];
        return visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN)
});
const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $8Bc5A.KANBAN_ONBOARDING_TASK)))
});
const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$789332a2d3504754 = 'jira.polaris:portfolio';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};

});

parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $5f07ce956337ba8b$export$5980f41aa657f9c7);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];
const $5f07ce956337ba8b$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("6RAg1", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4752306278e43a2d$export$e324594224ef24da);

var $6fSBR = parcelRequire("6fSBR");

var $j6wxT = parcelRequire("j6wxT");

var $7mZ3t = parcelRequire("7mZ3t");

var $8UXiA = parcelRequire("8UXiA");

var $3iEb4 = parcelRequire("3iEb4");

var $7yDu9 = parcelRequire("7yDu9");

var $5UBG2 = parcelRequire("5UBG2");

var $lHcRB = parcelRequire("lHcRB");

var $eiyXc = parcelRequire("eiyXc");

var $jZvbN = parcelRequire("jZvbN");

var $azcAL = parcelRequire("azcAL");

var $gbXQ5 = parcelRequire("gbXQ5");

var $iZuFy = parcelRequire("iZuFy");

var $70Fss = parcelRequire("70Fss");

var $erLQY = parcelRequire("erLQY");

var $dQPsy = parcelRequire("dQPsy");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $cUGWT = parcelRequire("cUGWT");

var $boV1S = parcelRequire("boV1S");

var $4Viq4 = parcelRequire("4Viq4");

var $jIoq4 = parcelRequire("jIoq4");

var $75A1x = parcelRequire("75A1x");

var $1Xkin = parcelRequire("1Xkin");
const $4752306278e43a2d$export$e324594224ef24da = {
    changeTaskGroupParent: $6fSBR.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $6fSBR.nextGoBackToPreviousTaskGroup,
    setIsOpen: $j6wxT.setIsOpen,
    refreshAppState: $7mZ3t.refreshAppState,
    setNudgeStep: $8UXiA.setNudgeStep,
    addMountedNudge: $3iEb4.addMountedNudge,
    removeMountedNudge: $3iEb4.removeMountedNudge,
    setShouldRenderComponent: $7yDu9.setShouldRenderComponent,
    setProjectState: $5UBG2.setProjectState,
    setHasNudgeActive: $lHcRB.setHasNudgeActive,
    forceHideNudge: $eiyXc.forceHideNudge,
    setHasEverSeenRoute: $jZvbN.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $azcAL.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $azcAL.setRoadmapIsListEmpty,
    openNextTask: $gbXQ5.openNextTask,
    resetIsQuickstartLoaded: $iZuFy.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $70Fss.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $erLQY.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $dQPsy.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $abQXL.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $4VXxO.nextSetChecklistIsOpen,
    nextOpenTask: $cUGWT.nextOpenTask,
    nextAutoExpand: $boV1S.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $4Viq4.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $jIoq4.nextGetTasks,
    syncVisibilityWithLocal: $75A1x.syncVisibilityWithLocal,
    universalDispatch: $1Xkin.universalDispatch
};

});
parcelRegister("6fSBR", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $0f1566e1d3fc2987$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $0f1566e1d3fc2987$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };
const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("1ftPQ", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $d3dd40bf54ad27bf$export$583b2d2422a6757f);

var $89SaW = parcelRequire("89SaW");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $89SaW.setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
    });
const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
    const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
};

});


parcelRegister("j6wxT", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $eefde484654068e9$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");
const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };
var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;

});
parcelRegister("3B5jO", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $47424244d57f6abc$export$eae834ce0286017a);

var $2vSU6 = parcelRequire("2vSU6");

var $8Bc5A = parcelRequire("8Bc5A");
const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
    if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("7mZ3t", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);


var $8fqy8 = parcelRequire("8fqy8");

var $8zOmE = parcelRequire("8zOmE");

var $bfWlw = parcelRequire("bfWlw");

var $ldyPw = parcelRequire("ldyPw");

var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $1ftPQ = parcelRequire("1ftPQ");

var $52Vcw = parcelRequire("52Vcw");

var $ljzlb = parcelRequire("ljzlb");

var $6ypzr = parcelRequire("6ypzr");

var $4ji4w = parcelRequire("4ji4w");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $erLQY = parcelRequire("erLQY");

var $6fSBR = parcelRequire("6fSBR");
const $ecf6e94ad9c4f8d6$var$allTasks = [
    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
    ...(0, $8Bc5A.JSM_BUSINESS_TASKS)
];
const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $8Bc5A.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_TASK_GROUP),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                ...$ecf6e94ad9c4f8d6$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $4ji4w.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $ldyPw.PREMIUM_EDITION)) {
            dispatch((0, $6fSBR.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $8fqy8.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $ljzlb.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $bfWlw.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $4VXxO.nextSetChecklistIsOpen)(true));
            dispatch((0, $abQXL.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $erLQY.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $6fSBR.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $1ftPQ.pushToBackend)({
                key: (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("8fqy8", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $77364531dfabe700$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $77364531dfabe700$export$6da79f996c267010);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $eusud.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("bfWlw", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $a55f3307b43c0521$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $a55f3307b43c0521$export$ef676f7f369f74fe);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $6c7t9 = parcelRequire("6c7t9");
const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $6c7t9.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $6c7t9.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $eusud.performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $6c7t9.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $6c7t9.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("6c7t9", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$f389f8ca168b4a3a);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $fab9df2877e9db77$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6yhDy", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $760653e5a4f27459$export$8420ef0cee98de);

var $1sYcL = parcelRequire("1sYcL");

var $8Bc5A = parcelRequire("8Bc5A");
const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $1sYcL.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $duUGa.UFOExperience)(key, {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("52Vcw", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $5dab66e6da9554ae$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $5dab66e6da9554ae$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $5dab66e6da9554ae$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $5dab66e6da9554ae$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $5dab66e6da9554ae$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $5dab66e6da9554ae$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $5dab66e6da9554ae$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $5dab66e6da9554ae$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $5dab66e6da9554ae$export$6c39ca65ca354e59);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");
const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $8Bc5A.ACTION_SUBJECT_ID), attributes);
};
const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $izv86.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("izv86", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $4725f5ccfabd2231$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $4725f5ccfabd2231$export$3b914201960fa7a6);

var $e4eHl = parcelRequire("e4eHl");

var $2vSU6 = parcelRequire("2vSU6");
const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
    [(0, $2vSU6.CORE_PROJECT)]: 'workManagement',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(projectType);
    return null;
};
const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
};

});


parcelRegister("ljzlb", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $9217b5bb53dd29c2$export$7f2186c37a3d095d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $k9OK8 = parcelRequire("k9OK8");
const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $eusud.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $8Bc5A.PACKAGE_NAME),
                teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $k9OK8.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("k9OK8", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ee27e8acf854e0ab$export$99f3e48748c2a8c3);

var $eNf8a = parcelRequire("eNf8a");

const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("6ypzr", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $98fe78eb4dc2e758$export$980c26b6f100081d);

var $eusud = parcelRequire("eusud");
const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, $eusud.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("4ji4w", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $af696889329ec63a$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $af696889329ec63a$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $af696889329ec63a$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $af696889329ec63a$export$93d719890ad66653);

var $bSSG7 = parcelRequire("bSSG7");

var $aFsRe = parcelRequire("aFsRe");
const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $af696889329ec63a$var$store = (0, $bSSG7.createLocalStorageProvider)('quickstart');
const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
    $af696889329ec63a$var$store.set(key, value);
};
const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);

});
parcelRegister("aFsRe", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $856e0575daef172f$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $856e0575daef172f$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $856e0575daef172f$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $856e0575daef172f$export$293f6b2affa6ea5a);

var $izv86 = parcelRequire("izv86");







const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("abQXL", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $dc09dffee9419aae$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED : (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: false
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("4VXxO", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $7815e3bf96163d46$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("erLQY", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $f082da41253fd664$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1ftPQ = parcelRequire("1ftPQ");
const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $1ftPQ.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("8UXiA", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $2d15900fae273e3c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;

});

parcelRegister("3iEb4", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d23aba2b0749d2be$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d23aba2b0749d2be$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("7yDu9", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $e7988e1b8f7782bd$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;

});

parcelRegister("5UBG2", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $72dc29ca0b198f0e$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;

});

parcelRegister("lHcRB", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $4ecbca1b06d3bc5e$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;

});

parcelRegister("eiyXc", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("jZvbN", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $bde38543b00c29f3$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;

});

parcelRegister("azcAL", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f19987e3027503ab$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f19987e3027503ab$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gbXQ5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $460159056a360dfc$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $4ji4w.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cUGWT", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $f8b3135a172025f8$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $f8b3135a172025f8$export$cc5f3544a6cb2922);


var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $8UXiA = parcelRequire("8UXiA");

var $lHcRB = parcelRequire("lHcRB");
const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        else dispatch((0, $lHcRB.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.SCRUM_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.KANBAN_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.ADD_COLUMNS_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else dispatch((0, $8UXiA.setNudgeStep)(''));
    };
const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        dispatch((0, $8UXiA.setNudgeStep)(''));
    };

});


parcelRegister("iZuFy", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $b50ce46f86d3e3d7$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $3B5jO = parcelRequire("3B5jO");
const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("70Fss", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $f0fdda8951af3bde$export$87fe8079a4ed9766);


var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $52Vcw = parcelRequire("52Vcw");

var $6ypzr = parcelRequire("6ypzr");

var $abQXL = parcelRequire("abQXL");
const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dQPsy", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $82a74350685dcd25$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $8Bc5A.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("boV1S", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $35a410a5fb89f79b$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $984bX.localStorageProvider)().get({
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $4ji4w.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $cUGWT.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("984bX", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $a6d0a6873aa6f7aa$export$f2666fae743fa5f);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $8Bc5A = parcelRequire("8Bc5A");
const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
const $a6d0a6873aa6f7aa$var$DAY = 86400000;
const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
};
let $a6d0a6873aa6f7aa$var$localStorage;
const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
    if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
    const provider = (0, $eNf8a.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    $a6d0a6873aa6f7aa$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $a6d0a6873aa6f7aa$var$localStorage;
};
const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
    $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
        accountId: (0, $8Bc5A.ACCOUNT_ID),
        key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("4Viq4", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $lHcRB = parcelRequire("lHcRB");
const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $984bX.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $lHcRB.setHasNudgeActive)(true));
            (0, $984bX.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("jIoq4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $034f263b888956c9$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ikZFc = parcelRequire("ikZFc");
const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $ikZFc.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("ikZFc", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $cb6c1b1dc7b1b225$export$d1f442602a91e7cc);

var $6s1PB = parcelRequire("6s1PB");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");


var $ldyPw = parcelRequire("ldyPw");

var $jtI3q = parcelRequire("jtI3q");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $ieqoN = parcelRequire("ieqoN");

var $3Iaiu = parcelRequire("3Iaiu");

var $aHo1U = parcelRequire("aHo1U");

var $5yUqp = parcelRequire("5yUqp");

var $5zzQl = parcelRequire("5zzQl");

var $jJca1 = parcelRequire("jJca1");

var $d7Knl = parcelRequire("d7Knl");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $aHo1U.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $8Bc5A.ROOT_TASK) ? (0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $8Bc5A.ROOT_TASK];
    return {
        title: title,
        items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
    };
};
const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
    if ((0, $c04PQ.isFedRamp)()) variants.add((0, $aHo1U.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $aHo1U.JSW).experiment.jswReverseTrial);
        (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $aHo1U.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $aHo1U.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $aHo1U.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $aHo1U.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $aHo1U.JSW).experience.kanbanOnboarding);
    if (isWizardSimplifyQS) variants.add((0, $aHo1U.JSW).experiment.wizard);
    if (canCreateProject === false) variants.add((0, $aHo1U.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $aHo1U.JSW).projectStyle.teamManaged);
    else variants.add((0, $aHo1U.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $aHo1U.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.jiraAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.siteAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $ldyPw.FREE_EDITION)) variants.add((0, $aHo1U.JSW).edition.free);
    else if (projectState?.edition === (0, $ldyPw.STANDARD_EDITION)) variants.add((0, $aHo1U.JSW).edition.standard);
    else if (projectState?.edition === (0, $ldyPw.PREMIUM_EDITION)) variants.add((0, $aHo1U.JSW).edition.premium);
    if ((0, $1ffS1.isRoadmapRoute)(routeName)) variants.add((0, $aHo1U.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $aHo1U.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $aHo1U.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $aHo1U.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $aHo1U.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $aHo1U.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $aHo1U.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $aHo1U.JSW).experiment.customizeSiteName);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $aHo1U.JSW).taskVariants,
        taskList: (0, $aHo1U.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $5yUqp.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $5yUqp.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $cb6c1b1dc7b1b225$export$e21b96de210942({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $5yUqp.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $5yUqp.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $5yUqp.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $5yUqp.JWM).experiments.isSampleProject);
    else variants.push((0, $5yUqp.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $5yUqp.JWM).experiments.trelloCrossflow);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $5yUqp.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3Iaiu.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3Iaiu.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.siteAdmin);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3Iaiu.JSM).taskVariants,
        taskList: (0, $3Iaiu.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $pDX5d.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $pDX5d.Feature).hasSprint);
    if (isEligibleForTailoredOnboardingM3) variants.push((0, $8VfDj.Experiment).tailoredOnboardingM3Eligible);
    if (isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
    if (teamType && (0, $jtI3q.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS: isWizardSimplifyQS = false, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $jJca1.isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $jJca1.isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $cb6c1b1dc7b1b225$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jtI3q", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $606262a699c9299e$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $606262a699c9299e$export$26c385918d734203);

var $370Ye = parcelRequire("370Ye");
const $606262a699c9299e$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredTeamTypes).includes(teamType);
};
const $606262a699c9299e$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("370Ye", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $06c84b7af2a23aee$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $06c84b7af2a23aee$export$52c5394d6e6cfcf3);

const $06c84b7af2a23aee$export$a1fbb7d965e15a39 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];
const $06c84b7af2a23aee$export$52c5394d6e6cfcf3 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];

});


parcelRegister("1ffS1", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $ee93e5dd18635f6d$export$d1fa67c1ffb68871);
const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("ieqoN", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $353950c3dd35bbc6$export$8eeb199b23203523);
const $353950c3dd35bbc6$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("3Iaiu", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $56a077523ddf70fb$export$63f289f2da861d35);

var $58IQc = parcelRequire("58IQc");
const $56a077523ddf70fb$export$63f289f2da861d35 = {
    taskList: (0, $58IQc.JSM_TASK_LIST),
    taskVariants: (0, $58IQc.JSM_TASK_VARIANTS),
    userRole: (0, $58IQc.UserRole),
    experiments: (0, $58IQc.Experiments)
};

});
parcelRegister("58IQc", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $3c13225c81ad4b5c$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $3c13225c81ad4b5c$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $3c13225c81ad4b5c$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $3c13225c81ad4b5c$export$5b68aef408c932d9);

var $8Bc5A = parcelRequire("8Bc5A");

var $kTSRm = parcelRequire("kTSRm");
const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $kTSRm.messages).rootTitle,
        items: [
            (0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
    [(0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("kTSRm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1f6142c4170f38e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1f6142c4170f38e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("aHo1U", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $563027753d017a60$export$4cfe6e52f2e72a54);

var $8VfDj = parcelRequire("8VfDj");
const $563027753d017a60$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8VfDj.TASK_LIST),
    taskVariants: (0, $8VfDj.TASK_VARIANTS),
    experiment: (0, $8VfDj.Experiment),
    experience: (0, $8VfDj.Experience),
    projectStyle: (0, $8VfDj.ProjectStyle),
    userRole: (0, $8VfDj.UserRole),
    edition: (0, $8VfDj.Edition),
    route: (0, $8VfDj.Route),
    permissions: (0, $8VfDj.Permissions),
    trait: (0, $8VfDj.Trait)
};

});
parcelRegister("8VfDj", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $ea3903bb15047c3b$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $ea3903bb15047c3b$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $ea3903bb15047c3b$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $ea3903bb15047c3b$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $ea3903bb15047c3b$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $ea3903bb15047c3b$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $ea3903bb15047c3b$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $ea3903bb15047c3b$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $ea3903bb15047c3b$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $ea3903bb15047c3b$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $ciLFO = parcelRequire("ciLFO");
const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    wizard: 'experiment.wizard',
    tailoredOnboardingM3Eligible: 'experiment.tailoredOnboardingM3Eligible',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $ea3903bb15047c3b$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
    (0, $8Bc5A.ADD_COLUMNS_TASK),
    (0, $8Bc5A.CREATE_PROJECT_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK),
    (0, $8Bc5A.FIND_HELP_TASK),
    (0, $8Bc5A.SET_UP_BOARD_TASK),
    (0, $8Bc5A.GET_MOBILE_APP_TASK),
    (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $8Bc5A.MONITOR_MANAGE_RISK_TASK),
    (0, $8Bc5A.SCRUM_ONBOARDING_TASK),
    (0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK),
    (0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $8Bc5A.GET_STARTED_LIST_TASK),
    (0, $8Bc5A.CALENDAR_VIEW_TASK)
];
const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ciLFO.messages).rootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $ciLFO.messages).reverseTrialRootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $ciLFO.messages).reverseTrialCardTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK)
        ]
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).standardPlanTitle,
        items: [
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
    ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
    [(0, $8Bc5A.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $8Bc5A.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("ciLFO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $609e253829546460$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $609e253829546460$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("5yUqp", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $80382801c7786de6$export$3ff26c80cb588e12);

var $82B5j = parcelRequire("82B5j");

var $8jC8d = parcelRequire("8jC8d");

var $5PFhq = parcelRequire("5PFhq");
const $80382801c7786de6$export$3ff26c80cb588e12 = {
    taskList: (0, $82B5j.TASK_LIST),
    taskVariants: (0, $82B5j.TASK_VARIANTS),
    userRole: (0, $5PFhq.UserRole),
    experiments: (0, $8jC8d.Experiments)
};

});
parcelRegister("82B5j", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $3b1179694682c8c8$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $3b1179694682c8c8$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $8jC8d = parcelRequire("8jC8d");

var $aQMWP = parcelRequire("aQMWP");

var $5PFhq = parcelRequire("5PFhq");
const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $aQMWP.messages).rootTitle,
        items: [
            (0, $8Bc5A.JWM_CREATE_PROJECT_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK),
            (0, $8Bc5A.GET_STARTED_LIST_TASK),
            (0, $8Bc5A.JWM_CALENDAR_TASK),
            (0, $8Bc5A.JWM_TIMELINE_TASK),
            (0, $8Bc5A.JWM_BUILD_FORM_TASK),
            (0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_SHARE_PROJECT_TASK),
            (0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
    ...$3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $8Bc5A.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("8jC8d", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $6cd173da51fb2ca8$export$c8d6ffd15214553a);
const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("aQMWP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40755a70921f89dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40755a70921f89dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5PFhq", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $637dacd99a3a1727$export$eb3485a690c2f0b8);
const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("5zzQl", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $f17c108f7b3045ad$export$20b82b4a32771893);

var $fNtu3 = parcelRequire("fNtu3");
const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $fNtu3.getConditional)(visibility, variants) : true;
const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, $fNtu3.getConditional)(position, variants);
const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("fNtu3", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $8978a3b25f57d9ac$export$fe3161cde0106bba);
const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("jJca1", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $6249819f9bc2846f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $6249819f9bc2846f$export$a972ed853ed1d469);

var $2vSU6 = parcelRequire("2vSU6");
const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $2vSU6.CORE_PROJECT);
const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});

parcelRegister("d7Knl", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $98ba598c6688dfac$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $98ba598c6688dfac$export$eb17ad7838835d2a);


var $8Bc5A = parcelRequire("8Bc5A");

var $57ZKw = parcelRequire("57ZKw");

var $i2O9c = parcelRequire("i2O9c");

var $643hq = parcelRequire("643hq");

var $2Ld7w = parcelRequire("2Ld7w");

var $1bW8Q = parcelRequire("1bW8Q");

var $9mlnS = parcelRequire("9mlnS");

var $f4rKN = parcelRequire("f4rKN");

var $3YqPl = parcelRequire("3YqPl");

var $xk58e = parcelRequire("xk58e");
const $98ba598c6688dfac$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD),
            (0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG),
            (0, $8Bc5A.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $98ba598c6688dfac$export$83849aa73c0a20db = {
    taskList: $98ba598c6688dfac$export$2757f7b23d120b9b,
    taskVariants: (0, $xk58e.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $98ba598c6688dfac$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$be9c097e18825d4c = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $3YqPl.SOFTWARE_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b:
            return 0, $3YqPl.SOFTWARE_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$eb17ad7838835d2a = {
    taskList: $98ba598c6688dfac$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $98ba598c6688dfac$export$3c409334669aec75
};

});
parcelRegister("57ZKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b241f4df6ba82218$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b241f4df6ba82218$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("i2O9c", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $c81c85368d94bebb$export$bdd338c80f8962df);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $c81c85368d94bebb$export$bdd338c80f8962df = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("pDX5d", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $c47e1ea5de95ecc4$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $c47e1ea5de95ecc4$export$6e91cf7616333d5);

const $c47e1ea5de95ecc4$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $6784cbc7d62e5d7c$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $6784cbc7d62e5d7c$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $6784cbc7d62e5d7c$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $c47e1ea5de95ecc4$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint'
};

});


parcelRegister("643hq", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("2Ld7w", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $d62d711ad5ddd92f$export$a3c4cd8e420f13a);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $d62d711ad5ddd92f$export$a3c4cd8e420f13a = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("1bW8Q", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $09c03dfb484f3e93$export$a25e809b52945082);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $09c03dfb484f3e93$export$a25e809b52945082 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9mlnS", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $6398fc5437bfee58$export$916be3c140ae8c0);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $6398fc5437bfee58$export$916be3c140ae8c0 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("f4rKN", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $dc653043c34d0d58$export$7a0daeb069f34de3);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $dc653043c34d0d58$export$7a0daeb069f34de3 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("3YqPl", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $136badd6870fea88$export$76a143792cc73994);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $136badd6870fea88$export$76a143792cc73994 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("xk58e", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $70190108b7b6e00a$export$64855550cee11b78);

var $8Bc5A = parcelRequire("8Bc5A");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $70190108b7b6e00a$export$64855550cee11b78 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software,
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});




parcelRegister("75A1x", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f9427b1514e1931c$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("1Xkin", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $e706482dec5e8abf$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e706482dec5e8abf$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("cGE52", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d175a7a443e10f6d$export$d4c72bab9d6cc13a);

var $8Bc5A = parcelRequire("8Bc5A");
const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $8Bc5A.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("cSUZZ", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $203c641f0a3380f5$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $203c641f0a3380f5$export$90749419e9042370);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $9dQKJ = parcelRequire("9dQKJ");
const $203c641f0a3380f5$export$92c4069b5349d086 = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $9dQKJ.fetchLicenseDetails)((0, $2993c3eadd0dda3e$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $203c641f0a3380f5$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($203c641f0a3380f5$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $2993c3eadd0dda3e$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("9dQKJ", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $164a09ef89830ae9$export$ec058a82eccb31e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $164a09ef89830ae9$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $164a09ef89830ae9$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $164a09ef89830ae9$var$EMPTY_RESPONSE;
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("6tzEU", function(module, exports) {

$parcel$export(module.exports, "useSidebarData", () => $530d739908e5dec3$export$f9257874e114985c);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hecDf = parcelRequire("hecDf");

var $4041n = parcelRequire("4041n");


var $iNzEe = parcelRequire("iNzEe");

var $4fCE7 = parcelRequire("4fCE7");
const $530d739908e5dec3$export$f9257874e114985c = ()=>{
    const { project: currentProject } = (0, $hecDf.useNavigationProject)();
    const { data: data, update: update, refresh: refresh, loading: loading } = (0, $iNzEe.useNavigationResource)();
    const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, $4041n.useChangeFavorite)();
    const isRefreshingFavorites = (0, $5uXOq.useRef)(false);
    const hasRefreshedOnce = (0, $5uXOq.useRef)(false);
    const onFavoriteToggle = (0, $5uXOq.useCallback)((project)=>{
        changeFavorite({
            id: String(project.id),
            type: 'projects',
            value: !project.isFavorite
        });
    }, [
        changeFavorite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
            isRefreshingFavorites.current = true;
            refresh();
        }
    }, [
        changedItems,
        refresh
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isRefreshingFavorites.current = false;
    }, [
        data
    ]);
    let recents;
    let favorites;
    let hasMoreFavorite;
    let overviews;
    let overviewsError;
    let isPremiumUserSeat;
    let shouldHideOverviews;
    if (data == null || data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
        // if the resource was initially fetched for a not applicable project (i.e. not a business project)
        // on the initial page load, then we have not yet fetched the list of sidebar business projects
        // we thus refresh the resource in the background now that we are in a business project
        if (data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
            hasRefreshedOnce.current = true;
            refresh();
        }
        recents = [];
        favorites = [];
        hasMoreFavorite = false;
        overviews = [];
        overviewsError = null;
        isPremiumUserSeat = false;
        shouldHideOverviews = false;
    } else {
        recents = data.recents;
        favorites = data.favorites;
        hasMoreFavorite = data.hasMoreFavorite;
        overviews = data.overviews;
        overviewsError = data.overviewsError;
        isPremiumUserSeat = data.isPremiumUserSeat;
        shouldHideOverviews = data.shouldHideOverviews;
    }
    // if the current is not in either recents or favorites, push it to the top of recents
    if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
        recents = (0, $4fCE7.prependProject)(currentProject, recents);
        // make sure that the reference doesn't get overwritten for the resource update below
        const newRecents = recents;
        update(()=>({
                recents: newRecents,
                favorites: favorites,
                hasMoreFavorite: hasMoreFavorite,
                overviews: overviews,
                overviewsError: overviewsError,
                isPremiumUserSeat: isPremiumUserSeat,
                shouldHideOverviews: shouldHideOverviews
            }));
    }
    // if there are changes to favorites, update projects
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(changedItems)) {
        recents = recents.map((project)=>(0, $4fCE7.mapProjectChanges)(project, changedItems));
        favorites = favorites.map((project)=>(0, $4fCE7.mapProjectChanges)(project, changedItems));
    }
    return {
        currentProject: currentProject,
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: hasMoreFavorite,
        onFavoriteToggle: onFavoriteToggle,
        overviews: overviews,
        overviewsError: overviewsError,
        shouldHideOverviews: shouldHideOverviews,
        loading: loading && !isRefreshingFavorites.current
    };
};

});
parcelRegister("hecDf", function(module, exports) {

$parcel$export(module.exports, "useNavigationProject", () => $46378552d09cbbed$export$befd5d7ebc77f264);


var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $doZTA = parcelRequire("doZTA");
const $46378552d09cbbed$export$befd5d7ebc77f264 = ()=>{
    const { data: currentProject, loading: currentProjectLoading } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const { data: navigationData, loading: navigationDataLoading } = (0, $iNzEe.useNavigationResource)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $doZTA.useRouter)();
    if (currentProject != null) return {
        project: currentProject,
        loading: currentProjectLoading
    };
    if (projectKey != null && navigationData != null && navigationData !== (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
        const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
        return {
            project: project,
            loading: navigationDataLoading
        };
    }
    return {
        project: null,
        loading: currentProjectLoading || navigationDataLoading
    };
};

});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("iNzEe", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $6b942b0827824c4b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $6b942b0827824c4b$export$c17011c09e042a31);

var $gccSB = parcelRequire("gccSB");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $geiy6 = parcelRequire("geiy6");

const $6b942b0827824c4b$export$62940941ee574cdc = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectId)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $kV9ss.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $2YP9W.useResource)($6b942b0827824c4b$export$62940941ee574cdc);

});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;

parcelRegister("geiy6", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $446f8b979bebb841$export$1fc5fff73d9a570c);

var $jlq4V = parcelRequire("jlq4V");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $ifwpM = parcelRequire("ifwpM");
const $446f8b979bebb841$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $ifwpM.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $446f8b979bebb841$var$EMPTY_RESPONSE;
};

});
parcelRegister("ifwpM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9031e5290b70d3d6$export$3ceb62baab058c6b);

var $6cG4N = parcelRequire("6cG4N");


var $027FQ = parcelRequire("027FQ");
const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
    });
const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $027FQ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("027FQ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $fd4c320fd9ec6c35$export$ddf2fc82885279d);
const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $fd4c320fd9ec6c35$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("l2N2a", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a72df1053ff3c9a0$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$97def3841413167f);
/* eslint-disable camelcase */ 
var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $8s4PA = parcelRequire("8s4PA");
const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a72df1053ff3c9a0$export$ced53bf9d9551fef = (0, $2M1hQ.createResource)({
    type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $8s4PA.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a72df1053ff3c9a0$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("8s4PA", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $3400333a67b09775$export$78aa221476efa1c6);

var $kV9ss = parcelRequire("kV9ss");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $2D9kr = parcelRequire("2D9kr");
const $3400333a67b09775$var$EMPTY_VALUE = {};
const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $kV9ss.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $2D9kr.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $3400333a67b09775$var$EMPTY_VALUE;
};

});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;

parcelRegister("2D9kr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $a9016a2d391e1663$export$3ceb62baab058c6b);
const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});




parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $9AmTW = parcelRequire("9AmTW");

var $6BtlL = parcelRequire("6BtlL");

var $kwbhb = parcelRequire("kwbhb");

var $6oLWS = parcelRequire("6oLWS");

var $aSWXp = parcelRequire("aSWXp");

var $kV9ss = parcelRequire("kV9ss");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $kV9ss.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $6oLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $kwbhb.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $aSWXp.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $6BtlL.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $9AmTW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("9AmTW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $6fa93d978dc51edc$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-servicedesk/queue/manifest.ts
var $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $6fa93d978dc51edc$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("6BtlL", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $4cecf7137216f798$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-software/board/manifest.ts
var $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $4cecf7137216f798$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("kwbhb", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $eeff8afd95fca51f$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/dashboard/manifest.ts
var $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $eeff8afd95fca51f$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("aSWXp", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $7eccae3426beb5b5$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/plan/manifest.ts
var $7eccae3426beb5b5$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $7eccae3426beb5b5$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});



parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("4fCE7", function(module, exports) {

$parcel$export(module.exports, "prependProject", () => $5da6154530b9fc4e$export$9e33a1a4f95ad56f);
$parcel$export(module.exports, "mapProjectChanges", () => $5da6154530b9fc4e$export$6cb16ed8ac180dfc);

const $5da6154530b9fc4e$export$9e33a1a4f95ad56f = (project, projects)=>[
        project,
        ...projects
    ].slice(0, (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd));
const $5da6154530b9fc4e$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
        ...project,
        isFavorite: changedItems[project.id].value
    } : project;

});


parcelRegister("aueMW", function(module, exports) {

$parcel$export(module.exports, "CreateProjectCta", () => $a1b8ae763ebf57fa$export$f49a4235d24dbad0);

var $5uXOq = parcelRequire("5uXOq");

var $4RjZC = parcelRequire("4RjZC");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");
const $a1b8ae763ebf57fa$var$runtimeProps = {};
const $a1b8ae763ebf57fa$var$entryPointParams = {};
const $a1b8ae763ebf57fa$export$f49a4235d24dbad0 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $4RjZC.createProjectCtaEntryPoint), $a1b8ae763ebf57fa$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-business-create-project-cta-entrypoint",
        packageName: "@atlassian/jira-business-create-project-cta",
        teamName: "jira-werewolves",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $a1b8ae763ebf57fa$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("4RjZC", function(module, exports) {

$parcel$export(module.exports, "createProjectCtaEntryPoint", () => $877fbe84ca72e3fe$export$7dadecc7d161da03);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $877fbe84ca72e3fe$export$7dadecc7d161da03 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5EjOz")), {
        moduleId: "0c73c6d1",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5EjOz", function(module, exports) {

let $41d00efad7fdd9ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $41d00efad7fdd9ab$var$load("aDsl8").then(()=>parcelRequire('3u5Rs'));

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $cutA3 = parcelRequire("cutA3");

var $4R6GH = parcelRequire("4R6GH");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $cutA3.useShallowStableReference)(entryPointParams, (0, $4R6GH.fg)('jfp_magma_entrypoint-stability'));
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("cutA3", function(module, exports) {

$parcel$export(module.exports, "useShallowStableReference", () => $43441358a7826a3c$export$cb8a85c49e39f60);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */ 
var $5uXOq = parcelRequire("5uXOq");

var $9pe79 = parcelRequire("9pe79");
const $43441358a7826a3c$var$STABLE_EMPTY_OBJECT = Object.freeze({});
const $43441358a7826a3c$var$STABLE_EMPTY_ARRAY = Object.freeze([]);
const $43441358a7826a3c$export$419c5efa1812e327 = ()=>$43441358a7826a3c$var$STABLE_EMPTY_OBJECT;
const $43441358a7826a3c$export$d81919e21b7bcda0 = ()=>$43441358a7826a3c$var$STABLE_EMPTY_ARRAY;
const $43441358a7826a3c$export$abf22ef229d645f7 = (value)=>Object.keys(value).length === 0 ? $43441358a7826a3c$var$STABLE_EMPTY_OBJECT : value;
const $43441358a7826a3c$export$540f03090e93e8f6 = (value)=>value.length === 0 ? $43441358a7826a3c$var$STABLE_EMPTY_ARRAY : value;
function $43441358a7826a3c$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $5uXOq.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $9pe79.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});

parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jp5kW = parcelRequire("jp5kW");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
        removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        });
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root)) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});



parcelRegister("iZNik", function(module, exports) {

$parcel$export(module.exports, "default", () => $17c51fb57bea1a65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $2xMvF = parcelRequire("2xMvF");

var $dS3PR = parcelRequire("dS3PR");

var $jPxJ7 = parcelRequire("jPxJ7");

var $koVbs = parcelRequire("koVbs");

var $g8I5C = parcelRequire("g8I5C");

var $ajOhG = parcelRequire("ajOhG");

var $Fmgai = parcelRequire("Fmgai");
const $17c51fb57bea1a65$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
const $17c51fb57bea1a65$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openFeedbackModal = (0, $jPxJ7.useFeedbackCollector)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajOhG.FeedbackNudgeAsync), null, children), []);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openFeedbackModal($17c51fb57bea1a65$var$FEEDBACK_GROUP_ID, (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), buttonRef);
    }, [
        openFeedbackModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: buttonRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xMvF))), {
            label: "",
            LEGACY_size: "small"
        }),
        appearance: "subtle-link",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "span",
        size: "UNSAFE_small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $Fmgai.default).feedback))));
};
var $17c51fb57bea1a65$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($17c51fb57bea1a65$var$FeedbackButton);

});
parcelRegister("2xMvF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95953690df38ef00a14db2c04a212acb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1da44ae3ec70ec89$var$_react = $1da44ae3ec70ec89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1da44ae3ec70ec89$var$_feedback = $1da44ae3ec70ec89$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $1da44ae3ec70ec89$var$_feedback2 = $1da44ae3ec70ec89$var$_interopRequireDefault((parcelRequire("2mVws")));
function $1da44ae3ec70ec89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "EditorFeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1da44ae3ec70ec89$var$FeedbackIcon = (props)=>/*#__PURE__*/ $1da44ae3ec70ec89$var$_react.default.createElement($1da44ae3ec70ec89$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $1da44ae3ec70ec89$var$_feedback2.default
    }, props));
$1da44ae3ec70ec89$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $1da44ae3ec70ec89$var$_default = module.exports.default = $1da44ae3ec70ec89$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("2mVws", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b9a41a3ba9d94ab$var$_react = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1b9a41a3ba9d94ab$var$_feedback = $1b9a41a3ba9d94ab$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $1b9a41a3ba9d94ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b9a41a3ba9d94ab$var$EditorFeedbackIcon = (props)=>/*#__PURE__*/ $1b9a41a3ba9d94ab$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M10.922 14.517 5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009zm11.224-4.78a.5.5 0 1 1-.448-.894l2-1a.5.5 0 1 1 .448.894zm-.448 4a.5.5 0 0 1 .448-.894l2 1a.5.5 0 0 1-.448.894zM17 11.5a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1z"/></svg>`
    }, props, {
        newIcon: $1b9a41a3ba9d94ab$var$_feedback.default
    }));
$1b9a41a3ba9d94ab$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
var $1b9a41a3ba9d94ab$var$_default = module.exports.default = $1b9a41a3ba9d94ab$var$EditorFeedbackIcon;

});


parcelRegister("jPxJ7", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $11c0bec8448c2614$export$4be696be8a3bff13);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $5XRYo = parcelRequire("5XRYo");

var $5Dn32 = parcelRequire("5Dn32");
const $11c0bec8448c2614$export$698ff856156a88fe = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).canContactPrompt), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $5XRYo.default).canContactPromptLink))));
});
const $11c0bec8448c2614$export$4f77effad9540593 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).enrollInResearchPrompt, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $5XRYo.default).enrollInResearchLink))
    })));
});
const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $7iULw.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $7iULw.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $5Dn32.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("5XRYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c924dc8de5075ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("5Dn32", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $0dd3b476597799f0$export$f57a7f1d32485807);
const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4ZIaA = parcelRequire("4ZIaA");
var $c8E4X = parcelRequire("c8E4X");
var $eX4XX = parcelRequire("eX4XX");
var $aKz2G = parcelRequire("aKz2G");
var $aj7M6 = parcelRequire("aj7M6");
var $kUAkd = parcelRequire("kUAkd");
var $3WK4F = parcelRequire("3WK4F");
var $4CWca = parcelRequire("4CWca");
var $9xmqY = parcelRequire("9xmqY");
var $31ERv = parcelRequire("31ERv");
var $cIcFn = parcelRequire("cIcFn");
var $j3yGs = parcelRequire("j3yGs");

var $2MLVq = parcelRequire("2MLVq");
var $jjRN8 = parcelRequire("jjRN8");
var $hOWCC = parcelRequire("hOWCC");
var $ZlCus = parcelRequire("ZlCus");
var $1EWMr = parcelRequire("1EWMr");
var $kTus1 = parcelRequire("kTus1");
var $7g4r8 = parcelRequire("7g4r8");

var $3HwlS = parcelRequire("3HwlS");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1EWMr.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WK4F.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjRN8.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZIaA.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g4r8.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ERv.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4XX.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj7M6.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKz2G.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOWCC.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUAkd.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8E4X.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MLVq.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xmqY.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZlCus.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CWca.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cIcFn.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $565cb8192fc4e070$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $565cb8192fc4e070$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $565cb8192fc4e070$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $565cb8192fc4e070$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $565cb8192fc4e070$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $565cb8192fc4e070$export$aeff86a16f13529);

});
parcelRegister("4ZIaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $046aa419aa6d0212$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $046aa419aa6d0212$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$238d30785c4bca84)
});
const $046aa419aa6d0212$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $046aa419aa6d0212$var$Banner = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $046aa419aa6d0212$var$bannerStyles,
                isFixed && $046aa419aa6d0212$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $046aa419aa6d0212$export$2e2bcd8739ae039 = $046aa419aa6d0212$var$Banner;

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;

parcelRegister("8XpIo", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $45f0612699d6a600$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $45f0612699d6a600$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $45f0612699d6a600$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $45f0612699d6a600$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $45f0612699d6a600$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $45f0612699d6a600$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $45f0612699d6a600$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $45f0612699d6a600$export$218ece2c32b7db0e);


var $1Dapo = parcelRequire("1Dapo");
const $45f0612699d6a600$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $45f0612699d6a600$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $45f0612699d6a600$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $45f0612699d6a600$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $45f0612699d6a600$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $565cb8192fc4e070$export$539e68c09584883a)) / (maxWidth - (0, $565cb8192fc4e070$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $45f0612699d6a600$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)]: slotName
    });
const $45f0612699d6a600$export$218ece2c32b7db0e = (slotName)=>`[${0, $565cb8192fc4e070$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("1Dapo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8542dfb7c79e1b98$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $8542dfb7c79e1b98$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $8542dfb7c79e1b98$var$safeLocalStorage = ()=>{
    if ($8542dfb7c79e1b98$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $8542dfb7c79e1b98$export$2e2bcd8739ae039 = $8542dfb7c79e1b98$var$safeLocalStorage;

});


parcelRegister("2Pb5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $69aa5d485af555af$export$2e2bcd8739ae039);

var $8XpIo = parcelRequire("8XpIo");
const $69aa5d485af555af$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $8XpIo.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $8XpIo.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $69aa5d485af555af$export$2e2bcd8739ae039 = $69aa5d485af555af$var$publishGridState;

});

parcelRegister("amcy7", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $9d139aaa63675775$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $9d139aaa63675775$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $9d139aaa63675775$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $9d139aaa63675775$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $9d139aaa63675775$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($9d139aaa63675775$export$4c5cc3b14c7678a);
const $9d139aaa63675775$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $9d139aaa63675775$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("fZqMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1b215f3de827c6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $be1b215f3de827c6$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $be1b215f3de827c6$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $be1b215f3de827c6$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($be1b215f3de827c6$var$sidebarFocusStyles) : css($be1b215f3de827c6$var$focusStyles)
        }));
};
var $be1b215f3de827c6$export$2e2bcd8739ae039 = $be1b215f3de827c6$var$SlotFocusRing;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("jUxG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bb67776ddc8896$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h9kUS = parcelRequire("h9kUS");
/**
 * Hoists slot dimension styles to the root element.
 */ const $16bb67776ddc8896$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $h9kUS.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};
var $16bb67776ddc8896$export$2e2bcd8739ae039 = $16bb67776ddc8896$var$SlotDimensions;

});


parcelRegister("c8E4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a355cc90b3ba1759$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $a355cc90b3ba1759$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a355cc90b3ba1759$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $a355cc90b3ba1759$var$contentStyles
    }, children);
};
var $a355cc90b3ba1759$export$2e2bcd8739ae039 = $a355cc90b3ba1759$var$Content;

});

parcelRegister("eX4XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0feeff252d3697c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $0feeff252d3697c9$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$344062f7cfc9528e)
});
const $0feeff252d3697c9$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0feeff252d3697c9$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $0feeff252d3697c9$var$leftPanelStyles,
                isFixed && $0feeff252d3697c9$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $0feeff252d3697c9$export$2e2bcd8739ae039 = $0feeff252d3697c9$var$LeftPanel;

});

parcelRegister("aKz2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d471261e665f40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $71YXv = parcelRequire("71YXv");


var $oGXFy = parcelRequire("oGXFy");



var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $b8DIB = parcelRequire("b8DIB");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $1hxaZ = parcelRequire("1hxaZ");

var $jUxG6 = parcelRequire("jUxG6");
const $24d471261e665f40$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $24d471261e665f40$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $24d471261e665f40$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $565cb8192fc4e070$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $8XpIo.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $565cb8192fc4e070$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $8XpIo.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $71YXv.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $24d471261e665f40$var$hiddenBackdropStyles,
            isFlyoutOpen && $24d471261e665f40$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $565cb8192fc4e070$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1hxaZ.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b8DIB.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $24d471261e665f40$export$2e2bcd8739ae039 = $24d471261e665f40$var$LeftSidebar;

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("oGXFy", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $76ca3f4294719aa5$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7yA6J = parcelRequire("7yA6J");

var $h9kUS = parcelRequire("h9kUS");
const $76ca3f4294719aa5$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $76ca3f4294719aa5$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $76ca3f4294719aa5$var$queries[queryString];
    (0, $7yA6J.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("j3yGs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $423fcd7a7dc715d5$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $423fcd7a7dc715d5$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $423fcd7a7dc715d5$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $423fcd7a7dc715d5$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $eGmKJ.default),
    collapseLeftSidebar: (0, $eGmKJ.default),
    leftSidebarState: $423fcd7a7dc715d5$var$leftSidebarState,
    setLeftSidebarState: (0, $eGmKJ.default),
    toggleLeftSidebar: (0, $eGmKJ.default)
});
const $423fcd7a7dc715d5$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    return context;
};
const $423fcd7a7dc715d5$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("b8DIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $035100f87b948476$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $gYx5U = parcelRequire("gYx5U");

var $7nOWs = parcelRequire("7nOWs");

var $3bMab = parcelRequire("3bMab");
function $035100f87b948476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $035100f87b948476$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$9ecd22db14e6c70e)]: true
};
const $035100f87b948476$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $035100f87b948476$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $035100f87b948476$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $035100f87b948476$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957] - (0, $8XpIo.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $8XpIo.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $565cb8192fc4e070$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $565cb8192fc4e070$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $565cb8192fc4e070$export$6949d4f32b161684) && sidebarWidth.current < (0, $565cb8192fc4e070$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: (0, $565cb8192fc4e070$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $565cb8192fc4e070$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $565cb8192fc4e070$export$539e68c09584883a)) {
                width = (0, $565cb8192fc4e070$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $565cb8192fc4e070$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $8XpIo.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$035100f87b948476$var$cssSelector,
        css: [
            $035100f87b948476$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $035100f87b948476$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bMab.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gYx5U.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $7nOWs.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $035100f87b948476$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$035100f87b948476$export$2e2bcd8739ae039 = $035100f87b948476$var$ResizeControl;

});
parcelRegister("gYx5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $859a4bb5bdb6af39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");


function $859a4bb5bdb6af39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $859a4bb5bdb6af39$var$varLineColor = '--ds-line';
const $859a4bb5bdb6af39$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$859a4bb5bdb6af39$var$varLineColor]: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
    }
});
const $859a4bb5bdb6af39$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $859a4bb5bdb6af39$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $859a4bb5bdb6af39$var$grabAreaLineSelector = {
    [(0, $565cb8192fc4e070$export$70c702a8c5895f03)]: true
};
const $859a4bb5bdb6af39$var$grabAreaSelector = {
    [(0, $565cb8192fc4e070$export$48a43f91e4becf4e)]: true
};
const $859a4bb5bdb6af39$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$859a4bb5bdb6af39$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $859a4bb5bdb6af39$var$grabAreaStyles,
            isLeftSidebarCollapsed && $859a4bb5bdb6af39$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $859a4bb5bdb6af39$var$lineStyles,
        ...$859a4bb5bdb6af39$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$859a4bb5bdb6af39$export$2e2bcd8739ae039 = $859a4bb5bdb6af39$var$GrabArea;

});

parcelRegister("7nOWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee2fadf0239ec76$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $3uzfU = parcelRequire("3uzfU");


var $lObw7 = parcelRequire("lObw7");

var $h9kUS = parcelRequire("h9kUS");


function $8ee2fadf0239ec76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ee2fadf0239ec76$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $8ee2fadf0239ec76$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $lObw7.durations).small}ms linear,
    color ${(0, $lObw7.durations).small}ms linear,
    opacity ${(0, $lObw7.durations).medium}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $8ee2fadf0239ec76$var$preventDefault = (event)=>event.preventDefault();
const $8ee2fadf0239ec76$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)]: true
};
const $8ee2fadf0239ec76$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$8ee2fadf0239ec76$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $8ee2fadf0239ec76$var$resizeIconButtonStyles,
            $8ee2fadf0239ec76$var$mobileStyles,
            !isLeftSidebarCollapsed && $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $8ee2fadf0239ec76$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $8ee2fadf0239ec76$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8ee2fadf0239ec76$export$2e2bcd8739ae039 = $8ee2fadf0239ec76$var$ResizeButton;

});

parcelRegister("3bMab", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b1337ced2d81f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $dwLzP = parcelRequire("dwLzP");
const $31b1337ced2d81f3$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $31b1337ced2d81f3$var$direction = 'to left';
const $31b1337ced2d81f3$var$transitionDuration = '0.22s';
const $31b1337ced2d81f3$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $31b1337ced2d81f3$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
});
const $31b1337ced2d81f3$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $31b1337ced2d81f3$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $31b1337ced2d81f3$var$shadowStyles,
            isDragging && $31b1337ced2d81f3$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31b1337ced2d81f3$export$2e2bcd8739ae039 = $31b1337ced2d81f3$var$Shadow;

});
parcelRegister("dwLzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6bed85a32a6108$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $fe6bed85a32a6108$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $fe6bed85a32a6108$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($fe6bed85a32a6108$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($fe6bed85a32a6108$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $fe6bed85a32a6108$export$2e2bcd8739ae039 = $fe6bed85a32a6108$var$useIsSidebarDragging;

});



parcelRegister("2QObc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd36b127ab52f290$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");
function $fd36b127ab52f290$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fd36b127ab52f290$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $fd36b127ab52f290$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
const $fd36b127ab52f290$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $565cb8192fc4e070$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $fd36b127ab52f290$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $fd36b127ab52f290$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $fd36b127ab52f290$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $fd36b127ab52f290$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $fd36b127ab52f290$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $fd36b127ab52f290$var$mobileStyles,
            isFlyoutOpen && $fd36b127ab52f290$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $fd36b127ab52f290$var$staticInnerStyles,
            isFixed && $fd36b127ab52f290$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $fd36b127ab52f290$var$fixedInnerFlyoutStyles,
            isDragging && $fd36b127ab52f290$var$draggingStyles,
            $fd36b127ab52f290$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd36b127ab52f290$export$2e2bcd8739ae039 = $fd36b127ab52f290$var$LeftSidebarInner;

});

parcelRegister("aY3ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $579ca93715ca9047$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $fZqMW = parcelRequire("fZqMW");
function $579ca93715ca9047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $579ca93715ca9047$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $579ca93715ca9047$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $579ca93715ca9047$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $579ca93715ca9047$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $579ca93715ca9047$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $579ca93715ca9047$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $579ca93715ca9047$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
const $579ca93715ca9047$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$46acf8758e9e2636)
});
const $579ca93715ca9047$var$selector = (0, $8XpIo.getPageLayoutSlotSelector)('left-sidebar');
const $579ca93715ca9047$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $579ca93715ca9047$var$mobileStyles,
                isFlyoutOpen && $579ca93715ca9047$var$mobileFlyoutStyles,
                // generic styles
                $579ca93715ca9047$var$outerStyles,
                isFixed && $579ca93715ca9047$var$fixedStyles,
                isFlyoutOpen && $579ca93715ca9047$var$flyoutStyles,
                isFlyoutOpen && isFixed && $579ca93715ca9047$var$flyoutFixedStyles,
                isDragging && $579ca93715ca9047$var$draggingStyles,
                $579ca93715ca9047$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$579ca93715ca9047$var$selector
        }, children));
};
const $579ca93715ca9047$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($579ca93715ca9047$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$579ca93715ca9047$export$2e2bcd8739ae039 = $579ca93715ca9047$var$LeftSidebarOuter;

});

parcelRegister("1hxaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2beb7a521c0e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");


var $2qAWW = parcelRequire("2qAWW");
function $b2beb7a521c0e059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b2beb7a521c0e059$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $565cb8192fc4e070$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $b2beb7a521c0e059$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $b2beb7a521c0e059$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $b2beb7a521c0e059$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $2qAWW.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $b2beb7a521c0e059$var$resizableChildrenWrapperStyles,
            isHidden && $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles,
            $b2beb7a521c0e059$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b2beb7a521c0e059$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b2beb7a521c0e059$export$2e2bcd8739ae039 = $b2beb7a521c0e059$var$ResizableChildrenWrapper;

});
parcelRegister("2qAWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $ed1c7c9bc9db6ce1$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)) === 'true';
};
const $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ed1c7c9bc9db6ce1$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($ed1c7c9bc9db6ce1$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039 = $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing;

});



parcelRegister("aj7M6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26851ff0e51eadd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $jUxG6 = parcelRequire("jUxG6");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $c26851ff0e51eadd$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed
    }, children));
};
var $c26851ff0e51eadd$export$2e2bcd8739ae039 = $c26851ff0e51eadd$var$LeftSidebarWithoutResize;

});

parcelRegister("kUAkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8aae2c1ff30f289$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");



var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");
function $e8aae2c1ff30f289$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e8aae2c1ff30f289$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $e8aae2c1ff30f289$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $e8aae2c1ff30f289$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $e8aae2c1ff30f289$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $565cb8192fc4e070$export$b6744d31294864fd)}, ${(0, $565cb8192fc4e070$export$991d5285ad765a3d)}px) + ${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e8aae2c1ff30f289$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $e8aae2c1ff30f289$var$mainStyles,
                isDragging && $e8aae2c1ff30f289$var$draggingStyles,
                isFlyoutOpen && !isFixed && $e8aae2c1ff30f289$var$flyoutStyles,
                $e8aae2c1ff30f289$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('main')
        }, children));
};
var $e8aae2c1ff30f289$export$2e2bcd8739ae039 = $e8aae2c1ff30f289$var$Main;

});

parcelRegister("3WK4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a3c4908a9e1b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $h9kUS = parcelRequire("h9kUS");


var $hhjNo = parcelRequire("hhjNo");
var $ln2Pp = parcelRequire("ln2Pp");

var $crY4K = parcelRequire("crY4K");
const $864a3c4908a9e1b7$var$pageLayoutSelector = {
    [(0, $565cb8192fc4e070$export$659ee746b31b360d)]: true
};
const $864a3c4908a9e1b7$var$gridTemplateAreasMobile = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)}"
 `;
const $864a3c4908a9e1b7$var$gridTemplateAreas = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
 `;
const $864a3c4908a9e1b7$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $565cb8192fc4e070$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} ${(0, $565cb8192fc4e070$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $864a3c4908a9e1b7$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $864a3c4908a9e1b7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $565cb8192fc4e070$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ln2Pp.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $crY4K.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$864a3c4908a9e1b7$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $864a3c4908a9e1b7$var$gridStyles,
            $864a3c4908a9e1b7$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hhjNo.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $864a3c4908a9e1b7$export$2e2bcd8739ae039 = $864a3c4908a9e1b7$var$PageLayout;

});
parcelRegister("hhjNo", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $592e749dad0a6cf7$export$850bd1bba41f1448);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $dWt6p = parcelRequire("dWt6p");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
const $592e749dad0a6cf7$var$handleDataAttributesAndCb = (callback = (0, $eGmKJ.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $592e749dad0a6cf7$var$leftSidebarSelector = (0, $8XpIo.getPageLayoutSlotCSSSelector)('left-sidebar');
const $592e749dad0a6cf7$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3yGs.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("ln2Pp", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $66b4ac88f2caca0d$export$da7be99d6a868f3d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $amcy7 = parcelRequire("amcy7");
const $66b4ac88f2caca0d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $66b4ac88f2caca0d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($66b4ac88f2caca0d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $amcy7.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("crY4K", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $c39a22bbdce5fcea$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $e4yMr = parcelRequire("e4yMr");

var $dWt6p = parcelRequire("dWt6p");



var $amcy7 = parcelRequire("amcy7");
function $c39a22bbdce5fcea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c39a22bbdce5fcea$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $c39a22bbdce5fcea$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 10px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $c39a22bbdce5fcea$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $c39a22bbdce5fcea$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $c39a22bbdce5fcea$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $c39a22bbdce5fcea$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $c39a22bbdce5fcea$var$assignIndex(num + 1, arr);
};
const $c39a22bbdce5fcea$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $amcy7.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $c39a22bbdce5fcea$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $565cb8192fc4e070$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $565cb8192fc4e070$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $c39a22bbdce5fcea$var$skipLinkStyles,
            $c39a22bbdce5fcea$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $c39a22bbdce5fcea$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $c39a22bbdce5fcea$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c39a22bbdce5fcea$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $c39a22bbdce5fcea$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
};
const $c39a22bbdce5fcea$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $c39a22bbdce5fcea$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $c39a22bbdce5fcea$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e4yMr.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $c39a22bbdce5fcea$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("4CWca", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9295d31affd013c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $d9295d31affd013c$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$c7139cc2d6110b5f)
});
const $d9295d31affd013c$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $d9295d31affd013c$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $d9295d31affd013c$var$baseStyles,
                isFixed && $d9295d31affd013c$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $d9295d31affd013c$export$2e2bcd8739ae039 = $d9295d31affd013c$var$RightPanel;

});

parcelRegister("9xmqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07a1808f1030823$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
function $a07a1808f1030823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $a07a1808f1030823$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $565cb8192fc4e070$export$750459958906793)})`
});
const $a07a1808f1030823$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a07a1808f1030823$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a07a1808f1030823$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a07a1808f1030823$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $565cb8192fc4e070$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $a07a1808f1030823$var$outerStyles,
                isFixed && $a07a1808f1030823$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $a07a1808f1030823$var$fixedInnerStyles,
                !isFixed && $a07a1808f1030823$var$staticInnerStyles
            ]
        }, children)));
};
var $a07a1808f1030823$export$2e2bcd8739ae039 = $a07a1808f1030823$var$RightSidebar;

});

parcelRegister("31ERv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf5fc6d75e2417f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $7bf5fc6d75e2417f$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$bec6dca2e63de4ae)
});
const $7bf5fc6d75e2417f$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7bf5fc6d75e2417f$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $7bf5fc6d75e2417f$var$topNavigationStyles,
                isFixed && $7bf5fc6d75e2417f$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $7bf5fc6d75e2417f$export$2e2bcd8739ae039 = $7bf5fc6d75e2417f$var$TopNavigation;

});

parcelRegister("cIcFn", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $a8132564ed4ca271$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $amcy7 = parcelRequire("amcy7");
const $a8132564ed4ca271$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $amcy7.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("2MLVq", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $77d6f7adcd563578$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lp9re = parcelRequire("lp9re");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");
const $77d6f7adcd563578$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $77d6f7adcd563578$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $77d6f7adcd563578$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $77d6f7adcd563578$var$getResizeBounds() {
    return $77d6f7adcd563578$var$asideWidthResizeBounds;
}
const $77d6f7adcd563578$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $77d6f7adcd563578$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixedProp, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $VSDnB.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $lp9re.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$77d6f7adcd563578$var$asideWidthSlotBounds.min}, ${width}px, ${$77d6f7adcd563578$var$asideWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        panelId: (0, $ilnvx.asidePanelSplitterId),
        cssVar: $77d6f7adcd563578$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $77d6f7adcd563578$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $ilnvx.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$77d6f7adcd563578$var$panelSplitterResizingVar}, ${asideVariableWidth})` : asideVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $77d6f7adcd563578$var$getResizeBounds,
                resizingCssVar: $77d6f7adcd563578$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $bwpsq.default)([
                        $77d6f7adcd563578$var$styles.fullHeight,
                        isFixed && $77d6f7adcd563578$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("585q9", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $ac664e290f9d7ee4$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $ac664e290f9d7ee4$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $ac664e290f9d7ee4$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $ac664e290f9d7ee4$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $ac664e290f9d7ee4$var$useSkipLinks = ()=>(0, $5uXOq.useContext)($ac664e290f9d7ee4$export$4c5cc3b14c7678a);
const $ac664e290f9d7ee4$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ac664e290f9d7ee4$var$useSkipLinks();
    (0, $5uXOq.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $ac664e290f9d7ee4$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $ac664e290f9d7ee4$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("ilnvx", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $7e0cfbaebce245b0$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $7e0cfbaebce245b0$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $7e0cfbaebce245b0$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $7e0cfbaebce245b0$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $7e0cfbaebce245b0$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $7e0cfbaebce245b0$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $7e0cfbaebce245b0$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $7e0cfbaebce245b0$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $7e0cfbaebce245b0$export$3452dcb65711af44);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $7e0cfbaebce245b0$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $7e0cfbaebce245b0$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $7e0cfbaebce245b0$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $7e0cfbaebce245b0$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $7e0cfbaebce245b0$export$951bf5156e86d974 = '--n_sNvw';
const $7e0cfbaebce245b0$export$594e6a30db7c057e = '--n_asDw';
const $7e0cfbaebce245b0$export$db0c2e1d744fb281 = '--n_pnlW';
const $7e0cfbaebce245b0$export$515a0b1baafe906c = '--n_bnrM';
const $7e0cfbaebce245b0$export$60ef3a7b1ed42328 = '--n_tNvM';
const $7e0cfbaebce245b0$export$1216dacffd1e9e65 = '--n_sNvlw';
const $7e0cfbaebce245b0$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $7e0cfbaebce245b0$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $7e0cfbaebce245b0$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $7e0cfbaebce245b0$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $7e0cfbaebce245b0$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $7e0cfbaebce245b0$export$855f5a09f5c99ac = '--topNavigationHeight';
const $7e0cfbaebce245b0$export$26354f9814213292 = '--bannerHeight';
const $7e0cfbaebce245b0$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $7e0cfbaebce245b0$export$753bf7651b25db91 = '--rightPanelWidth';
const $7e0cfbaebce245b0$export$6460bd6a2446260 = `calc(var(${$7e0cfbaebce245b0$export$26354f9814213292}, 0px) + var(${$7e0cfbaebce245b0$export$855f5a09f5c99ac}, 0px))`;
const $7e0cfbaebce245b0$export$3055529fab2b4edf = `var(${$7e0cfbaebce245b0$export$6bfc931a04ec5741}, 0px)`;
const $7e0cfbaebce245b0$export$166d8fd766c3eb92 = `calc(var(${$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b}, 0px) + var(${$7e0cfbaebce245b0$export$753bf7651b25db91}, 0px))`;
const $7e0cfbaebce245b0$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("8oF23", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $1ee0f763875d3fec$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $1ee0f763875d3fec$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("2WR37", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $cbb560d7ba4917d9$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $cbb560d7ba4917d9$export$9f45a1325e3cdfb8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1EWMr = parcelRequire("1EWMr");
const $cbb560d7ba4917d9$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: `#${(0, $1EWMr.gridRootId)} { ${variableName}: ${value}px }`
    });
const $cbb560d7ba4917d9$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $cbb560d7ba4917d9$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("1EWMr", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $f4db93acd3b1ab5b$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dlnxJ = parcelRequire("dlnxJ");

var $iuUiD = parcelRequire("iuUiD");

var $ivVtd = parcelRequire("ivVtd");

var $3Z6qh = parcelRequire("3Z6qh");

var $8oF23 = parcelRequire("8oF23");

var $5rLY7 = parcelRequire("5rLY7");

var $jDR0c = parcelRequire("jDR0c");

var $UTmRP = parcelRequire("UTmRP");
const $f4db93acd3b1ab5b$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $f4db93acd3b1ab5b$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $UTmRP.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDR0c.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rLY7.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z6qh.TopNavStartProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dlnxJ.OpenLayerObserver), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oF23.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ivVtd.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iuUiD.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                        ref: ref,
                                        className: (0, $bwpsq.default)([
                                            $f4db93acd3b1ab5b$var$styles.root,
                                            xcss
                                        ]),
                                        id: $f4db93acd3b1ab5b$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("dlnxJ", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $db6ff2d140327fd6$export$97afddda23bcd287);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $kEhTY = parcelRequire("kEhTY");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $db6ff2d140327fd6$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $db6ff2d140327fd6$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $db6ff2d140327fd6$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $db6ff2d140327fd6$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($db6ff2d140327fd6$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $db6ff2d140327fd6$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$db6ff2d140327fd6$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $3joPi.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kEhTY.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("iuUiD", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $4SKIy = parcelRequire("4SKIy");

var $hgvjm = parcelRequire("hgvjm");
const $8a6fecf6d9ada26f$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $8a6fecf6d9ada26f$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex = /^\s*$/;
const $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $4SKIy.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        onKeyDown: $8a6fecf6d9ada26f$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $bwpsq.default)([
            $8a6fecf6d9ada26f$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
                className: (0, $bwpsq.default)([
                    $8a6fecf6d9ada26f$var$styles.skipLinkList
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hgvjm.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("4SKIy", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $a6322a25f6b08ecb$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $a6322a25f6b08ecb$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $a6322a25f6b08ecb$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $a6322a25f6b08ecb$var$assignIndex(num + 1, arr);
};
const $a6322a25f6b08ecb$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $a6322a25f6b08ecb$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $a6322a25f6b08ecb$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $a6322a25f6b08ecb$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("hgvjm", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $ca929d4ef6b95820$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jhmo0 = parcelRequire("jhmo0");
const $ca929d4ef6b95820$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $ca929d4ef6b95820$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $cBeZP.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $ca929d4ef6b95820$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $ca929d4ef6b95820$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            $ca929d4ef6b95820$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});


parcelRegister("ivVtd", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $04aeed0b84d4da87$export$fe514f9f7b03d46f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $585q9 = parcelRequire("585q9");

var $4SKIy = parcelRequire("4SKIy");
const $04aeed0b84d4da87$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $04aeed0b84d4da87$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($04aeed0b84d4da87$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $585q9.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4SKIy.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("3Z6qh", function(module, exports) {

$parcel$export(module.exports, "TopNavStartProvider", () => $ac9d25344fa2e979$export$bc9d0ad0bce43e75);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7NFvZ = parcelRequire("7NFvZ");
const $ac9d25344fa2e979$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NFvZ.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NFvZ.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("5rLY7", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $60c376fb0d7017f3$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $60c376fb0d7017f3$export$fa4d0cff03b1ea4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $60c376fb0d7017f3$var$SideNavRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    current: null
});
function $60c376fb0d7017f3$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($60c376fb0d7017f3$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $60c376fb0d7017f3$export$fa4d0cff03b1ea4f() {
    return (0, $5uXOq.useContext)($60c376fb0d7017f3$var$SideNavRefContext);
}

});

parcelRegister("jDR0c", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $e430d141e8d30234$export$ceb8e60e9790fc0f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZOeM = parcelRequire("eZOeM");
const $e430d141e8d30234$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("UTmRP", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $2510be1036df6cd8$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b0CFU = parcelRequire("b0CFU");
const $2510be1036df6cd8$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("8mXqE", function(module, exports) {

$parcel$export(module.exports, "useSkipLinkId", () => $57190c324e1ec006$export$fa3cfac0c8e29c5c);
$parcel$export(module.exports, "useLayoutId", () => $57190c324e1ec006$export$110c3550c7c1c9aa);

var $9KnKW = parcelRequire("9KnKW");
function $57190c324e1ec006$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $9KnKW.useId)();
    return uniqueId;
}
function $57190c324e1ec006$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $57190c324e1ec006$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("fVO1C", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $0739b5288fba2b3a$export$f662bfb764348932);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9NI3h = parcelRequire("9NI3h");
const $0739b5288fba2b3a$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9NI3h.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("9NI3h", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $ec571489384d3ca6$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $ec571489384d3ca6$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("2HiMp", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $ef753172dcf77156$export$d4931ecf0fbcc8fc);

var $5uXOq = parcelRequire("5uXOq");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $3AWiS = parcelRequire("3AWiS");
function $ef753172dcf77156$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $3AWiS.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("3AWiS", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $f535d623adcb2c41$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $f535d623adcb2c41$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $98OXW = parcelRequire("98OXW");

var $e4cTf = parcelRequire("e4cTf");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("4dYas");
var $kLEEo = parcelRequire("kLEEo");
parcelRequire("hjhoK");
var $akFFC = parcelRequire("akFFC");
parcelRequire("fmZmH");
var $3C4FG = parcelRequire("3C4FG");

var $jldZL = parcelRequire("jldZL");

var $9NI3h = parcelRequire("9NI3h");

var $gRo7J = parcelRequire("gRo7J");

var $lVIfq = parcelRequire("lVIfq");

var $fAx1P = parcelRequire("fAx1P");

var $ay5e1 = parcelRequire("ay5e1");

var $1ICwz = parcelRequire("1ICwz");
const $f535d623adcb2c41$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $f535d623adcb2c41$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $f535d623adcb2c41$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $f535d623adcb2c41$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $f535d623adcb2c41$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$f535d623adcb2c41$var$panelSplitterDragDataSymbol]: true
    };
}
function $f535d623adcb2c41$export$e239b3966b677000(data) {
    return data[$f535d623adcb2c41$var$panelSplitterDragDataSymbol] === true;
}
const $f535d623adcb2c41$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $9NI3h.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $1ICwz.useTextDirection)(portalRef.current);
    const labelId = (0, $9KnKW.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $5uXOq.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $4hDdm.combine)((0, $kLEEo.blockDraggingToIFrames)({
            element: splitter
        }), (0, $7gWdR.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $akFFC.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $3C4FG.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                const initialWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $f535d623adcb2c41$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds()
                });
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds } = source.data;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $fAx1P.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panelRef.current?.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                (0, $3C4FG.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const finalWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        direction,
        position,
        isEnabled,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $98OXW.default)(onResizeStart);
    const onResizeEndStableRef = (0, $98OXW.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $ay5e1.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $5uXOq.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $5uXOq.useRef)(null);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $5uXOq.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $lVIfq.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $f535d623adcb2c41$var$containerStyles.root,
            position === 'start' && $f535d623adcb2c41$var$containerStyles.positionStart,
            position === 'end' && $f535d623adcb2c41$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $f535d623adcb2c41$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $f535d623adcb2c41$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $f535d623adcb2c41$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: hasMounted ? children : null
    });
};
const $f535d623adcb2c41$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("e4cTf", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $ea3ab92c791f0d5d$export$750f5b0d6c51617e);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $kEhTY = parcelRequire("kEhTY");
function $ea3ab92c791f0d5d$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}

});

parcelRegister("4dYas", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("kLEEo")).blockDraggingToIFrames);

var $kLEEo = parcelRequire("kLEEo");

});
parcelRegister("kLEEo", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $85c97841a27447ca$export$6ae1d8fab001518c);

var $40DDD = parcelRequire("40DDD");

var $3zl3q = parcelRequire("3zl3q");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $85c97841a27447ca$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $85c97841a27447ca$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $85c97841a27447ca$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($85c97841a27447ca$var$isActive) return;
    $85c97841a27447ca$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$85c97841a27447ca$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $3zl3q.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $40DDD.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $85c97841a27447ca$var$isActive = false;
    });
}
function $85c97841a27447ca$export$6ae1d8fab001518c({ element: element }) {
    return (0, $40DDD.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $85c97841a27447ca$var$tryStart();
        }
    });
}

});


parcelRegister("hjhoK", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("akFFC")).disableNativeDragPreview);

var $akFFC = parcelRequire("akFFC");

});
parcelRegister("akFFC", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $1774d76ee1100c7d$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $1774d76ee1100c7d$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $1774d76ee1100c7d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $1774d76ee1100c7d$var$tinyTransparentImage) nativeSetDragImage($1774d76ee1100c7d$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("fmZmH", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("3C4FG")).preventUnhandled);

var $3C4FG = parcelRequire("3C4FG");

});
parcelRegister("3C4FG", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $bc1937186f99453b$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $h5V4I = parcelRequire("h5V4I");
function $bc1937186f99453b$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $bc1937186f99453b$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $bc1937186f99453b$var$start() {
    $bc1937186f99453b$var$cleanup();
    $bc1937186f99453b$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $bc1937186f99453b$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $bc1937186f99453b$var$cleanup
        },
        ...(0, $h5V4I.getBindingsForBrokenDrags)({
            onDragEnd: $bc1937186f99453b$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $bc1937186f99453b$var$cleanup() {
    $bc1937186f99453b$var$unbindEvents?.();
    $bc1937186f99453b$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $bc1937186f99453b$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $bc1937186f99453b$var$cleanup();
}
const $bc1937186f99453b$export$453c0582481cc59d = {
    start: $bc1937186f99453b$var$start,
    stop: $bc1937186f99453b$var$stop
};

});


parcelRegister("gRo7J", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $4ac469c14ce45896$export$3d412b3011b66f82);
function $4ac469c14ce45896$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("lVIfq", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $eb54cea8a4880815$export$b5423678cdf09f5);
function $eb54cea8a4880815$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("fAx1P", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $e9a4e6873a340be1$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $e9a4e6873a340be1$export$d942790ad00c41f9);
const $e9a4e6873a340be1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $e9a4e6873a340be1$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("ay5e1", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $c3821cbf3d3af233$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs = 500;
function $c3821cbf3d3af233$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("1ICwz", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $19142174bc5bbe23$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $19142174bc5bbe23$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});




parcelRegister("jjRN8", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $365358079a8d32db$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $365358079a8d32db$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $365358079a8d32db$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = (0, $VSDnB.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $365358079a8d32db$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                variableName: (0, $ilnvx.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}

});

parcelRegister("hOWCC", function(module, exports) {

$parcel$export(module.exports, "Main", () => $325f1d6156df91d8$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $8mXqE = parcelRequire("8mXqE");

var $2GcIE = parcelRequire("2GcIE");
const $325f1d6156df91d8$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8"
};
function $325f1d6156df91d8$export$861edd1ccea2f746({ children: children, isFixed: isFixedProp, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $VSDnB.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $325f1d6156df91d8$var$mainElementStyles.root,
                isFixed && $325f1d6156df91d8$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2GcIE.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("2GcIE", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $7ccaf10616775f74$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $7ccaf10616775f74$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("ZlCus", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $05534568732462ab$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $5rLY7 = parcelRequire("5rLY7");

var $2HiMp = parcelRequire("2HiMp");
const $05534568732462ab$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $05534568732462ab$var$oldPanelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $05534568732462ab$var$oldPanelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $05534568732462ab$var$getOldResizeBounds() {
    return $05534568732462ab$var$oldPanelWidthResizeBounds;
}
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $05534568732462ab$var$fallbackResizeMinWidth = 400;
const $05534568732462ab$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs1cd0 _1w6ezgxb _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw",
    oldMobileWidth: "_1bsb1adv",
    newMobileWidth: "_1bsb1dxx"
};
function $05534568732462ab$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $VSDnB.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $5rLY7.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $05534568732462ab$var$fallbackResizeMinWidth);
    const getNewResizeBounds = (0, $5uXOq.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${0, $ilnvx.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    } : $05534568732462ab$var$oldPanelWidthSlotBounds;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        cssVar: $05534568732462ab$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $05534568732462ab$var$styles.root,
            defaultWidth === 0 && $05534568732462ab$var$styles.hidden,
            hasBorder && $05534568732462ab$var$styles.border,
            (0, $VSDnB.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? $05534568732462ab$var$styles.newMobileWidth : $05534568732462ab$var$styles.oldMobileWidth,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $ilnvx.panelVar)]: panelVariableWidth,
            '--minWidth': (0, $VSDnB.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? `${minWidth}px` : undefined
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.lg,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$05534568732462ab$var$panelSplitterResizingVar}, ${panelVariableWidth})` : panelVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? getNewResizeBounds : $05534568732462ab$var$getOldResizeBounds,
                resizingCssVar: $05534568732462ab$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $05534568732462ab$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("kTus1", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $be4966f89908f895$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $5JjdN = parcelRequire("5JjdN");

var $lJmpK = parcelRequire("lJmpK");
var $e4cTf = parcelRequire("e4cTf");

var $VSDnB = parcelRequire("VSDnB");

var $7gWdR = parcelRequire("7gWdR");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $7NFvZ = parcelRequire("7NFvZ");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");

var $5rLY7 = parcelRequire("5rLY7");


var $eZOeM = parcelRequire("eZOeM");

var $fD6iO = parcelRequire("fD6iO");

var $ecbZX = parcelRequire("ecbZX");

var $27t8Q = parcelRequire("27t8Q");

var $6qnkT = parcelRequire("6qnkT");

var $b0CFU = parcelRequire("b0CFU");
const $be4966f89908f895$var$panelSplitterResizingVar = '--n_snvRsz';
const $be4966f89908f895$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $be4966f89908f895$var$getResizeBounds() {
    return $be4966f89908f895$var$widthResizeBounds;
}
const $be4966f89908f895$var$openLayerObserverSideNavNamespace = 'side-nav';
const $be4966f89908f895$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $be4966f89908f895$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $5uXOq.useCallback)(()=>{
        (0, $7nsd3.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SideNavVisibilityState));
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $ecbZX.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $5uXOq.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$be4966f89908f895$var$widthResizeBounds.min}, ${width}px, ${$be4966f89908f895$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $5rLY7.useSideNavRef)();
    const mergedRef = (0, $5JjdN.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $eZOeM.SideNavToggleButtonElement));
    const topNavStartElement = (0, $5uXOq.useContext)((0, $7NFvZ.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $5uXOq.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $94307ebc0fda0ded$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $6qnkT.useToggleSideNav)();
    (0, $5uXOq.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $27t8Q.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $5uXOq.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $cBeZP.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support'),
        cssVar: $be4966f89908f895$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $ilnvx.sideNavVar)]: clampedWidth
        },
        ref: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? mergedRef : navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $be4966f89908f895$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') ? $be4966f89908f895$var$styles.newBorder : $be4966f89908f895$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $be4966f89908f895$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') && $be4966f89908f895$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $be4966f89908f895$var$styles.flyoutAnimateClosed
        ]),
        children: [
            (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') && // This CSS var is used by the `Panel` slot to enforce its maximum width constraint.
            // When we remove the UNSAFE legacy usage, we can change this to `HoistCssVarToLocalGrid`
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$be4966f89908f895$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && ((0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $ilnvx.sideNavLiveWidthVar)})`
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            })),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $be4966f89908f895$var$getResizeBounds,
                resizingCssVar: $be4966f89908f895$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $be4966f89908f895$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $be4966f89908f895$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJmpK.OpenLayerObserverNamespaceProvider), {
        namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($be4966f89908f895$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id,
            children: children
        })
    });
}

});
parcelRegister("lJmpK", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $68ced8fafd297685$export$327d0d2a7ae6f7cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $6uI1O = parcelRequire("6uI1O");

var $7e96v = parcelRequire("7e96v");
function $68ced8fafd297685$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $7e96v.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $3joPi.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6uI1O.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $94307ebc0fda0ded$export$a7801e29f563faad = 400;

parcelRegister("fD6iO", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $d44c9e93ca4d5bd6$export$e44b4744d8ff971a);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $b0CFU = parcelRequire("b0CFU");
function $d44c9e93ca4d5bd6$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const expandSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("27t8Q", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $cb86acb1b056338b$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $lp9re = parcelRequire("lp9re");
function $cb86acb1b056338b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $lp9re.default)(isExpandedOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $lp9re.default)(isExpandedOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("7g4r8", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $c8c2cc49c7ec13a9$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $lLCVr = parcelRequire("lLCVr");

var $9SFxq = parcelRequire("9SFxq");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $c8c2cc49c7ec13a9$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $c8c2cc49c7ec13a9$export$41d0d88a6b0e456f({ children: children, xcss: xcss, height: height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $9SFxq.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLCVr.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $c8c2cc49c7ec13a9$var$styles.root,
                (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_columns') ? $c8c2cc49c7ec13a9$var$styles.newLayoutStyles : $c8c2cc49c7ec13a9$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                    variableName: (0, $ilnvx.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $ilnvx.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("9SFxq", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $a4aaf4b86ce4bd3e$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $4ho76 = parcelRequire("4ho76");
function $a4aaf4b86ce4bd3e$export$c0c5f5b297b77726(theme) {
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $4ho76.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("4ho76", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $20b90a70389cbaea$export$3986d75fe2da3239);

var $aXYYm = parcelRequire("aXYYm");

var $8l1C4 = parcelRequire("8l1C4");

var $89F5e = parcelRequire("89F5e");

var $essik = parcelRequire("essik");

var $i38OJ = parcelRequire("i38OJ");

var $es68b = parcelRequire("es68b");
function $20b90a70389cbaea$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $20b90a70389cbaea$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $20b90a70389cbaea$var$buttonStyles = {
    light: {
        [(0, $8l1C4.themedButtonBackground)]: 'transparent',
        [(0, $8l1C4.themedButtonBackgroundHovered)]: (0, $i38OJ.palette).Neutral200A,
        [(0, $8l1C4.themedButtonBackgroundPressed)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonBorder)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonSelectedBackground)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonSelectedBackgroundHovered)]: (0, $i38OJ.palette).Neutral400A,
        [(0, $8l1C4.themedButtonSelectedBackgroundPressed)]: (0, $i38OJ.palette).Neutral500A,
        [(0, $8l1C4.themedButtonDisabledText)]: (0, $i38OJ.palette).Neutral400A,
        [(0, $8l1C4.themedButtonDisabledBackground)]: (0, $i38OJ.palette).Neutral100A
    },
    dark: {
        [(0, $8l1C4.themedButtonBackground)]: 'transparent',
        [(0, $8l1C4.themedButtonBackgroundHovered)]: (0, $i38OJ.palette).DarkNeutral200A,
        [(0, $8l1C4.themedButtonBackgroundPressed)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonBorder)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonSelectedBackground)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonSelectedBackgroundHovered)]: (0, $i38OJ.palette).DarkNeutral400A,
        [(0, $8l1C4.themedButtonSelectedBackgroundPressed)]: (0, $i38OJ.palette).DarkNeutral500A,
        [(0, $8l1C4.themedButtonDisabledText)]: (0, $i38OJ.palette).DarkNeutral400A,
        [(0, $8l1C4.themedButtonDisabledBackground)]: (0, $i38OJ.palette).DarkNeutral100A
    }
};
const $20b90a70389cbaea$var$logoStyles = {
    light: {
        [(0, $aXYYm.themedLogoIcon)]: (0, $i38OJ.palette).DarkNeutral0,
        [(0, $aXYYm.themedLogoText)]: (0, $i38OJ.palette).DarkNeutral0
    },
    dark: {
        [(0, $aXYYm.themedLogoIcon)]: (0, $i38OJ.palette).Neutral0,
        [(0, $aXYYm.themedLogoText)]: (0, $i38OJ.palette).Neutral0
    }
};
function $20b90a70389cbaea$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $essik.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $essik.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $89F5e.getTextColor)(backgroundRgb);
    const colorMode = (0, $89F5e.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $89F5e.getTextColor)(highlightRgb);
    return {
        backgroundColor: $20b90a70389cbaea$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$20b90a70389cbaea$var$buttonStyles[colorMode],
        ...$20b90a70389cbaea$var$logoStyles[colorMode],
        ...$20b90a70389cbaea$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $es68b.themedSearchBorder)]: $20b90a70389cbaea$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $es68b.themedSearchBorderFocused)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $8l1C4.themedButtonPrimaryBackground)]: $20b90a70389cbaea$var$toRGBString(highlightRgb),
        [(0, $8l1C4.themedButtonPrimaryBackgroundHovered)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $8l1C4.themedButtonPrimaryBackgroundPressed)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $8l1C4.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $20b90a70389cbaea$var$selectedBackgroundRGBA = {
    light: (0, $i38OJ.paletteRgba).Neutral300A,
    dark: (0, $i38OJ.paletteRgba).DarkNeutral300A
};
function $20b90a70389cbaea$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $20b90a70389cbaea$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $89F5e.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $8l1C4.themedButtonSelectedText)]: (0, $89F5e.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $8l1C4.themedButtonSelectedBorder)]: (0, $89F5e.isLight)(blendedBackground) ? (0, $i38OJ.palette).Neutral1100 : (0, $i38OJ.palette).DarkNeutral1100
    };
}

});
parcelRegister("89F5e", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $4fbdcc97a7190551$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $4fbdcc97a7190551$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $4fbdcc97a7190551$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $4fbdcc97a7190551$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $4fbdcc97a7190551$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $4fbdcc97a7190551$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.r),
        g: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.g),
        b: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $4fbdcc97a7190551$var$flipLuminance = 0.179129;
function $4fbdcc97a7190551$export$44af652f4cca9039(color) {
    return $4fbdcc97a7190551$var$relativeLuminanceW3C(color) >= $4fbdcc97a7190551$var$flipLuminance;
}
function $4fbdcc97a7190551$export$5573a5bab3e074b5(backgroundColor) {
    if ($4fbdcc97a7190551$var$relativeLuminanceW3C(backgroundColor) >= $4fbdcc97a7190551$var$flipLuminance) return 'light';
    return 'dark';
}
const $4fbdcc97a7190551$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $4fbdcc97a7190551$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $4fbdcc97a7190551$export$5573a5bab3e074b5(backgroundColor);
    return $4fbdcc97a7190551$var$textColor[colorMode];
}
function $4fbdcc97a7190551$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("essik", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $352c93155f572157$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $352c93155f572157$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $352c93155f572157$export$103711ef09c6edec(color) {
    if (!$352c93155f572157$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("i38OJ", function(module, exports) {

$parcel$export(module.exports, "palette", () => $3c1e0f0bc82f150b$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $3c1e0f0bc82f150b$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $3c1e0f0bc82f150b$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $3c1e0f0bc82f150b$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});





parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});





parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $j9VTE = parcelRequire("j9VTE");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $j9VTE.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("ajOhG", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $9b3ebbbcc2dff472$export$be3f2958452e7be9);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5S5zV")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
$9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $bCf8q = parcelRequire("bCf8q");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("5S5zV", function(module, exports) {

let $446652ad373994b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $446652ad373994b6$var$load("hZ95g").then(()=>parcelRequire('5YJ1A'));

});


parcelRegister("Fmgai", function(module, exports) {

$parcel$export(module.exports, "default", () => $c642b7880215349a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c642b7880215349a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedback: {
        "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("NCdt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b005747d8914d3b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b005747d8914d3b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    companyManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
        "defaultMessage": "You're in a company-managed project"
    },
    navigationLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
        "defaultMessage": "Side"
    },
    teamManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
        "defaultMessage": "You're in a team-managed project"
    },
    viewAllStarred: {
        "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
        "defaultMessage": "View all starred projects"
    }
});

});

parcelRegister("dCGEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $230ddc65e16732f3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $fVnbM = parcelRequire("fVnbM");

var $i8Qvm = parcelRequire("i8Qvm");

var $i5shE = parcelRequire("i5shE");

var $7yUJn = parcelRequire("7yUJn");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $doZTA = parcelRequire("doZTA");

var $gb5lQ = parcelRequire("gb5lQ");

var $iuAuR = parcelRequire("iuAuR");

var $6hYaZ = parcelRequire("6hYaZ");

var $2kAEg = parcelRequire("2kAEg");

var $imgTm = parcelRequire("imgTm");
const $230ddc65e16732f3$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
    (0, $gKZoD.di)(window);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const refresh = (0, $5uXOq.useCallback)(()=>typeof window !== 'undefined' && window.location.reload(), []);
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const routeOverviewId = match.params?.overviewId;
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $5uXOq.useState)(false);
    const openCreateModal = (0, $5uXOq.useCallback)(()=>{
        setIsCreateModalOpen(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
    }, [
        createAnalyticsEvent
    ]);
    const closeCreateModal = (0, $5uXOq.useCallback)(()=>setIsCreateModalOpen(false), []);
    let content;
    if (hasError) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorWrapper, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorMessage, null, formatMessage((0, $2kAEg.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: refresh
    }, formatMessage((0, $2kAEg.default).refreshPage)));
    else if (overviews.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$EmptyState, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: openCreateModal
    }, formatMessage((0, $2kAEg.default).createOverview)));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$List, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
    }, overviews.map((overview)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: overview.id
        }, routeOverviewId === overview.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imgTm.default), {
            overview: overview,
            to: (0, $i5shE.getOverviewUrl)(overview),
            isActive: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imgTm.default), {
            overview: overview,
            to: (0, $i5shE.getOverviewUrl)(overview, route?.name)
        }))));
    const hasReachedLimit = overviews?.length >= (0, $gb5lQ.OVERVIEW_MAX_LIMIT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuAuR.default), {
        title: formatMessage((0, $2kAEg.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6hYaZ.default), {
        onClick: openCreateModal,
        hasReachedLimit: hasReachedLimit
    })), content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isCreateModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yUJn.default), {
        onClose: closeCreateModal
    })));
};
var $230ddc65e16732f3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($230ddc65e16732f3$var$Overviews);
const $230ddc65e16732f3$var$EmptyState = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $230ddc65e16732f3$var$List = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            __cmplp.className
        ])
    });
});
const $230ddc65e16732f3$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $230ddc65e16732f3$var$ErrorMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxu2gc _otyridpf _18u0u2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i5shE", function(module, exports) {

$parcel$export(module.exports, "getOverviewUrl", () => $b5027b2ddff99a4d$export$e314405e3f098e61);
const $b5027b2ddff99a4d$export$e314405e3f098e61 = (overview, routeName)=>{
    switch(routeName){
        case 'classic-business-overview-summary':
        case 'classic-business-summary':
            return `/jira/core/overviews/${overview.id}/summary`;
        case 'classic-business-overview-calendar':
        case 'classic-business-calendar':
            return `/jira/core/overviews/${overview.id}/calendar`;
        case 'classic-business-overview-timeline':
        case 'classic-business-timeline':
            return `/jira/core/overviews/${overview.id}/timeline`;
        default:
            return `/jira/core/overviews/${overview.id}`;
    }
};

});

parcelRegister("7yUJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb121a7f5478dbf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cm8b5 = parcelRequire("cm8b5");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $bTIks = parcelRequire("bTIks");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2eb121a7f5478dbf$var$LazyCreateOverviewModal = (0, $kxZPA.lazy)(()=>(parcelRequire("ePB6h")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2eb121a7f5478dbf$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $bTIks.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2eb121a7f5478dbf$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("cm8b5", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $aca94fc714dddc77$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $aca94fc714dddc77$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $aca94fc714dddc77$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $aca94fc714dddc77$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $aca94fc714dddc77$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $aca94fc714dddc77$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $aca94fc714dddc77$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $aca94fc714dddc77$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $aca94fc714dddc77$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $aca94fc714dddc77$export$c9b6bcd70239a39c);

var $5uXOq = parcelRequire("5uXOq");

var $8Wswo = parcelRequire("8Wswo");

var $j8DrX = parcelRequire("j8DrX");

var $8UpTw = parcelRequire("8UpTw");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $aca94fc714dddc77$var$shard = (0, $j8DrX.default)('ajs-shard');
const $aca94fc714dddc77$var$region = (0, $j8DrX.default)('ajs-region');
const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {
            shard: $aca94fc714dddc77$var$shard,
            region: $aca94fc714dddc77$var$region
        }
    });
const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {
            shard: $aca94fc714dddc77$var$shard,
            region: $aca94fc714dddc77$var$region
        }
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
    const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, $8Wswo.getGraphqlErrorAttributes)(error));
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $aca94fc714dddc77$export$f20b867e738a222c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience })=>{
    const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $aca94fc714dddc77$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $8UpTw.ErrorPage), children: children })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $aca94fc714dddc77$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $aca94fc714dddc77$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
    const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
    (0, $5uXOq.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("8Wswo", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $6f94bc39289ec711$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $6f94bc39289ec711$export$b19e649eafc62480);

var $e3a3O = parcelRequire("e3a3O");
const $6f94bc39289ec711$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE',
    'ISSUE_UNAVAILABLE'
];
const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $e3a3O.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("12QNw", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $0c2eeee3dc68c900$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $0c2eeee3dc68c900$export$bf638b60ea8b89b7);

var $yEDl8 = parcelRequire("yEDl8");

var $98oUl = parcelRequire("98oUl");
var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $98oUl.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $yEDl8.default)(node), "."));
            var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $98oUl.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("yEDl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0682b20f61c706c4$export$2e2bcd8739ae039);

var $7NbHY = parcelRequire("7NbHY");
function $0682b20f61c706c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0682b20f61c706c4$var$_typeof(obj);
}
var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
    return $0682b20f61c706c4$var$formatValue(value, []);
}
function $0682b20f61c706c4$var$formatValue(value, seenValues) {
    switch($0682b20f61c706c4$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
    return $0682b20f61c706c4$var$formatObject(value, seenValues);
}
function $0682b20f61c706c4$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0682b20f61c706c4$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0682b20f61c706c4$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7NbHY.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0682b20f61c706c4$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("7NbHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac63109fd04dae2$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;

});


parcelRegister("98oUl", function(module, exports) {

$parcel$export(module.exports, "Location", () => $6a682e985d2af3c5$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $6a682e985d2af3c5$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $6a682e985d2af3c5$export$8ee0fc9ee280b4ee);

var $520Pd = parcelRequire("520Pd");
var $6a682e985d2af3c5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$18a2be9195644f38);
var $6a682e985d2af3c5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$50792b0e93539fde);
function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("520Pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9dc77a0e8a6949$export$2e2bcd8739ae039);

var $fM9AB = parcelRequire("fM9AB");

var $7NbHY = parcelRequire("7NbHY");
function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fM9AB.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7NbHY.default) classObject.prototype[0, $7NbHY.default] = fn;
}

});
parcelRegister("fM9AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c2c6f03066157d$export$2e2bcd8739ae039);
function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});

parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("8UpTw", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $beRD7 = parcelRequire("beRD7");
const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a72c35b5a5b98e9$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("bTIks", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $43e56627abfe9003$export$3d931b64f46140b3);

var $gwIPs = parcelRequire("gwIPs");
const $43e56627abfe9003$var$PACKAGE_NAME = 'jiraBusinessEntityOverview';
const $43e56627abfe9003$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$d03d4e78ea5b909a = (0, $gwIPs.gridSize) * 2;
const $43e56627abfe9003$export$57ee5df6bad94642 = 400;
const $43e56627abfe9003$export$7c9c92ba6b198ac4 = (0, $gwIPs.gridSize) * 3;
const $43e56627abfe9003$export$c4232794452dc6e3 = 480;
const $43e56627abfe9003$export$3d931b64f46140b3 = $43e56627abfe9003$export$c4232794452dc6e3 + $43e56627abfe9003$export$57ee5df6bad94642 + $43e56627abfe9003$export$7c9c92ba6b198ac4 * 2 + $43e56627abfe9003$export$d03d4e78ea5b909a * 2;
const $43e56627abfe9003$var$MODAL_DIALOG_MARGIN = 120;
const $43e56627abfe9003$export$68bc124b0fa13de0 = $43e56627abfe9003$export$3d931b64f46140b3 + $43e56627abfe9003$var$MODAL_DIALOG_MARGIN;

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $k5uoT = parcelRequire("k5uoT");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $k5uoT.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $k5uoT.layers).navigation(),
    card: (0, $k5uoT.layers).card(),
    dialog: (0, $k5uoT.layers).dialog(),
    navigation: (0, $k5uoT.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $k5uoT.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $k5uoT.layers).navigation() - 1,
    layer: (0, $k5uoT.layers).layer(),
    blanket: (0, $k5uoT.layers).blanket(),
    modal: (0, $k5uoT.layers).modal(),
    flag: (0, $k5uoT.layers).flag(),
    spotlight: (0, $k5uoT.layers).spotlight(),
    tooltip: (0, $k5uoT.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});


parcelRegister("ePB6h", function(module, exports) {

let $acc29b706d6ed2cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $acc29b706d6ed2cd$var$load("ffQaD"),
    $acc29b706d6ed2cd$var$load("kvRbA"),
    $acc29b706d6ed2cd$var$load("kNFvF"),
    $acc29b706d6ed2cd$var$load("fdutx")
]).then(()=>parcelRequire('6gB2z'));

});


parcelRegister("gb5lQ", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3a1993d4527e7f44$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "MENU_ID", () => $3a1993d4527e7f44$export$d4cd258d01c03112);
$parcel$export(module.exports, "SECTION_ID", () => $3a1993d4527e7f44$export$501955bd67991a25);
$parcel$export(module.exports, "REPORTS_ROUTES_SET", () => $3a1993d4527e7f44$export$f746f9acd7a66bdb);
$parcel$export(module.exports, "SETTINGS_ROUTES_SET", () => $3a1993d4527e7f44$export$e8d6319ab0eb2a27);
$parcel$export(module.exports, "ISSUES_ROUTES_SET", () => $3a1993d4527e7f44$export$6ca9a18cdf1b5a79);
$parcel$export(module.exports, "FORGE_ROUTES_SET", () => $3a1993d4527e7f44$export$6ad6f0faae6ab404);
$parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", () => $3a1993d4527e7f44$export$75d31ae45b00712c);
$parcel$export(module.exports, "JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY", () => $3a1993d4527e7f44$export$b0b94b45c4873ede);
$parcel$export(module.exports, "LOCATION", () => $3a1993d4527e7f44$export$87d0ca22edb7493a);
$parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", () => $3a1993d4527e7f44$export$96f465f51836d3a2);

var $gwIPs = parcelRequire("gwIPs");
const $3a1993d4527e7f44$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
const $3a1993d4527e7f44$export$d4cd258d01c03112 = 'project/core';
const $3a1993d4527e7f44$export$501955bd67991a25 = {
    ISSUES: 'issues',
    REPORTS: 'reports',
    SETTINGS: 'settings',
    ISSUE_TYPES: 'issuetypes'
};
const $3a1993d4527e7f44$export$f746f9acd7a66bdb = new Set([
    'legacy-all-reports',
    'legacy-reports-configure',
    'legacy-reports-average-age-report',
    'legacy-reports-created-vs-resolved-report',
    'legacy-reports-pie-report',
    'legacy-reports-recently-created-report',
    'legacy-reports-resolution-time-report',
    'legacy-reports-single-level-group-by-report',
    'legacy-reports-time-since-report',
    'legacy-reports-time-tracking-report',
    'legacy-reports-developer-workload-report',
    'legacy-reports-version-workload-report',
    'legacy-reports-workload-pie-report'
]);
const $3a1993d4527e7f44$export$e8d6319ab0eb2a27 = new Set([
    'project-settings-core-proforma-project-forms',
    'project-settings-classic-issue-layout',
    'legacy-project-settings-edit',
    'legacy-project-settings-config',
    'project-settings-classic-data-classifications',
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-layout',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-opsgenie',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-summary',
    'legacy-project-settings-workflows',
    'legacy-project-settings-collectors',
    'legacy-project-settings-people',
    'project-settings-automation',
    'project-settings-versions',
    'project-settings-components',
    'legacy-project-settings-dev'
]);
const $3a1993d4527e7f44$export$6ca9a18cdf1b5a79 = new Set([
    'legacy-pin',
    'issue-navigator',
    'issue-navigator-core'
]);
const $3a1993d4527e7f44$export$6ad6f0faae6ab404 = new Set([
    'forge-spa-project',
    'project-settings-core-forge-apps'
]);
const $3a1993d4527e7f44$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
const $3a1993d4527e7f44$export$b0b94b45c4873ede = 'com.codebarrel.addons.automation.moderate';
const $3a1993d4527e7f44$export$33abecf3eb4ba30b = (0, $gwIPs.gridSize) * 5;
const $3a1993d4527e7f44$export$76ca6e18b275dcad = 24;
const $3a1993d4527e7f44$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
const $3a1993d4527e7f44$export$96f465f51836d3a2 = 10;

});

parcelRegister("iuAuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeba495724dfd3ed$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $eeba495724dfd3ed$var$SectionHeader = ({ children: children, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$960a49cc3d27a090, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$8b251419efc915eb, null, title), children);
var $eeba495724dfd3ed$export$2e2bcd8739ae039 = $eeba495724dfd3ed$var$SectionHeader;
const $eeba495724dfd3ed$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _ca0qpxbi _u5f3idpf _n3tdu2gc _19bvidpf _1e0c1txw _1bah1yb4 _4cvr1h6o _1tke1tcg _vchhusvi",
            __cmplp.className
        ])
    });
});
const $eeba495724dfd3ed$export$8b251419efc915eb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _syaz1kw7 _19pkidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6hYaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7b20fc56e6a13a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $3MXKI = parcelRequire("3MXKI");

var $8ltGH = parcelRequire("8ltGH");

var $9rljV = parcelRequire("9rljV");
const $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
const $5c7b20fc56e6a13a$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isWarningOpen, setIsWarningOpen] = (0, $5uXOq.useState)(false);
    if (hasReachedLimit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview.jira-popup",
        messageType: "transactional",
        placement: "bottom-start",
        isOpen: isWarningOpen,
        onClose: ()=>setIsWarningOpen(false),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3MXKI.default), {
                ...triggerProps,
                onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                label: formatMessage((0, $8ltGH.default).createOverviewLabel),
                testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID,
                ref: ref
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9rljV.default), null)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3MXKI.default), {
        onClick: onClick,
        label: formatMessage((0, $8ltGH.default).createOverviewLabel),
        testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID
    });
};
var $5c7b20fc56e6a13a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5c7b20fc56e6a13a$var$CreateOverview);

});
parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $1I7E8 = parcelRequire("1I7E8");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $1I7E8.Popup), 'isOpen', 'content');

});


parcelRegister("3MXKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc099922ed453c2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $faod6 = parcelRequire("faod6");

var $3bDjY = parcelRequire("3bDjY");

var $dCm1o = parcelRequire("dCm1o");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $cdc099922ed453c2$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1njd _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $cdc099922ed453c2$var$RoundCreateButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        hideTooltipOnClick: true
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        testId: testId,
        onClick: onClick,
        spacing: "compact",
        appearance: "default",
        shape: "circle",
        label: label,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: "",
                color: "var(--ds-text, #172B4D)",
                size: "small"
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdc099922ed453c2$var$StyledButton, {
        ...props,
        ref: ref,
        testId: testId,
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
            label: label,
            color: "var(--ds-text, #172B4D)",
            LEGACY_size: "small"
        }),
        onClick: onClick
    })));
var $cdc099922ed453c2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cdc099922ed453c2$var$RoundCreateButton);

});

parcelRegister("8ltGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb84096f9d3de7a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5eb84096f9d3de7a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createOverviewLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
        "defaultMessage": "Create overview"
    }
});

});

parcelRegister("9rljV", function(module, exports) {

$parcel$export(module.exports, "default", () => $724e26e8635dbe63$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bU3PY = parcelRequire("bU3PY");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $gb5lQ = parcelRequire("gb5lQ");

var $6h1VX = parcelRequire("6h1VX");
const $724e26e8635dbe63$var$OverviewLimitPopup = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($724e26e8635dbe63$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        label: "",
        color: "var(--ds-icon-warning, #E56910)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $6h1VX.default).overviewLimitReached, {
        overviewMaxLimit: (0, $gb5lQ.OVERVIEW_MAX_LIMIT)
    })));
};
var $724e26e8635dbe63$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $5uXOq.memo)($724e26e8635dbe63$var$OverviewLimitPopup);
const $724e26e8635dbe63$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6h1VX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a804cbdeb9da3577$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a804cbdeb9da3577$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    overviewLimitReached: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
        "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
    }
});

});



parcelRegister("2kAEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $882af03f312c51f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $882af03f312c51f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createOverview: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
        "defaultMessage": "Create an overview"
    },
    overviewsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
        "defaultMessage": "Overviews"
    },
    errorMessage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
        "defaultMessage": "We couldn't load overviews"
    },
    refreshPage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
        "defaultMessage": "Refresh page"
    }
});

});

parcelRegister("imgTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a3e3fe210dbf9b0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5TTho = parcelRequire("5TTho");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eEqSc = parcelRequire("eEqSc");

var $e1jn1 = parcelRequire("e1jn1");

var $jzhSN = parcelRequire("jzhSN");
const $5a3e3fe210dbf9b0$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
    const { name: name, theme: theme } = overview;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzhSN.default), {
        to: to,
        isActive: isActive,
        prefetch: "hover",
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a3e3fe210dbf9b0$export$399e54fcdf2a48ec, {
        size: "small",
        themeName: theme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1jn1.default), null, name));
    return isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEqSc.default), null, content) : content;
};
var $5a3e3fe210dbf9b0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5a3e3fe210dbf9b0$var$OverviewLink);
const $5a3e3fe210dbf9b0$export$399e54fcdf2a48ec = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5TTho.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5TTho", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ece6799ec0a6037$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $guOIy = parcelRequire("guOIy");

var $6cG4N = parcelRequire("6cG4N");

var $52Mvi = parcelRequire("52Mvi");
const $3ece6799ec0a6037$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
    const theme = themeName ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name;
    const Wrapper = (0, $52Mvi.WRAPPER)[size][theme];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": "business-entity-overview.common.ui.overview-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($guOIy))), {
        label: "",
        LEGACY_size: size,
        color: "currentColor"
    }));
};
var $3ece6799ec0a6037$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3ece6799ec0a6037$var$OverviewIcon);

});
parcelRegister("guOIy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfa480f43d6d2cb52a0e0ba9712304a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c026ca20e9e43a09$var$_react = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c026ca20e9e43a09$var$_globe = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("9x5pH")));

var $c026ca20e9e43a09$var$_world = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("4GsX0")));
function $c026ca20e9e43a09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GlobeIcon.
 * This component is GlobeIcon, with `UNSAFE_fallbackIcon` set to "WorldIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c026ca20e9e43a09$var$GlobeIcon = (props)=>/*#__PURE__*/ $c026ca20e9e43a09$var$_react.default.createElement($c026ca20e9e43a09$var$_globe.default, Object.assign({
        LEGACY_fallbackIcon: $c026ca20e9e43a09$var$_world.default
    }, props));
$c026ca20e9e43a09$var$GlobeIcon.Name = 'GlobeIconMigration';
var $c026ca20e9e43a09$var$_default = module.exports.default = $c026ca20e9e43a09$var$GlobeIcon;

});
parcelRegister("4GsX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36918aadf9f6e08c$var$_react = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36918aadf9f6e08c$var$_globe = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("9x5pH")));
function $36918aadf9f6e08c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36918aadf9f6e08c$var$WorldIcon = (props)=>/*#__PURE__*/ $36918aadf9f6e08c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $36918aadf9f6e08c$var$_globe.default
    }));
$36918aadf9f6e08c$var$WorldIcon.displayName = 'WorldIcon';
var $36918aadf9f6e08c$var$_default = module.exports.default = $36918aadf9f6e08c$var$WorldIcon;

});


parcelRegister("52Mvi", function(module, exports) {

$parcel$export(module.exports, "WRAPPER", () => $02db9db1e823edfb$export$20b8431be300f03e);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gwIPs = parcelRequire("gwIPs");
const $02db9db1e823edfb$var$iconWrapperStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderRadius: `${(0, $gwIPs.borderRadius)}px`,
    border: `1px solid ${"var(--ds-border, #091E4224)"}`
};
const $02db9db1e823edfb$var$smallIconWrapperStyles = {
    ...$02db9db1e823edfb$var$iconWrapperStyles,
    width: '24px',
    height: '24px'
};
const $02db9db1e823edfb$var$mediumIconWrapperStyles = {
    ...$02db9db1e823edfb$var$iconWrapperStyles,
    width: '32px',
    height: '32px'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02db9db1e823edfb$var$WhiteSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazwdcn _bfhk11bn",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightPurpleSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz1jkz _bfhkygwo",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightBlueSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz4v9p _bfhkc8cv",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightTealSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz1a17 _bfhk2c8p",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightGreenSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz1wnw _bfhk1e5c",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightLimeSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightYellowSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz3fv2 _bfhk1vop",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightRedSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz1rtt _bfhkuibq",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightMagentaSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazv9ra _bfhkc3uk",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightOrangeSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazf2vu _bfhkjgng",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$DarkSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazwdcn _bfhk11bn",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$PurpleSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazygwo _bfhk1jkz",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$BlueSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazc8cv _bfhk4v9p",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$TealSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz2c8p _bfhk1a17",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$GreenSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz1e5c _bfhk1wnw",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LimeSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$YellowSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syaz1vop _bfhk3fv2",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$RedSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazuibq _bfhk1rtt",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$MagentaSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazc3uk _bfhkv9ra",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$OrangeSmallIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsb1tcg _4t3i1tcg _syazjgng _bfhkf2vu",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$WhiteMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazwdcn _bfhk11bn",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightPurpleMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz1jkz _bfhkygwo",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightBlueMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz4v9p _bfhkc8cv",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightTealMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz1a17 _bfhk2c8p",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightGreenMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz1wnw _bfhk1e5c",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightLimeMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightYellowMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz3fv2 _bfhk1vop",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightRedMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz1rtt _bfhkuibq",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightMagentaMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazv9ra _bfhkc3uk",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LightOrangeMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazf2vu _bfhkjgng",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$DarkMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazwdcn _bfhk11bn",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$PurpleMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazygwo _bfhk1jkz",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$BlueMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazc8cv _bfhk4v9p",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$TealMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz2c8p _bfhk1a17",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$GreenMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz1e5c _bfhk1wnw",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$LimeMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$YellowMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syaz1vop _bfhk3fv2",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$RedMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazuibq _bfhk1rtt",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$MagentaMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazc3uk _bfhkv9ra",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$var$OrangeMediumIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itzgxb _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _1bsbzwfg _4t3izwfg _syazjgng _bfhkf2vu",
            __cmplp.className
        ])
    });
});
const $02db9db1e823edfb$export$20b8431be300f03e = {
    small: {
        white: $02db9db1e823edfb$var$WhiteSmallIconWrapper,
        'light-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
        'light-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
        'light-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
        'light-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
        'light-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
        'light-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
        'light-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
        'light-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
        dark: $02db9db1e823edfb$var$DarkSmallIconWrapper,
        purple: $02db9db1e823edfb$var$PurpleSmallIconWrapper,
        blue: $02db9db1e823edfb$var$BlueSmallIconWrapper,
        teal: $02db9db1e823edfb$var$TealSmallIconWrapper,
        green: $02db9db1e823edfb$var$GreenSmallIconWrapper,
        yellow: $02db9db1e823edfb$var$YellowSmallIconWrapper,
        red: $02db9db1e823edfb$var$RedSmallIconWrapper,
        magenta: $02db9db1e823edfb$var$MagentaSmallIconWrapper,
        orange: $02db9db1e823edfb$var$OrangeSmallIconWrapper,
        'lightest-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
        'lightest-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
        'lightest-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
        'lightest-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
        'lightest-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
        'lightest-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
        'lightest-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
        'lightest-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
        'lightest-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
        'lightest-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
        'lighter-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
        'lighter-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
        'lighter-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
        'lighter-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
        'lighter-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
        'lighter-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
        'lighter-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
        'lighter-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
        'lighter-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
        'lighter-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
        'darker-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
        'darker-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
        'darker-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
        'darker-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
        'darker-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
        'darker-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
        'darker-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
        'darker-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
        'darker-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
        'darker-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
        'darkest-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
        'darkest-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
        'darkest-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
        'darkest-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
        'darkest-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
        'darkest-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
        'darkest-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
        'darkest-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
        'darkest-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
        'darkest-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
        'adaptive-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
        'adaptive-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
        'adaptive-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
        'adaptive-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
        'adaptive-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
        'adaptive-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
        'no-background': $02db9db1e823edfb$var$WhiteSmallIconWrapper
    },
    medium: {
        white: $02db9db1e823edfb$var$WhiteMediumIconWrapper,
        'light-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
        'light-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
        'light-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
        'light-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
        'light-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
        'light-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
        'light-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
        'light-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
        dark: $02db9db1e823edfb$var$DarkMediumIconWrapper,
        purple: $02db9db1e823edfb$var$PurpleMediumIconWrapper,
        blue: $02db9db1e823edfb$var$BlueMediumIconWrapper,
        teal: $02db9db1e823edfb$var$TealMediumIconWrapper,
        green: $02db9db1e823edfb$var$GreenMediumIconWrapper,
        yellow: $02db9db1e823edfb$var$YellowMediumIconWrapper,
        red: $02db9db1e823edfb$var$RedMediumIconWrapper,
        magenta: $02db9db1e823edfb$var$MagentaMediumIconWrapper,
        orange: $02db9db1e823edfb$var$OrangeMediumIconWrapper,
        'lightest-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
        'lightest-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
        'lightest-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
        'lightest-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
        'lightest-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
        'lightest-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
        'lightest-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
        'lightest-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
        'lightest-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
        'lightest-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
        'lighter-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
        'lighter-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
        'lighter-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
        'lighter-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
        'lighter-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
        'lighter-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
        'lighter-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
        'lighter-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
        'lighter-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
        'lighter-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
        'darker-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
        'darker-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
        'darker-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
        'darker-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
        'darker-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
        'darker-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
        'darker-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
        'darker-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
        'darker-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
        'darker-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
        'darkest-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
        'darkest-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
        'darkest-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
        'darkest-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
        'darkest-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
        'darkest-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
        'darkest-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
        'darkest-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
        'darkest-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
        'darkest-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
        'adaptive-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
        'adaptive-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
        'adaptive-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
        'adaptive-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
        'adaptive-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
        'adaptive-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
        'no-background': $02db9db1e823edfb$var$WhiteMediumIconWrapper
    }
};

});


parcelRegister("eEqSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $eade14dd496994be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $eade14dd496994be$var$ActiveItem = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eade14dd496994be$var$ActiveItemWrapper, {
        "data-testid": testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eade14dd496994be$var$ActiveItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkm7j4",
            __cmplp.className
        ])
    });
});
var $eade14dd496994be$export$2e2bcd8739ae039 = $eade14dd496994be$var$ActiveItem;

});

parcelRegister("e1jn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1030b7620e8fb1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a1030b7620e8fb1d$var$LinkLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48p1wq8",
            __cmplp.className
        ])
    });
});
var $a1030b7620e8fb1d$export$2e2bcd8739ae039 = $a1030b7620e8fb1d$var$LinkLabel;

});

parcelRegister("jzhSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $90049e6de285b9de$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hjSul = parcelRequire("hjSul");
const $90049e6de285b9de$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$Wrapper, {
        isActive: isActive,
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$StyledLink, {
        "aria-current": isActive ? 'page' : undefined,
        ...other
    }, children), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$ElementAfterWrapper, {
        "data-component-selector": "sidebar-link-elem-after"
    }, elemAfter));
const $90049e6de285b9de$var$showElementAfter = {
    width: 'inherit !important',
    opacity: 1
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $90049e6de285b9de$var$ElementAfterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
            __cmplp.className
        ])
    });
});
const $90049e6de285b9de$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1x3jfry": (0, $lD23V.default)(!__cmplp.isActive && "var(--ds-background-neutral, #091E420F)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v5649dqc _1e0c1txw _4cvr1h6o _4t3i1ylp _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi1p6i _ylp515y0 _irr315y0 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp1p6i _sboj15y0",
            __cmplp.className
        ])
    });
});
const $90049e6de285b9de$var$StyledLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1e0c1txw _4cvr1h6o _syaz1gjq _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
var $90049e6de285b9de$export$2e2bcd8739ae039 = $90049e6de285b9de$var$SidebarLink;

});



parcelRegister("6KeQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7979212ccba7a92c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kEVMo = parcelRequire("kEVMo");

var $fVnbM = parcelRequire("fVnbM");

var $6jE0j = parcelRequire("6jE0j");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $1zqLm = parcelRequire("1zqLm");

var $hVL5W = parcelRequire("hVL5W");

var $1tFZj = parcelRequire("1tFZj");

var $cUsQ8 = parcelRequire("cUsQ8");
const $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
const $7979212ccba7a92c$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
const $7979212ccba7a92c$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const title = sectionId === 'starred' ? formatMessage((0, $1tFZj.default).favorites) : formatMessage((0, $1tFZj.default).recents);
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
    const onToggleExpand = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
            sectionId: sectionId,
            collapse: isExpanded
        });
    }, [
        createAnalyticsEvent,
        isExpanded,
        sectionId
    ]);
    const chevronIcon = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$var$IconWrapper, {
            isExpanded: isExpanded,
            visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            label: formatMessage(isExpanded ? (0, $1tFZj.default).collapseSection : (0, $1tFZj.default).expandSection, {
                section: title
            }),
            color: "var(--ds-text-subtlest, #626F86)",
            size: "small"
        })), [
        formatMessage,
        isExpanded,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$7d436a88869873b5, {
        "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$dca3dbf057c88c5f, {
        "aria-expanded": isExpanded,
        "aria-controls": `multi-project-menu-project-group-${sectionId}`,
        onClick: onToggleExpand,
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        iconBefore: chevronIcon
    }), title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jE0j.Collapsible), {
        id: `multi-project-menu-project-group-${sectionId}`,
        isExpanded: isExpanded,
        resetOverflow: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hVL5W.default), {
            project: project,
            to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
            onFavoriteToggle: ()=>onFavoriteToggle(project)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1zqLm.default), {
            project: project,
            to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
            onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                    projectId: project.id,
                    starred: project.isFavorite,
                    current: false
                }),
            onFavoriteToggle: ()=>onFavoriteToggle(project),
            prefetch: "hover",
            testId: $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID
        }))), showViewAllProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUsQ8.default), {
        label: viewAllProjectsLabel
    })))));
};
var $7979212ccba7a92c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($7979212ccba7a92c$var$ProjectGroup);
const $7979212ccba7a92c$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641b1u _k8m01e03",
            __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
            __cmplp.visualRefresh && "_1yt412x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7979212ccba7a92c$export$7d436a88869873b5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr _onzypxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7979212ccba7a92c$export$dca3dbf057c88c5f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81vhk _zulpv77o _syaz131l _1e0c1txw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _4cvr1h6o _80omtlke _1p1dangw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7979212ccba7a92c$export$99bffacbdbcb5195 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6jE0j", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $23992aab491d57ae$export$6eb0f7ddcda6131f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");
const $23992aab491d57ae$var$getSize = (element, direction)=>{
    return direction === 'horizontal' ? element.scrollWidth : element.scrollHeight;
};
const $23992aab491d57ae$var$setCollapsedStyle = (wrapper, direction)=>{
    // set max width to 0 and opacity to 0
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, '0px');
    wrapper.style.setProperty('opacity', '0');
    wrapper.style.setProperty('overflow', 'hidden');
};
const $23992aab491d57ae$var$setExpandedStyle = (wrapper, content, direction)=>{
    // set the max size to content size and opacity to 1
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, `${$23992aab491d57ae$var$getSize(content, direction)}px`);
    wrapper.style.setProperty('opacity', '1');
};
const $23992aab491d57ae$var$resetStyle = (wrapper, direction, resetOverflow)=>{
    wrapper.style.removeProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`);
    wrapper.style.removeProperty('opacity');
    if (resetOverflow) wrapper.style.removeProperty('overflow');
};
const $23992aab491d57ae$export$6eb0f7ddcda6131f = ({ animationDuration: animationDuration = 250, children: children, direction: direction = 'vertical', id: id, isExpanded: isExpanded, resetOverflow: resetOverflow = true })=>{
    const didMountRef = (0, $5uXOq.useRef)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const contentRef = (0, $5uXOq.useRef)(null);
    const [isRendered, setIsRendered] = (0, $5uXOq.useState)(isExpanded);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        // add the transition to the wrapper
        wrapperRef.current.style.setProperty('transition', `max-${direction === 'horizontal' ? 'width' : 'height'} ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`);
        if (!resetOverflow) wrapperRef.current.style.setProperty('overflow', 'hidden');
        if (!isExpanded) $23992aab491d57ae$var$setCollapsedStyle(wrapperRef.current, direction);
    // initial render only
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            if (!isRendered) setIsRendered(true);
            else requestAnimationFrame(()=>{
                if (!wrapperRef.current || !contentRef.current) return;
                $23992aab491d57ae$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
                // wait for the animation to finish before removing the overflow
                Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    wrapperRef.current && $23992aab491d57ae$var$resetStyle(wrapperRef.current, direction, resetOverflow);
                });
            });
        } else if (isRendered) {
            if (!wrapperRef.current || !contentRef.current) return;
            $23992aab491d57ae$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!wrapperRef.current) return;
                    $23992aab491d57ae$var$setCollapsedStyle(wrapperRef.current, direction);
                    // wait for the animation to finish before removing the content
                    Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            });
        }
    }, [
        direction,
        isExpanded,
        isRendered,
        resetOverflow
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: id,
        ref: wrapperRef
    }, isRendered && /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: contentRef
    }, children));
};

});

parcelRegister("1zqLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f581e43f4f1b3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bVfxn = parcelRequire("bVfxn");

var $jzhSN = parcelRequire("jzhSN");
const $47f581e43f4f1b3b$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzhSN.default), {
        to: to,
        onClick: onClick,
        isActive: isActive,
        elemAfter: project.permissions.viewIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bVfxn.default), {
            project: project,
            onToggle: onFavoriteToggle
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        testId: testId,
        prefetch: prefetch
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$Avatar, {
        src: project.avatarUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$ProjectName, null, project.name));
var $47f581e43f4f1b3b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($47f581e43f4f1b3b$var$ProjectItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47f581e43f4f1b3b$var$ProjectName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $47f581e43f4f1b3b$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _2rko1l7b _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVfxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5957c6a2c0f9f04$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5IcUR = parcelRequire("5IcUR");

var $7piTm = parcelRequire("7piTm");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $79Jog = parcelRequire("79Jog");
const $b5957c6a2c0f9f04$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const label = project.isFavorite ? formatMessage((0, $79Jog.default).unstar) : formatMessage((0, $79Jog.default).star);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const star = !project.isFavorite;
        onToggle(star);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
            projectId: project.id,
            star: star
        });
    }, [
        project,
        onToggle,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        padding: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5957c6a2c0f9f04$var$Button, {
        isFavorite: project.isFavorite ?? false,
        onClick: onClick,
        "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
    }, project.isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))), {
        color: "currentColor",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7piTm))), {
        color: "currentColor",
        label: label
    }))));
};
var $b5957c6a2c0f9f04$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = /*#__PURE__*/ (0, $5uXOq.memo)($b5957c6a2c0f9f04$var$FavoriteButton);
const $b5957c6a2c0f9f04$var$Button = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _2rko1sit _1e0c1txw _4cvr1h6o _80omtlke _1spjglyw _157zglyw",
            __cmplp.isFavorite ? "_syazkizl" : "_syaz1gjq",
            __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj131l _30l3131l _1705131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5IcUR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b98083f7180ee5a6483375174c0842e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $428b14ab8e8af837$var$_react = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $428b14ab8e8af837$var$_starStarred = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("dm1qi")));

var $428b14ab8e8af837$var$_starFilled = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("bH1hf")));
function $428b14ab8e8af837$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $428b14ab8e8af837$var$StarStarredIcon = (props)=>/*#__PURE__*/ $428b14ab8e8af837$var$_react.default.createElement($428b14ab8e8af837$var$_starStarred.default, Object.assign({
        LEGACY_fallbackIcon: $428b14ab8e8af837$var$_starFilled.default
    }, props));
$428b14ab8e8af837$var$StarStarredIcon.Name = 'StarStarredIconMigration';
var $428b14ab8e8af837$var$_default = module.exports.default = $428b14ab8e8af837$var$StarStarredIcon;

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});

parcelRegister("bH1hf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8834b3797a7b4177$var$_react = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8834b3797a7b4177$var$_starStarred = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("dm1qi")));
function $8834b3797a7b4177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8834b3797a7b4177$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8834b3797a7b4177$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8834b3797a7b4177$var$_starStarred.default
    }));
$8834b3797a7b4177$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $8834b3797a7b4177$var$_default = module.exports.default = $8834b3797a7b4177$var$StarFilledIcon;

});


parcelRegister("7piTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::981bc152c9d73fe857301cf222775bab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));

var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
function $564985c3728d4aa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarUnstarredIcon.
 * This component is StarUnstarredIcon, with `UNSAFE_fallbackIcon` set to "StarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
        LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
    }, props));
$564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;

});
parcelRegister("5oTeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eea0a48351333dc$var$_react = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3eea0a48351333dc$var$_starUnstarred = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("dAf5R")));
function $3eea0a48351333dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3eea0a48351333dc$var$StarIcon = (props)=>/*#__PURE__*/ $3eea0a48351333dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $3eea0a48351333dc$var$_starUnstarred.default
    }));
$3eea0a48351333dc$var$StarIcon.displayName = 'StarIcon';
var $3eea0a48351333dc$var$_default = module.exports.default = $3eea0a48351333dc$var$StarIcon;

});


parcelRegister("79Jog", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dbb204157c9a073$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2dbb204157c9a073$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    star: {
        "id": "spa-apps-sidebar-core.common.favorite-button.star",
        "defaultMessage": "Add to Starred"
    },
    unstar: {
        "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
        "defaultMessage": "Remove from Starred"
    }
});

});



parcelRegister("hVL5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b65956d11fea1d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eEqSc = parcelRequire("eEqSc");

var $1zqLm = parcelRequire("1zqLm");

var $fqbZF = parcelRequire("fqbZF");
const $e4b65956d11fea1d$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
const $e4b65956d11fea1d$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
            projectId: project.id,
            starred: project.isFavorite,
            current: true
        });
    }, [
        createAnalyticsEvent,
        project
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEqSc.default), {
        testId: $e4b65956d11fea1d$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1zqLm.default), {
        project: project,
        to: to,
        isActive: true,
        onClick: onClick,
        onFavoriteToggle: onFavoriteToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbZF.default), null));
};
var $e4b65956d11fea1d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e4b65956d11fea1d$var$ActiveProject);

});
parcelRegister("fqbZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $44c9fe648224cdc5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k0iPT = parcelRequire("k0iPT");

var $juTur = parcelRequire("juTur");

var $231OU = parcelRequire("231OU");

var $6jY6G = parcelRequire("6jY6G");

var $gb5lQ = parcelRequire("gb5lQ");

var $lPApw = parcelRequire("lPApw");

var $74Yye = parcelRequire("74Yye");

var $iCrgB = parcelRequire("iCrgB");

var $2U3dG = parcelRequire("2U3dG");

var $boE05 = parcelRequire("boE05");

var $chejP = parcelRequire("chejP");

var $9nNLl = parcelRequire("9nNLl");
const $44c9fe648224cdc5$var$calculateStack = (route, connectStack, forgeStack)=>{
    const routeName = route && route.name || '';
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $gb5lQ.FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
    if ((0, $k0iPT.CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
    return [];
};
const $44c9fe648224cdc5$var$ProjectMenu = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $74Yye.default)();
    const { data: features, loading: isFeaturesLoading } = (0, $lPApw.useFeatures)();
    const { stack: connectProjectStack } = (0, $lPApw.useProjectConnectItems)();
    const { stack: connectReportsStack } = (0, $lPApw.useProjectReportsConnectItems)();
    const { stack: connectSettingsStack } = (0, $lPApw.useProjectSettingsConnectItems)();
    const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
    const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    const [stack, setStack] = (0, $5uXOq.useState)(()=>$44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
    (0, $5uXOq.useEffect)(()=>{
        setStack($44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
    let content = null;
    if ((0, $gb5lQ.ISSUES_ROUTES_SET).has(route.name)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $boE05.default), {
        project: project
    });
    else if ((0, $gb5lQ.REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $chejP.default), null);
    else if ((0, $gb5lQ.SETTINGS_ROUTES_SET).has(route.name) || route?.group === 'project-settings-core' || connectSettingsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nNLl.default), {
        project: project
    });
    else if ((0, $gb5lQ.FORGE_ROUTES_SET).has(route.name) || forgeStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2U3dG.default), null);
    else if ((0, $k0iPT.CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCrgB.default), {
        stack: stack,
        onStackChange: setStack,
        project: project
    });
    else return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $gb5lQ.MENU_ID),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44c9fe648224cdc5$export$42a852a2b6b56249, null, content));
};
const $44c9fe648224cdc5$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
            __cmplp.className
        ])
    });
});
var $44c9fe648224cdc5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($44c9fe648224cdc5$var$ProjectMenu);

});
parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $c82776b15970ab04$export$50c2d6bcb0b94b74);
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $c82776b15970ab04$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});

parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: // eslint-disable-next-line react-hooks/react-compiler
useProject = (0, $lpwtK.useProject), ...rest })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("231OU", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $1a247d2d1d6e7cdf$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $1a247d2d1d6e7cdf$export$80e84933a3e2f677);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(projectData, routeName);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("kKdpt", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $dac9c7c54c5ccbb1$export$462f82a278743d46);

var $5uXOq = parcelRequire("5uXOq");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");

var $7Tlti = parcelRequire("7Tlti");
const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $7Tlti.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});

parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});



parcelRegister("lPApw", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $fd44cc0bd2bece63$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useProjectConnectItems", () => $fd44cc0bd2bece63$export$f23d0c24c77d7608);
$parcel$export(module.exports, "useProjectReportsConnectItems", () => $fd44cc0bd2bece63$export$a1c75c386c088992);
$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $fd44cc0bd2bece63$export$41a50100db18b578);
$parcel$export(module.exports, "useProjectSettingsForgeItems", () => $fd44cc0bd2bece63$export$84761bbf25a4f51f);

var $18FbX = parcelRequire("18FbX");

var $7OqB4 = parcelRequire("7OqB4");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $6hMYg = parcelRequire("6hMYg");

var $bkw8F = parcelRequire("bkw8F");
const $fd44cc0bd2bece63$export$4a39035bacc4ed76 = (0, $7OqB4.withThrowOnError)((0, $bkw8F.useFeatures));
const $fd44cc0bd2bece63$export$f23d0c24c77d7608 = (0, $7OqB4.withThrowOnError)((0, $gZbSF.useProjectConnectItems));
const $fd44cc0bd2bece63$export$a1c75c386c088992 = (0, $7OqB4.withThrowOnError)((0, $hWtQt.useProjectReportsConnectItems));
const $fd44cc0bd2bece63$export$41a50100db18b578 = (0, $7OqB4.withThrowOnError)((0, $jfqNX.useProjectSettingsConnectItems));
const $fd44cc0bd2bece63$export$84761bbf25a4f51f = (0, $6hMYg.useProjectSettingsForgeAppsForMenu);
const $fd44cc0bd2bece63$export$96e8a0c1f4717705 = (0, $7OqB4.withThrowOnError)((0, $18FbX.useJiraWorkManagementProjectPagesLink));

});
parcelRegister("18FbX", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", () => $066b0551287c1b35$export$50628ae0ad1a35f2);
$parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", () => $066b0551287c1b35$export$96e8a0c1f4717705);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $1J3t1 = parcelRequire("1J3t1");
const $066b0551287c1b35$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`/rest/projects/1.0/pageslink/${projectKey}`;
const $066b0551287c1b35$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
const $066b0551287c1b35$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
const $066b0551287c1b35$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, $eusud.performPutRequest)($066b0551287c1b35$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, $eusud.performPutRequest)($066b0551287c1b35$var$disablePagesLinkUrl(baseUrl, projectKey));
const $066b0551287c1b35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
const $066b0551287c1b35$export$50628ae0ad1a35f2 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
        await $066b0551287c1b35$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: data?.hasPages === true,
            canEdit: data?.permissionInfo != null && $066b0551287c1b35$var$isProjectOrJiraAdmin(data.permissionInfo),
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};
const $066b0551287c1b35$export$96e8a0c1f4717705 = ()=>{
    const { loading: loading, refresh: refresh, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
        await $066b0551287c1b35$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: true,
            canEdit: false,
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("6hMYg", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $2106846b1818d2e6$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $2106846b1818d2e6$export$b741e3e3cfb39b82);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $2YP9W = parcelRequire("2YP9W");

var $kKdpt = parcelRequire("kKdpt");

var $7Tlti = parcelRequire("7Tlti");
const $2106846b1818d2e6$export$bef2e514007d2f07 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeProjectSettingsModuleResource));
    const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions
    ]);
};
const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
    const stack = (0, $kKdpt.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $7Tlti.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});
parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});


parcelRegister("bkw8F", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $7fc2f0545f0a83ac$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useSettingFeatures", () => $7fc2f0545f0a83ac$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useReportFeatures", () => $7fc2f0545f0a83ac$export$4adaea9828b7ff13);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $jIwth = parcelRequire("jIwth");

var $cSUZZ = parcelRequire("cSUZZ");

var $daoB1 = parcelRequire("daoB1");

var $d4FZj = parcelRequire("d4FZj");
const $7fc2f0545f0a83ac$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const isPremiumUserSeat = (0, $cSUZZ.useIsPremiumUserSeat)();
    const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, $d4FZj.getExtraData)(data, isPremiumUserSeat), [
        data,
        isPremiumUserSeat
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $7fc2f0545f0a83ac$export$56022a3b83c8ed6a = ()=>{
    const hasActiveSoftwareAccess = (0, $jIwth.useHasActiveSoftwareAccess)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, $d4FZj.getExtraSettingsData)(data, hasActiveSoftwareAccess), [
        data,
        hasActiveSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $7fc2f0545f0a83ac$export$4adaea9828b7ff13 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, $d4FZj.getExtraReportData)(hasSoftwareAccess), [
        data,
        hasSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("jIwth", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $c3adde43a433f1b5$export$895f9b38ce00671e);

var $k9JTq = parcelRequire("k9JTq");

var $daoB1 = parcelRequire("daoB1");
const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});
parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});


parcelRegister("d4FZj", function(module, exports) {

$parcel$export(module.exports, "getExtraData", () => $acf9418ce967848e$export$6c55c6c980ed2046);
$parcel$export(module.exports, "getExtraSettingsData", () => $acf9418ce967848e$export$b77a5597b7177cfb);
$parcel$export(module.exports, "getExtraReportData", () => $acf9418ce967848e$export$be58a1e7b06d1d3);

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");
const $acf9418ce967848e$export$6c55c6c980ed2046 = (data, isPremium)=>{
    const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
    const isSimplifiedProject = project.simplified;
    const hasSettings = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS || projectPermissionsQueried.EDIT_ISSUE_LAYOUT || projectPermissionsQueried.EDIT_WORKFLOW || ((0, $4R6GH.fg)('vmc-11-manage-versions-permission') ? projectPermissionsQueried.MANAGE_VERSIONS : false);
    return {
        hasVersions: (0, $4R6GH.fg)('vmc-11-manage-versions-permission') ? projectPermissionsQueried.MANAGE_VERSIONS || isProjectOrJiraAdmin : true,
        hasSettings: hasSettings,
        hasBoard: true,
        hasReports: true,
        hasAddItem: isProjectOrJiraAdmin,
        hasComponents: hasComponents,
        hasIssues: true,
        hasSummary: true,
        hasPages: true,
        hasChangeTheme: isProjectOrJiraAdmin,
        hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
    };
};
const $acf9418ce967848e$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
    const isCMPProject = !data.project.simplified;
    const hasEditWorkflowPermissions = projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasIssueLayoutPermissions = projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    const hasManageVersionsPermissions = projectPermissionsQueried.MANAGE_VERSIONS === true;
    const hasDetails = isProjectOrJiraAdmin;
    const hasPeople = isProjectOrJiraAdmin;
    const hasIssueTypes = isAdmin;
    let hasAutomation = true;
    let hasSummary = true;
    let hasWorkflows = true;
    let hasScreens = true;
    /*
	 * SettingFeatures.hasSystemFieldsConfiguration and hasProjectEfaFields both
	 * show/hide a navigation menu item named "Fields".
	 *
	 * - `hasSystemFieldsConfiguration` is CMP specific; shows the
	 * "System Default Field Configuration" page which is visible by default
	 * - `hasProjectEfaFields` is TMP specific; only shows Project Fields page
	 * under certain circumstances.
	 */ let hasSystemFieldsConfiguration = true;
    let hasProjectEfaFields = false;
    let hasVersions = true;
    let hasComponents = true;
    let hasPermissions = true;
    let hasIssueSecurity = true;
    let hasNotifications = true;
    let hasIssueCollectors = true;
    let hasIssueLayout = true;
    const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
    hasAutomation = isProjectOrJiraAdmin;
    hasSummary = isProjectOrJiraAdmin;
    hasWorkflows = hasEditWorkflowPermissions || isProjectOrJiraAdmin;
    hasScreens = isProjectOrJiraAdmin;
    hasSystemFieldsConfiguration = isCMPProject && isProjectOrJiraAdmin;
    hasVersions = (0, $4R6GH.fg)('vmc-11-manage-versions-permission') ? hasManageVersionsPermissions || isProjectOrJiraAdmin : isProjectOrJiraAdmin;
    hasComponents = isProjectOrJiraAdmin;
    hasPermissions = isProjectOrJiraAdmin;
    hasIssueSecurity = isProjectOrJiraAdmin;
    hasNotifications = isProjectOrJiraAdmin;
    hasIssueCollectors = isProjectOrJiraAdmin;
    hasIssueLayout = hasIssueLayoutPermissions || isProjectOrJiraAdmin;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    if (expConfig.get('isEnabled', false)) hasProjectEfaFields = !isCMPProject && isProjectOrJiraAdmin && !!data.hasExplicitFieldAssociationsEnabled;
    return {
        hasAutomation: hasAutomation,
        hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
        hasIssueConfigSection: hasIssueTypes,
        hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasSystemFieldsConfiguration,
        hasProjectGroupThreeSection: hasVersions || hasComponents,
        hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
        hasgetIssueCollectorSection: hasIssueCollectors,
        hasComponents: hasComponents,
        hasDetails: hasDetails,
        hasSystemFieldsConfiguration: hasSystemFieldsConfiguration,
        hasProjectEfaFields: hasProjectEfaFields,
        hasIssueCollectors: hasIssueCollectors,
        hasIssueSecurity: hasIssueSecurity,
        hasIssueTypes: hasIssueTypes,
        hasNotifications: hasNotifications,
        hasPeople: hasPeople,
        hasPermissions: hasPermissions,
        hasScreens: hasScreens,
        hasSummary: hasSummary,
        hasVersions: hasVersions,
        hasWorkflows: hasWorkflows,
        hasDevtools: hasDevtools,
        hasIssueLayout: hasIssueLayout
    };
};
const $acf9418ce967848e$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
        hasDeveloperWorkload: true,
        hasForcastSection: true,
        hasTimeTracking: true,
        hasVersionWorkloadReport: hasSoftwareAccess
    });

});



parcelRegister("74Yye", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d2a068828302038$export$2e2bcd8739ae039);

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");
const $3d2a068828302038$var$useProject = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
var $3d2a068828302038$export$2e2bcd8739ae039 = $3d2a068828302038$var$useProject;

});

parcelRegister("iCrgB", function(module, exports) {

$parcel$export(module.exports, "default", () => $116dde1e3871ac6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $3tHFY = parcelRequire("3tHFY");

var $gZbSF = parcelRequire("gZbSF");

var $8yg0C = parcelRequire("8yg0C");

var $cqRWX = parcelRequire("cqRWX");
const $116dde1e3871ac6a$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
    (0, $8yg0C.default)();
    const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, $gZbSF.useProjectConnectItems)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectKey = String(project?.key);
    const getBackMenuItem = (0, $5uXOq.useCallback)(()=>({
            href: `/jira/core/projects/${projectKey}`,
            title: formatMessage((0, $cqRWX.messages).itemBack)
        }), [
        formatMessage,
        projectKey
    ]);
    if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: onStackChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: connectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: getBackMenuItem(),
            navigateOnBackMenuItemClick: true
        }
    })));
    return null;
};
var $116dde1e3871ac6a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($116dde1e3871ac6a$var$ConnectAppMenu);

});
parcelRegister("9btdk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $1598986e4d07c239$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $1598986e4d07c239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $VSDnB = parcelRequire("VSDnB");

var $6XySk = parcelRequire("6XySk");

var $8UO8z = parcelRequire("8UO8z");

var $9zCCP = parcelRequire("9zCCP");

var $j9VTE = parcelRequire("j9VTE");

var $cfT4M = parcelRequire("cfT4M");
const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $1598986e4d07c239$var$nestableNavigationContentStyles = null;
const $1598986e4d07c239$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XySk.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $9zCCP.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfT4M.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9VTE.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UO8z.default), {
                                    title: "",
                                    id: $1598986e4d07c239$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;

});
parcelRegister("6XySk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf862f964b3fe45$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2gYe = parcelRequire("d2gYe");


var $ayWDM = parcelRequire("ayWDM");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $acf862f964b3fe45$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;

});
parcelRegister("d2gYe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
    }, props));
$97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;

});
parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});


parcelRegister("ayWDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cc941614c9e62$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kJpBP = parcelRequire("kJpBP");

var $j9VTE = parcelRequire("j9VTE");
const $860cc941614c9e62$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $860cc941614c9e62$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $860cc941614c9e62$var$styles.root,
            props.isSelected && $860cc941614c9e62$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;

});


parcelRegister("8UO8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599b2a9b08db47e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bh9nY = parcelRequire("bh9nY");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $ayWDM = parcelRequire("ayWDM");
var $jSfqD = parcelRequire("jSfqD");
var $kzjuk = parcelRequire("kzjuk");

var $9btdk = parcelRequire("9btdk");

var $j9VTE = parcelRequire("j9VTE");

var $9zCCP = parcelRequire("9zCCP");
const $0599b2a9b08db47e$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $0599b2a9b08db47e$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $j9VTE.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $9zCCP.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j9VTE.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kzjuk.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $9btdk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "data-right-arrow": true,
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh9nY))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;

});
parcelRegister("bh9nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
function $835890081946c47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835890081946c47e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
    }, props));
$835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("1zw66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $1251f532550be707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $1251f532550be707$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $1251f532550be707$var$_arrowRight.default
    }));
$1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;

});


parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1aogK = parcelRequire("1aogK");

var $j9VTE = parcelRequire("j9VTE");
const $0e63733262ea805c$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0e63733262ea805c$var$styles.root,
            props.isSelected && $0e63733262ea805c$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("9zCCP", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $edc749a9b64f215e$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $edc749a9b64f215e$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $9btdk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("cfT4M", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $0051a7791f96d83a$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Sbj3 = parcelRequire("8Sbj3");
const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("3tHFY", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $1b0be5b9936240ae$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");
const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("au6nA", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $cb371d7d8e582719$export$79762159776e61da);

var $5uXOq = parcelRequire("5uXOq");

var $kvHKs = parcelRequire("kvHKs");
const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $kvHKs.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fh2pW", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $3OGaE = parcelRequire("3OGaE");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $hrlU6.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $5uXOq.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $4OCke.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2bd062d7c8c5e44$var$ConnectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUo88", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $89b5b8a4b358ad27$export$93509ff9a62ee022);

var $7RRGT = parcelRequire("7RRGT");
const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $7RRGT.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("jjUR3", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $c499ec49965fe6fe$export$c251e3fda1cce4a3);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
// A single instance for the entire SPA session
const $c499ec49965fe6fe$var$history = {
    unique: []
};
const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
    (0, $gKZoD.di)(window);
    const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $c499ec49965fe6fe$var$history.unique.push(historyItem);
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            history: $c499ec49965fe6fe$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $c499ec49965fe6fe$var$history.unique.length = 0;
};

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("fsoZQ"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");

var $wRU6t = parcelRequire("wRU6t");

var $jcw0u = parcelRequire("jcw0u");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: new Error((0, $wRU6t.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("fsoZQ", function(module, exports) {

let $b40cdc4ebdd385ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b40cdc4ebdd385ab$var$load("gZGeX").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d2gYe = parcelRequire("d2gYe");

var $8UO8z = parcelRequire("8UO8z");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fpoBX = parcelRequire("fpoBX");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $8UO8z.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $bwpsq.default)([
                $2fbfde7c900477f4$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});



parcelRegister("8yg0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $389170a5379f53c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $389170a5379f53c2$var$useAutoExpandSidebar = ()=>{
    const { expandLeftSidebar: expandLeftSidebar } = (0, $gPQRI.useLeftSidebarController)();
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const sidebarExpandedRef = (0, $5uXOq.useRef)(!isCollapsed);
    (0, $5uXOq.useEffect)(()=>{
        if (!sidebarExpandedRef.current && isCollapsed) {
            expandLeftSidebar();
            sidebarExpandedRef.current = true;
        }
    }, [
        expandLeftSidebar,
        isCollapsed
    ]);
};
var $389170a5379f53c2$export$2e2bcd8739ae039 = $389170a5379f53c2$var$useAutoExpandSidebar;

});

parcelRegister("cqRWX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dd966ae40fe1732a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dd966ae40fe1732a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
        "defaultMessage": "Back to project"
    }
});

});


parcelRegister("2U3dG", function(module, exports) {

$parcel$export(module.exports, "default", () => $46153d687d6c578f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $ih1Yr = parcelRequire("ih1Yr");

var $231OU = parcelRequire("231OU");

var $8zgGo = parcelRequire("8zgGo");

var $6jY6G = parcelRequire("6jY6G");

var $2YP9W = parcelRequire("2YP9W");

var $8yg0C = parcelRequire("8yg0C");
const $46153d687d6c578f$var$ForgeMenu = ()=>{
    (0, $8yg0C.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: forgeResourceData } = (0, $2YP9W.useResource)((0, $5bkvv.forgeProjectModuleResource));
    const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        forgeResourceData
    ]);
    const selectedForgeApp = (0, $ih1Yr.useForgeSelectedApp)(projectData, route.name);
    const { stack: forgeStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zgGo.ForgeProjectSection), {
        overrides: {
            showSelectedAppMenuOnly: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedApp: selectedForgeApp
        }
    });
    return null;
};
var $46153d687d6c578f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($46153d687d6c578f$var$ForgeMenu);

});
parcelRegister("ih1Yr", function(module, exports) {

$parcel$export(module.exports, "useForgeSelectedApp", () => $b1393ffdd951bcc8$export$e6dee8b777476118);

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");
const $b1393ffdd951bcc8$export$e6dee8b777476118 = (modules, routeName)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    if (route.name !== routeName || matchedExtension == null) return null;
    return matchedExtension;
};

});

parcelRegister("8zgGo", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $4cec53abbd9c3c33$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeProjectSection", () => $4cec53abbd9c3c33$export$fb7da191295a7e22);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $bXK4r = parcelRequire("bXK4r");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $231OU = parcelRequire("231OU");

var $kBPYs = parcelRequire("kBPYs");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
    [(0, $2vSU6.CORE_PROJECT)]: 'core',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $231OU.useProjectForgeApps)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
            overrides.selectedApp
        ] : data || [], [
        data,
        overrides
    ]);
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXK4r.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $kBPYs.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("1rTGO", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $abbdb580491d9d09$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $abbdb580491d9d09$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $abbdb580491d9d09$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $abbdb580491d9d09$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $abbdb580491d9d09$export$14e56d7f5d3f917c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $eOGyv = parcelRequire("eOGyv");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $dd7Uh = parcelRequire("dd7Uh");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");
const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: (0, $6MtPV.createAttributes)(attributes)
    });
const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $dd7Uh.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $eOGyv.useHasForgeAccess)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]);
    const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, (0, $9BrHy.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: fireEvent
    });
};
const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hBuqR.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $k2DRb.CUSTOM_FIELD_MODULE) || extensionModule === (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $k2DRb.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $k2DRb.GLOBAL_PAGE_MODULE),
        (0, $k2DRb.ISSUE_ACTION_MODULE),
        (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
        (0, $k2DRb.ISSUE_CONTEXT_MODULE),
        (0, $k2DRb.ISSUE_GLANCE_MODULE),
        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $k2DRb.ISSUE_PANEL_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.ADMIN_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $k2DRb.BACKLOG_ACTION_MODULE),
        (0, $k2DRb.BOARD_ACTION_MODULE),
        (0, $k2DRb.SPRINT_ACTION_MODULE),
        (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $5uXOq.useRef)(performance.now());
        const isCustomUI = (0, $3mOWa.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $9BrHy.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        }) : (0, $9BrHy.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $5uXOq.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $5uXOq.useCallback)(()=>{
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $dd7Uh.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("3mOWa", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $e79bbc527e600bd1$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $e79bbc527e600bd1$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $e79bbc527e600bd1$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $e79bbc527e600bd1$export$42b85bc9b386c977);

var $gccSB = parcelRequire("gccSB");
const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("eOGyv", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);

var $cZpsT = parcelRequire("cZpsT");
const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $cb25w.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("isuse", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $1df0619a43ad69d9$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
// eslint-disable-next-line jira/react/no-class-components
class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, $cb25w.default)()($1df0619a43ad69d9$var$MountEventComponent);

});

parcelRegister("dd7Uh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $7d829a81d29f9e72$export$add44f896fb31ba3);

var $hBuqR = parcelRequire("hBuqR");

var $8uOa6 = parcelRequire("8uOa6");
const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("2RhPB", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $3fba0b567cec1fe0$export$5d3b06ab08af139e);

var $3mOWa = parcelRequire("3mOWa");

var $e0AC8 = parcelRequire("e0AC8");
const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $3mOWa.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("bXK4r", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $488beba58e0bb189$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $488beba58e0bb189$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $488beba58e0bb189$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("k51JQ", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $b3f0da209e047dcf$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $b3f0da209e047dcf$export$26a5287439a1d287);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $fl3Yy = parcelRequire("fl3Yy");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $jv9Yy = parcelRequire("jv9Yy");

var $8iQMc = parcelRequire("8iQMc");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeIcon, {
        alt: "",
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        spacing: "spacious",
        label: ""
    });
const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        }
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $8iQMc.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        nestedMenuActive: nestedMenuActive
    });
const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $5uXOq.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $4OCke.matchPartialUrlPathname)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeSubpagesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jv9Yy.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                }
            }, page.title)))));
};
const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b3f0da209e047dcf$var$ForgeSubpagesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_14tkpxbi _t3zcv47k _1so41gjq",
            __cmplp.className
        ])
    });
});
const $b3f0da209e047dcf$var$ForgeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl3Yy", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $730173a4987fa3e4$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $730173a4987fa3e4$export$f9338c21ba7c7334);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $k2DRb = parcelRequire("k2DRb");

var $ousew = parcelRequire("ousew");

var $8Je4V = parcelRequire("8Je4V");
const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $k2DRb.DEVELOPMENT_ENVIRONMENT:
            return (0, $8Je4V.messages).developmentEnvironmentLozenge;
        case 0, $k2DRb.STAGING_ENVIRONMENT:
            return (0, $8Je4V.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), labelKey)) : null;
};
const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("8Je4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $838ac71f7259b5ef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $838ac71f7259b5ef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("jv9Yy", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $c634a42deba697de$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c2V4l = parcelRequire("c2V4l");

var $fpoBX = parcelRequire("fpoBX");
const $c634a42deba697de$var$textColorCssVar = '--section-header-text-color';
const $c634a42deba697de$var$opacityCssVar = '--section-header-opacity';
const $c634a42deba697de$var$colorThemeStyles = null;
const $c634a42deba697de$var$opacityThemeStyles = null;
const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement((0, $c2V4l.default), {
        // @ts-expect-error - className is a valid prop
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            [$c634a42deba697de$var$opacityCssVar]: item?.opacity,
            [$c634a42deba697de$var$textColorCssVar]: item?.color?.default
        },
        className: (0, $bwpsq.default)([
            item?.opacity && "_tzy4blmq",
            item?.color?.default && "_syazoa1y"
        ])
    }, children);
};

});
parcelRegister("c2V4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6289355db2eea81d$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mNf3 = parcelRequire("4mNf3");

var $j9VTE = parcelRequire("j9VTE");
const $6289355db2eea81d$var$styles = {
    headingItem: "_18zru2gc"
};
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $6289355db2eea81d$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mNf3.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $6289355db2eea81d$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};
var $6289355db2eea81d$export$2e2bcd8739ae039 = $6289355db2eea81d$var$HeadingItem;

});


parcelRegister("8iQMc", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $apKqz = parcelRequire("apKqz");

var $fl3Yy = parcelRequire("fl3Yy");

var $fJoTF = parcelRequire("fJoTF");
const $5bbfd34eb4e2a6d6$var$containerNestedStyles = null;
const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $ujWmd.default), AddonIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($apKqz))), Header: Header = (0, $fJoTF.CustomHeader), EnvironmentLozenge: EnvironmentLozenge = (0, $fl3Yy.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, nestedMenuActive: nestedMenuActive })=>{
    return /*#__PURE__*/ $5uXOq.createElement(Header, {
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ $5uXOq.createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ $5uXOq.createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        iconAfter: /*#__PURE__*/ $5uXOq.createElement(EnvironmentLozenge, {
            environmentType: environmentType
        }),
        className: (0, $bwpsq.default)([
            nestedMenuActive && "_19bv183y"
        ])
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});


parcelRegister("kBPYs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3e1e8355c24b18f2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});



parcelRegister("boE05", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8fbdf556ad4d3a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $juTur = parcelRequire("juTur");

var $jsI7v = parcelRequire("jsI7v");

var $8yg0C = parcelRequire("8yg0C");

var $k6yFu = parcelRequire("k6yFu");
const $e8fbdf556ad4d3a9$var$EMPTY_STACK = [];
const $e8fbdf556ad4d3a9$var$IssuesMenu = ({ project: project })=>{
    (0, $8yg0C.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        initialStack: $e8fbdf556ad4d3a9$var$EMPTY_STACK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsI7v.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
        titleHeaderText: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $k6yFu.default).issuesIssueTermRefresh : (0, $k6yFu.default).issues)
    }))));
};
var $e8fbdf556ad4d3a9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e8fbdf556ad4d3a9$var$IssuesMenu);

});
parcelRegister("jsI7v", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $e89a82dba74cf1ac$export$1cb51167b20548a0);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bWqXX = parcelRequire("bWqXX");

var $7CMCs = parcelRequire("7CMCs");

var $iL2Ly = parcelRequire("iL2Ly");

var $6KxGW = parcelRequire("6KxGW");

var $8kM72 = parcelRequire("8kM72");

var $5w5Kh = parcelRequire("5w5Kh");

var $hnmuM = parcelRequire("hnmuM");
const $e89a82dba74cf1ac$export$1cb51167b20548a0 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { data: features } = (0, $8kM72.useDefaultPinFilters)();
    if (features === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5w5Kh.DefaultFilters), {
        pinUrl: pinUrl,
        projectKey: projectKey,
        features: features,
        titleHeaderText: titleHeaderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jira-navigation-apps-sidebar-common",
        id: "issues.starred-filters-section",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KxGW.StarredFiltersErrorFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerAfter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL2Ly.StarredFiltersContainer), {
        pinUrl: pinUrl,
        projectKey: projectKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnmuM.FiltersFooter), {
        hasFilters: hasFilters
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e89a82dba74cf1ac$var$CompiledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xlv12x7 _1rqn1fxt",
            __cmplp.renderDividerBefore && "_175u1crf",
            __cmplp.renderDividerAfter && "_1we51crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iL2Ly", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersContainer", () => $1ec2742e0426c5a8$export$f5b4503a4a7ca418);

var $59JDz = parcelRequire("59JDz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWqXX = parcelRequire("bWqXX");

var $VILOn = parcelRequire("VILOn");

var $a3OKn = parcelRequire("a3OKn");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $bATyw = parcelRequire("bATyw");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $aV2yn = parcelRequire("aV2yn");

var $8Jljs = parcelRequire("8Jljs");
const $1ec2742e0426c5a8$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.;
    const [localStorageData] = (0, $5uXOq.useState)((0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
    const { data: resourceData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    // get value from localStorage if available, get from the resource if this code runs in SSR
    let isNinGlobalScopeEnrolmentEnabled;
    if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
    const baseHref = (0, $aV2yn.getStarredFilterLink)({
        projectKey: projectKey,
        pinUrl: pinUrl,
        shouldStayProjectScope: isNinGlobalScopeEnrolmentEnabled
    });
    const data = (0, $8Uumt.usePreloadedQuery)((0, $59JDz.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Jljs.StarredFiltersList), {
        baseHref: baseHref,
        jiraQuery: data.jira,
        onFavouritesChanged: onFavouritesChanged
    });
};
const $1ec2742e0426c5a8$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
    const { queryReference: resourceQueryRef } = (0, $ao2h1.useRelayResource)((0, $a3OKn.sidebarProjectIssuesResource));
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $59JDz.default), resourceQueryRef);
    const cloudId = (0, $koeKL.useCloudId)();
    const loadSidebarData = (0, $5uXOq.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!queryReference) loadSidebarData();
    }, [
        loadSidebarData,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "starred-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ec2742e0426c5a8$export$3be6ba2fb4838e7e, {
        queryReference: queryReference,
        onFavouritesChanged: loadSidebarData,
        pinUrl: pinUrl,
        projectKey: projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null));
};

});
parcelRegister("59JDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7247f574fad09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02638f2e8727b45498d5facc19a78e14>>
 * @relayHash 976837d13abb9b9131601925549fb05e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9

var $7vXy9 = parcelRequire("7vXy9");
const $6bc7247f574fad09$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $7vXy9.default)
            }
        }
    };
}();
$6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;

});
parcelRegister("7vXy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac90445fe2bfbc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3ac90445fe2bfbc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar');
    }
};

});


parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("a3OKn", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $b491cf2963738bcf$export$be31dd7adcfd2297);

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $6YG83 = parcelRequire("6YG83");
const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $59JDz.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("6YG83", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $895edd6ed19f0aa8$export$f4b29e78f4c0a526);
const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("jyZ5j"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("jyZ5j", function(module, exports) {

let $e3e0936d37a0ceb5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3e0936d37a0ceb5$var$load("7etJl").then(()=>parcelRequire('dIecw'));

});


parcelRegister("aV2yn", function(module, exports) {

$parcel$export(module.exports, "getStarredFilterLink", () => $a754d4f1af7bcc7d$export$7082c02465d0ecd4);
const $a754d4f1af7bcc7d$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
    if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
    // xxx/issues?filter=123 -> xxx/issues
    const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
    return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};

});

parcelRegister("8Jljs", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $0208f837fc89d8ec$export$b7f4b26a8737eee0);

var $47bDC = parcelRequire("47bDC");

var $jUReQ = parcelRequire("jUReQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $b2GBS = parcelRequire("b2GBS");

var $kZDjT = parcelRequire("kZDjT");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4ABV3 = parcelRequire("4ABV3");
const $0208f837fc89d8ec$export$1f869c99ead9db5f = 15;
const $0208f837fc89d8ec$var$VIEW_ALL_STARRED_FILTERS_HREF = '/jira/filters?page=1&sortKey=favourite&sortOrder=DESC';
const $0208f837fc89d8ec$var$analyticsPayload = {
    itemId: 'nin-view-all-starred-filters'
};
var $0208f837fc89d8ec$var$_StyledSection = /*#__PURE__*/ (0, $47bDC.default)((0, $gjTBi.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $jUReQ.default), jiraQuery);
    (0, $b2GBS.useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar') ? data.favouriteFilters?.edges?.filter(Boolean).filter((edge)=>!!edge?.node?.filterId).slice(0, $0208f837fc89d8ec$export$1f869c99ead9db5f) ?? [] : data.favouriteFiltersOld?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
        title: formatMessage((0, $4ABV3.messages).newStarredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZDjT.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null), (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar') && (data.favouriteFilters?.pageInfo?.hasNextPage || (data.favouriteFilters?.edges ?? []).length > $0208f837fc89d8ec$export$1f869c99ead9db5f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $0208f837fc89d8ec$var$analyticsPayload,
        href: $0208f837fc89d8ec$var$VIEW_ALL_STARRED_FILTERS_HREF
    }, formatMessage((0, $4ABV3.messages).viewAllStarredFilters)));
};

});
parcelRegister("jUReQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9363fe5268fd6910$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb56e1e6bcabd6407e4fcb2c88f43e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9363fe5268fd6910$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v2 = {
        "kind": "FragmentSpread",
        "name": "filterItem_navigationAppsSidebarCommon"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "starredFiltersList_navigationAppsSidebarCommon",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "favouriteFilters",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                    "sort": {
                                        "order": "DESC"
                                    },
                                    "type": "FILTER"
                                }
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 15
                            }
                        ],
                        "concreteType": "JiraFavouriteConnection",
                        "kind": "LinkedField",
                        "name": "favourites",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraFavouriteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "type": "JiraFilter",
                                                "abstractKey": "__isJiraFilter"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "alias": "favouriteFiltersOld",
                        "args": [
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraFilterConnection",
                        "kind": "LinkedField",
                        "name": "favouriteFilters",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraFilterEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$9363fe5268fd6910$var$node.hash = "900a854eaff0335a83067c20ea0c3e72";
var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;

});

parcelRegister("b2GBS", function(module, exports) {

$parcel$export(module.exports, "useFavoritesChangeEffect", () => $0fca8b6d7b43f931$export$659f59218fc5dd14);

var $5uXOq = parcelRequire("5uXOq");

var $4f8Oj = parcelRequire("4f8Oj");

var $4041n = parcelRequire("4041n");

var $1XJ20 = parcelRequire("1XJ20");
const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $1XJ20.usePreviousWithInitial)(hasPendingChanges);
    (0, $5uXOq.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});
parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $011794d66b906d20$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $5uXOq.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("kZDjT", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $f981c975abc56594$export$3cf161fcd24b6b4f);

var $lE53e = parcelRequire("lE53e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k0ZZ2 = parcelRequire("k0ZZ2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $lE53e.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $f981c975abc56594$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("lE53e", function(module, exports) {

$parcel$export(module.exports, "default", () => $251d70d9349441ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $251d70d9349441ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;

});


parcelRegister("4ABV3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f94c0f775539d45d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f94c0f775539d45d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    },
    viewAllStarredFilters: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.view-all-starred-filters",
        "defaultMessage": "View all starred filters"
    }
});

});



parcelRegister("6KxGW", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersErrorFallback", () => $48c59f757828f109$export$70765d6359132b82);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $92Z2l = parcelRequire("92Z2l");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $b1xML = parcelRequire("b1xML");
const $48c59f757828f109$export$70765d6359132b82 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48c59f757828f109$var$SectionWrapper, {
        // TODO remove SectionWrapper once @atlaskit/section design gets updated
        title: formatMessage((0, $b1xML.default).starredFiltersHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, formatMessage((0, $b1xML.default).errorMessage, {
        link: (linkText)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>window.location.reload()
            }, linkText)
    })));
};
// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48c59f757828f109$var$SectionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gjTBi.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt3i2wt _euf41fxt _1qdg1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("dg0Fl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a6d49390b09b82e$var$_react = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a6d49390b09b82e$var$_questionCircle = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("8nk07")));

var $9a6d49390b09b82e$var$_questionCircle2 = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("eJS47")));
function $9a6d49390b09b82e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a6d49390b09b82e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $9a6d49390b09b82e$var$_react.default.createElement($9a6d49390b09b82e$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $9a6d49390b09b82e$var$_questionCircle2.default
    }, props));
$9a6d49390b09b82e$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $9a6d49390b09b82e$var$_default = module.exports.default = $9a6d49390b09b82e$var$QuestionCircleIcon;

});
parcelRegister("8nk07", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618ffc7dfbf067c7$var$_react = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $618ffc7dfbf067c7$var$_baseNew = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $618ffc7dfbf067c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618ffc7dfbf067c7$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $618ffc7dfbf067c7$var$_react.default.createElement($618ffc7dfbf067c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$618ffc7dfbf067c7$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $618ffc7dfbf067c7$var$_default = module.exports.default = $618ffc7dfbf067c7$var$QuestionCircleIcon;

});

parcelRegister("eJS47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abaf34f2ab9c61b9$var$_react = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $abaf34f2ab9c61b9$var$_questionCircle = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("8nk07")));
function $abaf34f2ab9c61b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abaf34f2ab9c61b9$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $abaf34f2ab9c61b9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $abaf34f2ab9c61b9$var$_questionCircle.default
    }));
$abaf34f2ab9c61b9$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $abaf34f2ab9c61b9$var$_default = module.exports.default = $abaf34f2ab9c61b9$var$QuestionCircleIcon;

});




parcelRegister("b1xML", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc624d55e9cb181d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dc624d55e9cb181d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
        "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
    },
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});


parcelRegister("8kM72", function(module, exports) {

$parcel$export(module.exports, "useDefaultPinFilters", () => $42363ac07745a31e$export$3c69152f8409a017);

var $5uXOq = parcelRequire("5uXOq");

var $1b36n = parcelRequire("1b36n");

var $2YP9W = parcelRequire("2YP9W");
const $42363ac07745a31e$export$3c69152f8409a017 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $2YP9W.useResource)((0, $1b36n.staticSidebarDefaultPINFiltersResource));
    (0, $5uXOq.useEffect)(()=>{
        if (data == null && error == null && loading === false) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
parcelRegister("1b36n", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $f0c33588b62c7651$export$d3efe54a881807bf);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $elyZV = parcelRequire("elyZV");
const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $2M1hQ.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $elyZV.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("elyZV", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $88433d457c0f5220$export$268c1bcb44a0ddd3);

var $eusud = parcelRequire("eusud");
const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $eusud.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});



parcelRegister("5w5Kh", function(module, exports) {

$parcel$export(module.exports, "DefaultFilters", () => $68067cb39e642d05$export$5df36bcfaa4d1f9d);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $gjTBi = parcelRequire("gjTBi");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $doZTA = parcelRequire("doZTA");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $irHAa = parcelRequire("irHAa");

var $2q4IS = parcelRequire("2q4IS");
const $68067cb39e642d05$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match, location: location }] = (0, $doZTA.useRouter)();
    // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $ebyGx.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).issuesIssueTermRefresh : (0, $irHAa.messages).issues) : titleHeaderText;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $4OCke.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $4OCke.matchUrlParams)([
        'filter'
    ], false);
    // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query URL param should be ignored unless this is for legacy PIN.
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: title
    }, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).ninLayoutAllIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).ninLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allIssuesIssueTermRefresh : (0, $irHAa.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).myOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).myOpenIssues.selectedOn(jql),
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).myOpenIssuesIssueTermRefresh : (0, $irHAa.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).reportedByMe.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).reportedByMe.selectedOn(jql),
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $irHAa.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).notNinLayoutAllIssues.analytics,
        selectedOn: (0, $2q4IS.itemMap).notNinLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allIssuesIssueTermRefresh : (0, $irHAa.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).allOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allOpenIssuesIssueTermRefresh : (0, $irHAa.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).doneIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).doneIssues.selectedOn(jql),
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).doneIssuesIssueTermRefresh : (0, $irHAa.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).viewedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).viewedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $irHAa.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).createdRecently.analytics,
        selectedOn: (0, $2q4IS.itemMap).createdRecently.selectedOn(jql),
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $irHAa.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).resolvedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).resolvedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $irHAa.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).updatedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).updatedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $irHAa.messages).updatedRecently)));
};

});
parcelRegister("irHAa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87feacba5b057fbf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87feacba5b057fbf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
        "defaultMessage": "Updated recently"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    },
    issuesFiltersIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    allIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
        "defaultMessage": "All work items"
    },
    allOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    doneIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    }
});

});

parcelRegister("2q4IS", function(module, exports) {

$parcel$export(module.exports, "itemMap", () => $414ee2dbecb9ba58$export$1072457701b9918d);

var $kvHKs = parcelRequire("kvHKs");

var $4OCke = parcelRequire("4OCke");
const $414ee2dbecb9ba58$export$1596c397510d46b1 = (filter, jql)=>{
    // Initial load
    if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
    if (filter != null && filter !== 'allissues') return false;
    if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
    return false;
};
const $414ee2dbecb9ba58$export$1072457701b9918d = {
    ninLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>(...args)=>$414ee2dbecb9ba58$export$1596c397510d46b1(undefined, '') || (!jql ? (0, $4OCke.matchUrlParams)([
                    'filter'
                ], false)(...args) : false)
    },
    myOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    reportedByMe: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    notNinLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    allOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
    },
    doneIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    viewedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    createdRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    resolvedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    updatedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    }
};

});


parcelRegister("hnmuM", function(module, exports) {

$parcel$export(module.exports, "FiltersFooter", () => $ca4a87e5b79a11b5$export$c131ccfc44bcd85c);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fcEY2 = parcelRequire("fcEY2");
const $ca4a87e5b79a11b5$var$analyticsPayload = {
    itemId: 'pin-manage-filters'
};
const $ca4a87e5b79a11b5$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: hasFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $ca4a87e5b79a11b5$var$analyticsPayload,
        href: "/jira/filters"
    }, formatMessage((0, $fcEY2.messages).viewAllFilters)));
};

});
parcelRegister("fcEY2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $905189d98c72b841$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $905189d98c72b841$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});



parcelRegister("k6yFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $073d14daf21d9ee8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $073d14daf21d9ee8$var$messages = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues-issue-term-refresh",
        "defaultMessage": "All work"
    }
});
var $073d14daf21d9ee8$export$2e2bcd8739ae039 = $073d14daf21d9ee8$var$messages;

});


parcelRegister("chejP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de49251f2394688$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");

var $k0iPT = parcelRequire("k0iPT");

var $6jY6G = parcelRequire("6jY6G");

var $gb5lQ = parcelRequire("gb5lQ");

var $8yg0C = parcelRequire("8yg0C");

var $lPApw = parcelRequire("lPApw");

var $jxrFe = parcelRequire("jxrFe");
const $5de49251f2394688$var$calculateStack = (route, connectStack)=>{
    if ((0, $k0iPT.CONNECT_ROUTES_SET).has(route.name) && connectStack) {
        const [first, ...other] = connectStack;
        // omit the reports nesting level as we render the reports menu
        // as a top level menu in business projects
        if ((0, $gb5lQ.SECTION_ID).REPORTS === first) return other;
        return connectStack;
    }
    return [];
};
const $5de49251f2394688$var$ReportsMenu = ()=>{
    (0, $8yg0C.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $lPApw.useProjectReportsConnectItems)();
    const [stack, setStack] = (0, $5uXOq.useState)(()=>$5de49251f2394688$var$calculateStack(route, connectStack));
    (0, $5uXOq.useEffect)(()=>{
        setStack($5de49251f2394688$var$calculateStack(route, connectStack));
    }, [
        route,
        connectStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxrFe.Reports), {
        connectItems: connectItems
    })));
};
var $5de49251f2394688$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5de49251f2394688$var$ReportsMenu);

});
parcelRegister("jxrFe", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $345de988b64525a0$export$883262dc952d8f59);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $jv9Yy = parcelRequire("jv9Yy");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $9h6Pc = parcelRequire("9h6Pc");

var $eA5Jb = parcelRequire("eA5Jb");

var $bkw8F = parcelRequire("bkw8F");

var $9GoDt = parcelRequire("9GoDt");
const $345de988b64525a0$var$useThrowDefaultReportItemsDI = (0, $7OqB4.withThrowOnError)((0, $eA5Jb.useDefaultReportItems));
const $345de988b64525a0$var$useThrowProjectDI = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $345de988b64525a0$var$useThrowReportFeaturesDI = (0, $7OqB4.withThrowOnError)((0, $bkw8F.useReportFeatures));
const $345de988b64525a0$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, $3tHFY.ConnectMenu), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $gjTBi.default), SkeletonItem: SkeletonItem = (0, $bWqXX.default), connectItems: connectItems, SectionHeader: SectionHeader = (0, $jv9Yy.SectionHeader), matchUrlParams: matchUrlParams = (0, $4OCke.matchUrlParams), useDefaultReportItems: // eslint-disable-next-line react-hooks/react-compiler
useDefaultReportItems = $345de988b64525a0$var$useThrowDefaultReportItemsDI, useIntl: // eslint-disable-next-line react-hooks/react-compiler
useIntl = (0, $koVbs.default), useProject: // eslint-disable-next-line react-hooks/react-compiler
useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: // eslint-disable-next-line react-hooks/react-compiler
useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345de988b64525a0$var$ReportsSidebar, {
        ConnectMenu: ConnectMenu,
        MenuItem: MenuItem,
        Section: Section,
        SkeletonItem: SkeletonItem,
        connectItems: connectItems,
        SectionHeader: SectionHeader,
        matchUrlParams: matchUrlParams,
        // eslint-disable-next-line react-hooks/react-compiler
        useDefaultReportItems: useDefaultReportItems,
        // eslint-disable-next-line react-hooks/react-compiler
        useIntl: useIntl,
        // eslint-disable-next-line react-hooks/react-compiler
        useProject: useProject,
        // eslint-disable-next-line react-hooks/react-compiler
        useReportFeatures: useReportFeatures
    }));
};
const $345de988b64525a0$var$ReportsSidebar = ({ ConnectMenu: ConnectMenu = (0, $3tHFY.ConnectMenu), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $gjTBi.default), SkeletonItem: SkeletonItem = (0, $bWqXX.default), connectItems: connectItems, SectionHeader: SectionHeader = (0, $jv9Yy.SectionHeader), matchUrlParams: matchUrlParams = (0, $4OCke.matchUrlParams), useDefaultReportItems: // eslint-disable-next-line react-hooks/react-compiler
useDefaultReportItems = $345de988b64525a0$var$useThrowDefaultReportItemsDI, useIntl: // eslint-disable-next-line react-hooks/react-compiler
useIntl = (0, $koVbs.default), useProject: // eslint-disable-next-line react-hooks/react-compiler
useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: // eslint-disable-next-line react-hooks/react-compiler
useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
    const baseUrl = '';
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: defaultItems } = useDefaultReportItems();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: features } = useReportFeatures();
    // eslint-disable-next-line react-hooks/react-compiler
    const { formatMessage: formatMessage } = useIntl();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: project } = useProject();
    if (project == null || features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    const createReportUrl = (0, $9h6Pc.createReportUrlFunc)({
        baseUrl: baseUrl,
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, defaultItems && defaultItems.items.length > 0 && // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        id: defaultItems.id,
        key: defaultItems.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            key: item.id,
            analytics: {
                itemId: item.id
            },
            selectedOn: matchUrlParams([
                'reportKey'
            ]),
            href: item.url
        }, item.name != null ? item.name : null))), features && features.hasForcastSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, $9GoDt.default).forecastAndManagement)), features.hasTimeTracking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'time-tracking'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $9GoDt.default).timeTracking)), features.hasDeveloperWorkload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'developer-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $9GoDt.default).userWorkload)), features.hasVersionWorkloadReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'version-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $9GoDt.default).versionWorkload))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, $9GoDt.default).other)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'workloadpie'
        },
        href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $9GoDt.default).workloadPieChart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: (0, $4R6GH.fg)('reports-overview-page-migration') ? `/jira/core/projects/${project.key}/reports` : `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                title: formatMessage((0, $9GoDt.default).itemBack)
            }
        }
    })));
};

});
parcelRegister("9h6Pc", function(module, exports) {

$parcel$export(module.exports, "createReportUrlFunc", () => $14ad3153b403c86e$export$fe91ad5e718e4335);
const $14ad3153b403c86e$export$fe91ad5e718e4335 = ({ project: project })=>(reportKey)=>`/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;

});

parcelRegister("eA5Jb", function(module, exports) {

$parcel$export(module.exports, "useDefaultReportItems", () => $b47a0bfc5b0d2f58$export$ab2e8832e8916e83);

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lpwtK = parcelRequire("lpwtK");

var $9h6Pc = parcelRequire("9h6Pc");

var $cnn8W = parcelRequire("cnn8W");
const $b47a0bfc5b0d2f58$export$ab2e8832e8916e83 = ()=>{
    const baseUrl = '';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project, loading: loading, error: error } = (0, $lpwtK.useProject)();
    let defaultIssueAnalysisSection = null;
    if (project) {
        const createReportUrl = (0, $9h6Pc.createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        defaultIssueAnalysisSection = {
            name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cnn8W.default).issueAnalysisIssueTermRefresh : (0, $cnn8W.default).issueAnalysis),
            id: 'issue-analysis-sidebar-links',
            items: [
                {
                    id: 'averageage-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                    name: formatMessage((0, $cnn8W.default).averageAgeReport)
                },
                {
                    id: 'createdvsresolved-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                    name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cnn8W.default).createdResolvedIssuesReportIssueTermRefresh : (0, $cnn8W.default).createdResolvedIssuesReport)
                },
                {
                    id: 'pie-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                    name: formatMessage((0, $cnn8W.default).pieChart)
                },
                {
                    id: 'recentlycreated-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                    name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cnn8W.default).recentlyCreatedIssuesIssueTermRefresh : (0, $cnn8W.default).recentlyCreatedIssues)
                },
                {
                    id: 'resolutiontime-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                    name: formatMessage((0, $cnn8W.default).resolutionTime)
                },
                {
                    id: 'singlelevelgroupby',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                    name: formatMessage((0, $cnn8W.default).singleLevelGroup)
                },
                {
                    id: 'timesince-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                    name: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cnn8W.default).timeSinceIssuesIssueTermRefresh : (0, $cnn8W.default).timeSinceIssues)
                }
            ]
        };
    }
    return {
        data: defaultIssueAnalysisSection,
        loading: loading,
        error: error
    };
};

});
parcelRegister("cnn8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f93c3dbd2e4c3a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7f93c3dbd2e4c3a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueAnalysis: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
        "defaultMessage": "Issue analysis"
    },
    averageAgeReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
        "defaultMessage": "Average Age Report"
    },
    createdResolvedIssuesReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
        "defaultMessage": "Created vs Resolved Issues Report"
    },
    pieChart: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
        "defaultMessage": "Pie Chart Report"
    },
    recentlyCreatedIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
        "defaultMessage": "Recently Created Issues Report"
    },
    resolutionTime: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
        "defaultMessage": "Resolution Time Report"
    },
    singleLevelGroup: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
        "defaultMessage": "Single Level Group By Report"
    },
    timeSinceIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
        "defaultMessage": "Time Since Issues Report"
    },
    issueAnalysisIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis-issue-term-refresh",
        "defaultMessage": "Work item analysis"
    },
    createdResolvedIssuesReportIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report-issue-term-refresh",
        "defaultMessage": "Created vs resolved work items report"
    },
    recentlyCreatedIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues-issue-term-refresh",
        "defaultMessage": "Recently created work items report"
    },
    timeSinceIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues-issue-term-refresh",
        "defaultMessage": "Time since work items report"
    }
});

});


parcelRegister("9GoDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $98779022895d106f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98779022895d106f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forecastAndManagement: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
        "defaultMessage": "Forecast & management"
    },
    timeTracking: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
        "defaultMessage": "Time Tracking Report"
    },
    userWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
        "defaultMessage": "User Workload Report"
    },
    versionWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
        "defaultMessage": "Version Workload Report"
    },
    workloadPieChart: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
        "defaultMessage": "Workload Pie Chart Report"
    },
    other: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
        "defaultMessage": "Other"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
        "defaultMessage": "Back to reports"
    }
});

});



parcelRegister("9nNLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a0ff13f8a11c35$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");

var $k0iPT = parcelRequire("k0iPT");

var $6jY6G = parcelRequire("6jY6G");

var $gb5lQ = parcelRequire("gb5lQ");

var $8yg0C = parcelRequire("8yg0C");

var $lPApw = parcelRequire("lPApw");

var $3wt3Q = parcelRequire("3wt3Q");

var $4rn3K = parcelRequire("4rn3K");
const $90a0ff13f8a11c35$var$EMPTY_STACK = [];
const $90a0ff13f8a11c35$var$adjustAppStack = (appStack)=>{
    const [first, ...other] = appStack;
    // omit the settings nesting level as we render the settings menu
    // as a top level menu in business projects
    if ((0, $gb5lQ.SECTION_ID).SETTINGS === first) return other;
    return appStack;
};
const $90a0ff13f8a11c35$var$calculateStack = (route, connectStack, forgeStack)=>{
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $gb5lQ.FORGE_ROUTES_SET).has(route.name) && forgeStack) return $90a0ff13f8a11c35$var$adjustAppStack(forgeStack);
    if (route.name.includes('project-settings-core')) {
        // this is the same logic as the one in src/packages/navigation-apps/sidebar/next-gen/src/ui/menu/main.js
        const [view] = route.name.replace(`${'project-settings-core'}-`, '').split('-');
        return view === 'issuetypes' ? [
            view
        ] : $90a0ff13f8a11c35$var$EMPTY_STACK;
    }
    if ((0, $k0iPT.CONNECT_ROUTES_SET).has(route.name) && connectStack) return $90a0ff13f8a11c35$var$adjustAppStack(connectStack);
    return $90a0ff13f8a11c35$var$EMPTY_STACK;
};
const $90a0ff13f8a11c35$var$SettingsMenu = ({ project: project })=>{
    (0, $8yg0C.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $lPApw.useProjectSettingsConnectItems)();
    const { data: forgeItems, stack: forgeStack } = (0, $lPApw.useProjectSettingsForgeItems)('project-settings-core-forge-apps', $90a0ff13f8a11c35$var$EMPTY_STACK);
    const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
            forge: forgeItems,
            connect: connectItems
        }), [
        forgeItems,
        connectItems
    ]);
    const [stack, setStack] = (0, $5uXOq.useState)(()=>$90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
    (0, $5uXOq.useEffect)(()=>{
        setStack($90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, project.isSimplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wt3Q.SettingsMenu), {
        stack: stack
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4rn3K.Settings), {
        ecosystemItems: ecosystemItems
    }))));
};
var $90a0ff13f8a11c35$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($90a0ff13f8a11c35$var$SettingsMenu);

});
parcelRegister("3wt3Q", function(module, exports) {

$parcel$export(module.exports, "SettingsMenu", () => $26eff467887b13fc$export$1d7840d5cdc861d5);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $xc3fY = parcelRequire("xc3fY");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $kZj7F = parcelRequire("kZj7F");

var $71bFU = parcelRequire("71bFU");

var $3SzZi = parcelRequire("3SzZi");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $02Psx = parcelRequire("02Psx");

var $j9iVo = parcelRequire("j9iVo");

var $cSUZZ = parcelRequire("cSUZZ");

var $daoB1 = parcelRequire("daoB1");

var $6EZeH = parcelRequire("6EZeH");

var $6s1PB = parcelRequire("6s1PB");

var $gb5lQ = parcelRequire("gb5lQ");

var $bkw8F = parcelRequire("bkw8F");

var $9DEd8 = parcelRequire("9DEd8");

var $7OvX8 = parcelRequire("7OvX8");

var $1tmBf = parcelRequire("1tmBf");

var $17zko = parcelRequire("17zko");
const $26eff467887b13fc$export$a4007dc4843ca7f6 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $26eff467887b13fc$var$DisplayNotificationsOptions = ({ hasCoreAccess: hasCoreAccess, formatMessage: formatMessage, baseSettingsUrl: baseSettingsUrl, projectId: projectId })=>{
    if (!hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        menuItemLabel: formatMessage((0, $17zko.messages).itemNotifications),
        forceExpand: true,
        submenuId: "core-notifications-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71bFU.NotificationsSubMenu), {
        settingsUrl: `${baseSettingsUrl}/notifications`,
        issueLogsUrl: `${baseSettingsUrl}/notifications/issue-logs?projectId=${projectId}`
    }));
};
const $26eff467887b13fc$export$c72f6eaae7b9adff = ({ stack: stack })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
    const { hasCoreAccess: hasCoreAccess } = (0, $daoB1.useApplicationPermissions)();
    const hasDlpEnabled = (0, $6EZeH.useDlpEntitlement)();
    const isPremiumUserSeat = (0, $cSUZZ.useIsPremiumUserSeat)();
    const { data: settingFeatures } = (0, $bkw8F.useSettingFeatures)();
    const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, $j9iVo.useConnectApps)();
    // to remove on isAppControlsEnabled() cleanup
    (0, $5uXOq.useEffect)(()=>{
        if (project && !connectAppsData) fetchConnectApps(project.key);
    }, [
        connectAppsData,
        fetchConnectApps,
        project
    ]);
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.CORE_PROJECT), project.key);
    const showCoreForms = (0, $4R6GH.fg)('proforma_mvp_jwm_project_settings') && hasCoreAccess;
    const BackMenuItem = {
        href: baseSettingsUrl,
        title: formatMessage((0, $17zko.messages).title)
    };
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $17zko.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseSettingsUrl}/details`
    }, formatMessage((0, $17zko.messages).itemDetails)), hasCoreAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'access'
        },
        href: `${baseSettingsUrl}/access`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $17zko.messages).itemAccess)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$var$DisplayNotificationsOptions, {
        hasCoreAccess: hasCoreAccess,
        formatMessage: formatMessage,
        baseSettingsUrl: baseSettingsUrl,
        projectId: project.id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseSettingsUrl}/automation`
    }, formatMessage((0, $17zko.messages).automation)), hasCoreAccess && settingFeatures?.hasProjectEfaFields && expConfig.get('isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'fields'
        },
        href: `${baseSettingsUrl}/fields`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $17zko.messages).itemFieldsNonFinal)), (0, $3SzZi.shouldRenderNesting)(hasCoreAccess, stack, (0, $gb5lQ.SECTION_ID).ISSUE_TYPES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'issuetypes'
        },
        href: `${baseSettingsUrl}/issuetypes`,
        id: (0, $gb5lQ.SECTION_ID).ISSUE_TYPES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $17zko.messages).itemIssueTypesIssueTermRefresh : (0, $17zko.messages).itemIssueTypes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tmBf.IssueTypes), null)), isPremiumUserSeat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'approvals'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseSettingsUrl}/approvals`
    }, formatMessage((0, $17zko.messages).itemApprovals)), showCoreForms && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseSettingsUrl}/forms`
    }, formatMessage((0, $17zko.messages).itemAdvancedForms)), (0, $3SzZi.shouldRenderNesting)(hasCoreAccess, stack, 'apps') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'apps'
        },
        menuItemLabel: formatMessage((0, $7OvX8.messages).apps),
        forceExpand: true,
        submenuId: "nextgen-apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DEd8.EcosystemAppsMenu), null)), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'data-classification'
        },
        href: `${baseSettingsUrl}/data-classifications`,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $17zko.messages).dataClassificationNonFinal))));
};
const $26eff467887b13fc$export$1d7840d5cdc861d5 = (props)=>{
    const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return(// to remove on isAppControlsEnabled() cleanup
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j9iVo.ConnectAppsContainer), {
        onError: undefined,
        scope: project.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$export$c72f6eaae7b9adff, props)));
};

});
parcelRegister("xc3fY", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubmenuItem", () => $dec8d2ea50472f86$export$16ba9a3b96f3ac6d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fXJBp = parcelRequire("fXJBp");

var $k0ZZ2 = parcelRequire("k0ZZ2");
const $dec8d2ea50472f86$var$defaultExpandMenuState = {
    submenuActive: false,
    expanded: false
};
const $dec8d2ea50472f86$export$e5a6b8291f2460bc = ()=>{
    const getExpandableState = (submenuId)=>{
        const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
        let parsedCookieData = null;
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parsedCookieData = JSON.parse(cookieData);
        } catch  {
            // Rather than throw an error - just set the default state
            parsedCookieData = $dec8d2ea50472f86$var$defaultExpandMenuState;
        }
        return parsedCookieData;
    };
    const setExpandedState = (submenuId, newExpandedState)=>{
        if (submenuId != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
    };
    return {
        getExpandableState: getExpandableState,
        setExpandedState: setExpandedState
    };
};
const $dec8d2ea50472f86$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $dec8d2ea50472f86$export$e5a6b8291f2460bc();
    const [subMenuActive, setSubMenuActive] = (0, $5uXOq.useState)(false);
    const [currentCookieData] = (0, $5uXOq.useState)(getExpandableState(submenuId));
    const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
    const [expanded, setExpanded] = (0, $5uXOq.useState)(forceExpand);
    const expandableMenuItemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (currentCookieData?.expanded) {
            setExpanded(currentCookieData.expanded);
            setSubMenuActive(currentCookieData.submenuActive);
        }
    }, [
        currentCookieData
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (submenuId != null) setExpandedState(submenuId, {
            submenuActive: false,
            expanded: !expanded
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
            expandMenuId: analytics?.itemId,
            expanded: !expanded
        });
        setExpanded(!expanded);
        requestAnimationFrame(()=>{
            expandableMenuItemRef?.current?.focus();
        });
    }, [
        analytics,
        createAnalyticsEvent,
        expanded,
        setExpandedState,
        submenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuWrapper, {
        isExpanded: subMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: analytics,
        href: href,
        useButtonLink: useButtonLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXJBp.ExpandButton), {
            id: expandButtonId,
            label: expandButtonLabel,
            isActive: true,
            isExpanded: expanded,
            size: "medium"
        }), iconBefore),
        onClick: onClick,
        "data-test-id": testId,
        ref: expandableMenuItemRef,
        tabIndex: -1
    }, menuItemLabel), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper, {
        noListStyle: noListStyle
    }, children));
};
// Buttons inside the Expandable Menu indicate sub-expandable menus,
// these are styled differently that top level expandable menu items so the aligment look ok
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dec8d2ea50472f86$var$ExpandableSubmenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
            __cmplp.isExpanded && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fXJBp", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $iy9RA = parcelRequire("iy9RA");

var $bpC55 = parcelRequire("bpC55");

var $MHKc7 = parcelRequire("MHKc7");

var $dCm1o = parcelRequire("dCm1o");
const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const ChevronOld = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))) : (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)));
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))) : (0, (/*@__PURE__*/$parcel$interopDefault($bpC55)));
    const onKeydown = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        padding: "space.075",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
        testId: `sidebar.expand-button.container-${id}`,
        color: "var(--ds-icon, #44546F)",
        label: label,
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: "var(--ds-icon, #44546F)",
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3120c1c485e5e18$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _kqswh2mm _4t3i1osq _bfhk18uv _80omtlke _1spjglyw _1ejjufon _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("71bFU", function(module, exports) {

$parcel$export(module.exports, "NotificationsSubMenu", () => $4606ea7b05b7e72d$export$f80567459a5e304a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $aYAc3 = parcelRequire("aYAc3");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bWqXX = parcelRequire("bWqXX");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $icKiA = parcelRequire("icKiA");
const $4606ea7b05b7e72d$export$51b1383ef8844a7 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY = 'issue-email-log-spotlight';
const $4606ea7b05b7e72d$export$f80567459a5e304a = ({ settingsUrl: settingsUrl, issueLogsUrl: issueLogsUrl, displayLozenge: displayLozenge = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { data: project, loading: projectLoading } = $4606ea7b05b7e72d$export$51b1383ef8844a7();
    if (projectLoading || !project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notifications-settings'
        },
        href: settingsUrl,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $icKiA.messages).itemSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notifications-issue-logs'
        },
        href: issueLogsUrl,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4606ea7b05b7e72d$var$issueLogsContainerStyles
    }, formatMessage((0, $icKiA.messages).itemProjectEmailAuditLogs), displayLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $icKiA.messages).newLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
};
const $4606ea7b05b7e72d$var$issueLogsContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("icKiA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0ac4b8c96850fb1d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0ac4b8c96850fb1d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemSettings: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-settings",
        "defaultMessage": "Settings"
    },
    itemProjectEmailAuditLogs: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-project-email-audit-logs",
        "defaultMessage": "Project email audit"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("3SzZi", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $956cef61e43b05f1$export$a35baff1c4efd3da);
const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("02Psx", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $a59737cd16881573$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $a59737cd16881573$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $a59737cd16881573$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $a59737cd16881573$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $a59737cd16881573$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $a59737cd16881573$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $a59737cd16881573$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $a59737cd16881573$export$dad567762dae162e);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $2X0eJ = parcelRequire("2X0eJ");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: (0, $4R6GH.fg)('jcs_project_type_m3') ? 'servicedesk' : 'customerservice',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('urls'), (0, $gl0PU.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
};
const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $2vSU6.SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;

});
parcelRegister("2X0eJ", function(module, exports) {

$parcel$export(module.exports, "serializeBackLink", () => $b75ea0cca9bceab1$export$abebef1e474c32c5);
$parcel$export(module.exports, "getHrefWithBackLink", () => $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd);
/**
 * When users complete task in SWIFT settings page, a UI flag shows and says "Go back to X"
 * This object configures the URL and _translated_ link text of the UI flag.
 *
 * If this backlink is not configured then SWIFT uses some default text ("Go to project") or similar.
 * Each project type has its own defaults: configured in Product features
 *
 * See https://hello.atlassian.net/wiki/spaces/JPCE/pages/700125807/SWIFT+backlinks
 */ const $b75ea0cca9bceab1$export$abebef1e474c32c5 = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd = (href, title)=>{
    if (!href || !href.length) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname, search: search } = window.location;
    const backlinkData = {
        // url and title are not using encodeURIComponent here because it will be serialized later.
        url: `${pathname}${search}`,
        title: title
    };
    const backlink = $b75ea0cca9bceab1$export$abebef1e474c32c5(backlinkData);
    return `${href}${backlink}`;
};

});

parcelRegister("3XO6n", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $594ec5369f29a734$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $594ec5369f29a734$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $594ec5369f29a734$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $594ec5369f29a734$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $594ec5369f29a734$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $594ec5369f29a734$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $594ec5369f29a734$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $594ec5369f29a734$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $594ec5369f29a734$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $594ec5369f29a734$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $594ec5369f29a734$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $594ec5369f29a734$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $594ec5369f29a734$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $594ec5369f29a734$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_APP_NAME", () => $594ec5369f29a734$export$b36025abb367eace);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $594ec5369f29a734$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $594ec5369f29a734$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $594ec5369f29a734$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $594ec5369f29a734$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $594ec5369f29a734$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $594ec5369f29a734$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $594ec5369f29a734$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $594ec5369f29a734$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $594ec5369f29a734$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $594ec5369f29a734$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $594ec5369f29a734$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $594ec5369f29a734$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $594ec5369f29a734$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $594ec5369f29a734$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $594ec5369f29a734$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $594ec5369f29a734$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $594ec5369f29a734$export$ac655f5b3ff7b929);
// Issue Type Templates

var $lzeFL = parcelRequire("lzeFL");

var $5fc53 = parcelRequire("5fc53");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7qPn9 = parcelRequire("7qPn9");

var $5fc53 = parcelRequire("5fc53");
const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
const $594ec5369f29a734$export$952581bc40160893 = 'custom';
const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
    $594ec5369f29a734$export$9355e489ad16f98e,
    $594ec5369f29a734$export$bcf558c186108044,
    $594ec5369f29a734$export$1ea39a3ae330045,
    $594ec5369f29a734$export$3cb4a99a332e4186
];
const $594ec5369f29a734$export$39cd48613b53ce2f = (0, $5fc53.TEXT_AREA_CF_TYPE);
const $594ec5369f29a734$export$56eae1056efd4899 = (0, $5fc53.DESCRIPTION_TYPE);
const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, $5fc53.ENVIRONMENT_TYPE);
const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
    $594ec5369f29a734$export$56eae1056efd4899,
    $594ec5369f29a734$export$39cd48613b53ce2f,
    $594ec5369f29a734$export$ca61f05d869b2ea3
];
const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $594ec5369f29a734$export$b36025abb367eace = 'Jira Customer Service';
const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
const $594ec5369f29a734$export$d77765147749db6b = 'select';
const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $ldyPw.populateApplicationEditions)(),
        appPermissions: (0, $7qPn9.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        baseUrl: '',
        cloudId: (0, $g5X3G.toCloudId)(''),
        activationId: (0, $g5X3G.toActivationId)(''),
        cloudName: (0, $g5X3G.toCloudName)(''),
        devopsProjectSignupSource: (0, $g5X3G.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $ef5Xn.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $lzeFL.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false,
            customerService: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null,
        cmdbDisabledInFedRAMP: null
    });

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $81f079589240b9b7$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $81f079589240b9b7$export$f4909db381566ce3);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $81f079589240b9b7$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $81f079589240b9b7$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $81f079589240b9b7$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $81f079589240b9b7$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $81f079589240b9b7$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $81f079589240b9b7$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $81f079589240b9b7$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $81f079589240b9b7$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $81f079589240b9b7$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $2YZCu.default).unsafeErrorWithCustomerData(location, message, error);
};

});


parcelRegister("j9iVo", function(module, exports) {

$parcel$export(module.exports, "ConnectAppsSubscriber", () => $1d2a37fb0b2cedf7$export$2646f920b0e2e4de);
$parcel$export(module.exports, "useConnectApps", () => $1d2a37fb0b2cedf7$export$4864478dcab77643);
$parcel$export(module.exports, "ConnectAppsContainer", () => $1d2a37fb0b2cedf7$export$ac845603c8c91acd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7YSUx = parcelRequire("7YSUx");

const $1d2a37fb0b2cedf7$export$2646f920b0e2e4de = (0, $51nlc.createSubscriber)((0, $7YSUx.default), {
    displayName: 'ConnectAppsSubscriber'
});
const $1d2a37fb0b2cedf7$export$4864478dcab77643 = (0, $3sQ5x.createHook)((0, $7YSUx.default));
const $1d2a37fb0b2cedf7$export$ac845603c8c91acd = (0, $gg7kZ.createContainer)((0, $7YSUx.default));

});
parcelRegister("7YSUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bdb3f5fb2a260df$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $76t3Y = parcelRequire("76t3Y");
const $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null,
    hasFirstError: false
};
var $3bdb3f5fb2a260df$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'connect-apps',
    initialState: $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a,
    actions: $76t3Y.actions
});

});
parcelRegister("76t3Y", function(module, exports) {

$parcel$export(module.exports, "actions", () => $183a508abf4e51e7$export$e324594224ef24da);

var $8VvCU = parcelRequire("8VvCU");
const $183a508abf4e51e7$export$e324594224ef24da = {
    fetch: $8VvCU.default
};

});
parcelRegister("8VvCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b005bb27151e101$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $2FYaA = parcelRequire("2FYaA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b005bb27151e101$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { onError: onError })=>{
        const currentState = getState();
        if (!projectKey || currentState.loading) return;
        setState({
            loading: true,
            error: null
        });
        try {
            const data = await (0, $2FYaA.default)(projectKey);
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { hasFirstError: hasFirstError, data: data } = getState();
            // It's the first error if it does not already have a first error and there is no data currently in state
            const isFirstError = !hasFirstError && data === null;
            setState({
                error: err,
                loading: false,
                hasFirstError: hasFirstError || isFirstError
            });
            if (onError) onError(isFirstError);
        }
    };

});
parcelRegister("2FYaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $27cd0e7e45645bce$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $lVlV8 = parcelRequire("lVlV8");
const $27cd0e7e45645bce$export$43bc37ac3360968f = (projectKey)=>`/rest/internal/2/connectprojectconfig/${projectKey}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$27cd0e7e45645bce$export$2e2bcd8739ae039 = (projectKey)=>{
    const fetchPromise = (0, $koFzm.famaCatchAndLogFetchError)((0, $7f4tk.default)($27cd0e7e45645bce$export$43bc37ac3360968f(projectKey)), (0, $lVlV8.PACKAGE_NAME), (0, $gl0PU.toErrorId)('getConnectApps'), (0, $gl0PU.toErrorMessage)('Failed to fetch connect apps for a project'));
    return fetchPromise.then((response)=>response.map((app)=>{
            // Server returns JSON as a string inside JSON as a string inside JSON as a string because reasons.
            // Let's parse it here
            const options = JSON.parse(app.iframe.options);
            const myApp = {
                title: app.title,
                id: options.uniqueKey,
                connectIframeProps: {
                    addon_key: app.iframe.addonKey,
                    key: app.iframe.moduleKey,
                    url: options.url,
                    options: {
                        ...options,
                        productContext: JSON.parse(options.productCtx),
                        structuredContext: JSON.parse(options.structuredContext),
                        user: {
                            uid: options.uid,
                            ukey: options.ukey,
                            timeZone: options.timeZone
                        }
                    }
                }
            };
            return myApp;
        }));
};

});
parcelRegister("koFzm", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $eb8b95f475174133$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $eb8b95f475174133$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $1RLjE = parcelRequire("1RLjE");
const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $jJZqs.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
        (0, $1RLjE.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;

});

parcelRegister("lVlV8", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $418c76e16c63cf92$export$d76071d5de2774fc);
$parcel$export(module.exports, "PACKAGE_NAME", () => $418c76e16c63cf92$export$b8b9d90f9e5bd72b);

var $3XO6n = parcelRequire("3XO6n");
const $418c76e16c63cf92$export$d76071d5de2774fc = 'project-settings/connect-apps';
const $418c76e16c63cf92$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsConnectApps');

});






parcelRegister("6EZeH", function(module, exports) {

$parcel$export(module.exports, "useDlpEntitlement", () => $c4c8661954b324b0$export$4472465702535e7);

var $9OXo1 = parcelRequire("9OXo1");
const $c4c8661954b324b0$export$4472465702535e7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.hasDlpEnabled || false;
};

});

parcelRegister("9DEd8", function(module, exports) {

$parcel$export(module.exports, "EcosystemAppsMenu", () => $865dc24bed436cec$export$e583660e6ee09caf);

var $5uXOq = parcelRequire("5uXOq");

var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $aHv3X = parcelRequire("aHv3X");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $4OCke = parcelRequire("4OCke");

var $k51JQ = parcelRequire("k51JQ");

var $6hMYg = parcelRequire("6hMYg");

var $02Psx = parcelRequire("02Psx");

var $j9iVo = parcelRequire("j9iVo");

var $gb5lQ = parcelRequire("gb5lQ");

var $7OvX8 = parcelRequire("7OvX8");
const $865dc24bed436cec$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ data: connectAppsData, loading: connectLoading }] = (0, $j9iVo.useConnectApps)();
    const { data: forgeApps, loading: forgeLoading } = (0, $6hMYg.useProjectSettingsForgeAppsForMenu)();
    const filteredConnectAppsData = (0, $5uXOq.useMemo)(()=>connectAppsData?.filter((app)=>!(app?.connectIframeProps?.addon_key === (0, $gb5lQ.JIRA_AUTOMATION_ADDON_KEY) || app?.connectIframeProps?.addon_key === (0, $gb5lQ.JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY))), [
        connectAppsData
    ]);
    const sortedApps = (0, $5uXOq.useMemo)(()=>[
            ...(forgeApps || []).map((app)=>({
                    type: 'forge',
                    name: app.name,
                    app: app
                })),
            ...(filteredConnectAppsData || []).map((app)=>({
                    type: 'connect',
                    name: app.title,
                    app: app
                }))
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        forgeApps,
        filteredConnectAppsData
    ]);
    const overrides = (0, $5uXOq.useMemo)(()=>({
            BackMenuItem: {
                href: `/jira/core/projects/${projectKey}/settings`,
                title: formatMessage((0, $7OvX8.messages).backItem),
                onClick: (ev)=>ev.preventDefault()
            }
        }), [
        projectKey,
        formatMessage
    ]);
    if (connectLoading || forgeLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, sortedApps.map((ecosystemItem)=>{
        const { type: type, app: app } = ecosystemItem;
        if (type === 'forge') {
            const item = app;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
                key: item.id,
                ...item,
                showIcon: false,
                overrides: overrides
            });
        }
        const connectApp = app;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: connectApp.id
            },
            key: connectApp.id,
            href: `${baseSettingsUrl}/apps/${connectApp.id}`,
            selectedOn: (0, $4OCke.matchUrlPathname)()
        }, connectApp.title);
    }), forgeApps?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
        }
    }) : null);
};
const $865dc24bed436cec$export$e583660e6ee09caf = (props)=>{
    const { children: children } = props;
    const { data: project } = (0, $lpwtK.useProject)();
    const projectKey = project && project.key || ''; // flow
    const baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.CORE_PROJECT), projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHv3X.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j9iVo.ConnectAppsContainer), {
        onError: undefined,
        scope: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($865dc24bed436cec$export$c62cfdba33f43c7e, {
        baseSettingsUrl: baseSettingsUrl,
        projectKey: projectKey
    }), children != null && children));
};

});
parcelRegister("aHv3X", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $de4af379e202f62d$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $de4af379e202f62d$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $de4af379e202f62d$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $de4af379e202f62d$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("7OvX8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $43a11d7b95b850bb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $43a11d7b95b850bb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    apps: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
        "defaultMessage": "Apps"
    },
    appFields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
        "defaultMessage": "App fields"
    },
    backItem: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
        "defaultMessage": "Back"
    }
});

});


parcelRegister("1tmBf", function(module, exports) {

$parcel$export(module.exports, "IssueTypes", () => $b746059f9b32cf5c$export$15fef796fc6acc30);

var $5uXOq = parcelRequire("5uXOq");

var $99M5v = parcelRequire("99M5v");

var $gjTBi = parcelRequire("gjTBi");

var $3bDjY = parcelRequire("3bDjY");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $h9XlT = parcelRequire("h9XlT");

var $lGo7j = parcelRequire("lGo7j");

var $7OqB4 = parcelRequire("7OqB4");

var $4ya5m = parcelRequire("4ya5m");

var $02Psx = parcelRequire("02Psx");

var $kIafm = parcelRequire("kIafm");

var $afIXj = parcelRequire("afIXj");
const $b746059f9b32cf5c$export$a4007dc4843ca7f6 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $b746059f9b32cf5c$export$15fef796fc6acc30 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, $kIafm.useIssueTypesNavigationItems)();
    const [, addIssueTypesContextActions] = (0, $4ya5m.useAddIssueTypeContext)();
    const { data: project } = $b746059f9b32cf5c$export$a4007dc4843ca7f6();
    let baseSettingsUrl = '';
    if (project !== null) baseSettingsUrl = (0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.CORE_PROJECT), project.key);
    const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
    const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
    if (!project || !isReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $afIXj.default).issueTypesIssueTermRefresh : (0, $afIXj.default).issueTypes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9XlT.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: false,
        navigationItems: topLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9XlT.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: baseLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9XlT.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: bottomLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, (()=>{
        const addItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'add-issue-type'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                spacing: "spacious",
                label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $afIXj.default).addIssueTypeIssueTermRefresh : (0, $afIXj.default).addIssueType)
            }),
            isDisabled: isAddIssueTypeDisabled,
            onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $afIXj.default).addIssueTypeIssueTermRefresh : (0, $afIXj.default).addIssueType));
        return addIssueTypeTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: addIssueTypeTooltip
        }, addItem) : addItem;
    })()));
};

});
parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});
parcelRegister("7ymNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $57fd655943aa23fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57fd655943aa23fe$var$AddIcon = (props)=>/*#__PURE__*/ $57fd655943aa23fe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $57fd655943aa23fe$var$_add.default
    }));
$57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;

});


parcelRegister("h9XlT", function(module, exports) {

$parcel$export(module.exports, "IssueTypesGroup", () => $f4e999d453ca906b$export$5bc39a07c26525ad);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $gjTBi = parcelRequire("gjTBi");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");
const $f4e999d453ca906b$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $gjTBi.default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
    if (!navigationItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: hasSeparator
    }, navigationItems.map((issueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            key: String(issueType.id),
            analytics: {
                itemId: String(issueType.id)
            },
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                appearance: "square",
                size: "small",
                src: issueType.icon,
                borderColor: "transparent"
            })
        }, issueType.name)));
};

});

parcelRegister("4ya5m", function(module, exports) {

$parcel$export(module.exports, "useAddIssueTypeContext", () => $018a92cfc5e17302$export$40493c3e9059110a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $018a92cfc5e17302$var$initialState = {
    isActive: false
};
const $018a92cfc5e17302$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: true
        });
    };
const $018a92cfc5e17302$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: false
        });
    };
const $018a92cfc5e17302$var$actions = {
    openAddIssueTypeModal: $018a92cfc5e17302$var$openAddIssueTypeModal,
    closeAddIssueTypeModal: $018a92cfc5e17302$var$closeAddIssueTypeModal
};
const $018a92cfc5e17302$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
const $018a92cfc5e17302$var$Store = (0, $iXqE5.createStore)({
    name: $018a92cfc5e17302$var$STORE_NAME,
    initialState: $018a92cfc5e17302$var$initialState,
    actions: $018a92cfc5e17302$var$actions
});
const $018a92cfc5e17302$export$40493c3e9059110a = (0, $3sQ5x.createHook)($018a92cfc5e17302$var$Store);
const $018a92cfc5e17302$export$a0f296f941567e3d = (0, $51nlc.createSubscriber)($018a92cfc5e17302$var$Store);
// instead of utilisling defaultRegistry, we will grab it from the render tree to have this singleton
// call useStoreReference in render tree before accessing the store instance
// https://github.com/atlassian/react-sweet-state/issues/139#issuecomment-890439621
const $018a92cfc5e17302$var$storeInstance = {
    state: $018a92cfc5e17302$var$initialState,
    actions: null
};
const $018a92cfc5e17302$export$f1a20ca23c90093e = ()=>{
    const [issueTypeContextState, issueTypeContextActions] = $018a92cfc5e17302$export$40493c3e9059110a();
    // eslint-disable-next-line react-hooks/react-compiler
    $018a92cfc5e17302$var$storeInstance.state = issueTypeContextState;
    $018a92cfc5e17302$var$storeInstance.actions = issueTypeContextActions;
    return null;
};
const $018a92cfc5e17302$export$605f542240ea8e19 = ()=>$018a92cfc5e17302$var$storeInstance.actions;

});

parcelRegister("kIafm", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesNavigationItems", () => $117ff49c1fb0e68b$export$8facf5695da03580);
$parcel$export(module.exports, "useTrueIssueTypesNavigationItems", () => $117ff49c1fb0e68b$export$49d5981231217e0e);
$parcel$export(module.exports, "useIssueTypesNavigationItemsActions", () => $117ff49c1fb0e68b$export$502d4d04702890ce);

var $6wesA = parcelRequire("6wesA");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $4R6GH = parcelRequire("4R6GH");

var $kXBJP = parcelRequire("kXBJP");

var $bI4Ju = parcelRequire("bI4Ju");
const $117ff49c1fb0e68b$export$d4c72bab9d6cc13a = {
    projectId: null,
    asyncState: (0, $6wesA.INIT),
    data: {
        limitPerProject: null,
        issueTypes: []
    },
    addIssueTypeTooltipMessage: ''
};
const $117ff49c1fb0e68b$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            if (currentState.asyncState === (0, $6wesA.LOADING) && projectId === currentState.projectId) return;
            setState({
                ...projectId === currentState.projectId ? currentState : $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
                projectId: projectId,
                asyncState: (0, $6wesA.LOADING)
            });
            const result = await (0, $kXBJP.queryIssueTypesNavigationItems)(projectId, productFeatures);
            if (getState().projectId !== projectId) return;
            const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
            setState({
                projectId: projectId,
                asyncState: (0, $6wesA.SUCCESS),
                data: {
                    limitPerProject: limitPerProject,
                    issueTypes: data
                },
                addIssueTypeTooltipMessage: productFeatures.navigationMessages.addIssueTypeDisabledTooltipIssueTermRefresh && (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltipIssueTermRefresh, {
                    limit: limitPerProject
                }) : intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                    limit: limitPerProject
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                asyncState: (0, $6wesA.FAILURE)
            });
        }
    };
const $117ff49c1fb0e68b$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $6wesA.SUCCESS)) return;
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
            }
        });
    };
const $117ff49c1fb0e68b$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $6wesA.SUCCESS)) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newDataById = {};
        for(let i = 0; i < layoutOwners.length; i += 1){
            const { data: data } = layoutOwners[i];
            newDataById[data.id] = {
                name: data.name,
                avatarId: data.avatarId,
                icon: data.iconUrl
            };
        }
        const issueTypes = state.data.issueTypes.map((issueType)=>{
            if (!newDataById[issueType.id]) return issueType;
            const { name: name, avatarId: avatarId } = newDataById[issueType.id];
            return {
                ...issueType,
                name: name,
                avatarId: avatarId || issueType.avatarId
            };
        });
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: issueTypes
            }
        });
    };
const $117ff49c1fb0e68b$export$e324594224ef24da = {
    load: $117ff49c1fb0e68b$var$load,
    remove: $117ff49c1fb0e68b$var$remove,
    update: $117ff49c1fb0e68b$var$update
};
/**
 * selectIssueTypesNavigationItemsData is the original implementation of the selector
 * to allow for checking  hierarchy levels of issue types, containing an exception for
 * Jira service desk projects Email Request Type
 *
 * @param state
 * @returns SelectorState
 */ const $117ff49c1fb0e68b$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
    const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
    const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, $bI4Ju.getIssueTypeNavigationItemsLevels)(issueTypes);
    const isIssueTypeLimitReached = (0, $bI4Ju.getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
    const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
    return {
        asyncState: asyncState,
        projectId: projectId,
        isAddIssueTypeDisabled: asyncState !== (0, $6wesA.SUCCESS) || isIssueTypeLimitReached,
        addIssueTypeTooltip: addIssueTypeTooltip,
        topLevel: topLevel,
        baseLevel: baseLevel,
        bottomLevel: bottomLevel
    };
};
/**
 * selectTrueIssueTypesNavigationItemsData is a seperate implementation of the selector
 * to allow for checking true hierarchy levels of issue types not modified for nav levels
 * e.g. JSM email request type
 *
 * @param state
 * @returns SelectorState
 */ const $117ff49c1fb0e68b$var$selectTrueIssueTypesNavigationItemsData = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
    const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
    const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, $bI4Ju.getTrueIssueTypeNavigationItemsLevels)(issueTypes);
    const isIssueTypeLimitReached = (0, $bI4Ju.getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
    const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
    return {
        asyncState: asyncState,
        projectId: projectId,
        isAddIssueTypeDisabled: asyncState !== (0, $6wesA.SUCCESS) || isIssueTypeLimitReached,
        addIssueTypeTooltip: addIssueTypeTooltip,
        topLevel: topLevel,
        baseLevel: baseLevel,
        bottomLevel: bottomLevel
    };
};
// Made it const for visibility. Apparently, store name must be unique or it breaks the library
const $117ff49c1fb0e68b$var$STORE_NAME = 'issue-type-page-navigation-items-new';
const $117ff49c1fb0e68b$var$Store = (0, $iXqE5.createStore)({
    name: $117ff49c1fb0e68b$var$STORE_NAME,
    initialState: $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
    actions: $117ff49c1fb0e68b$export$e324594224ef24da
});
/**
 * useIssueTypesNavigationItems hook is the original implementation of the selector
 * to allow for checking  hierarchy levels of issue types, containing an exception for
 * Jira service desk projects Email Request Type to render in the epic/top hierarchy level
 */ const $117ff49c1fb0e68b$export$8facf5695da03580 = (0, $3sQ5x.createHook)($117ff49c1fb0e68b$var$Store, {
    selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
});
/**
 * useTrueIssueTypesNavigationItems hook is a seperate implementation of the selector
 * to allow for checking true hierarchy levels of issue types not modified for nav levels
 * e.g. JSM email request type will be present in the base level and not epic level.
 */ const $117ff49c1fb0e68b$export$49d5981231217e0e = (0, $3sQ5x.createHook)($117ff49c1fb0e68b$var$Store, {
    selector: $117ff49c1fb0e68b$var$selectTrueIssueTypesNavigationItemsData
});
// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>...' is not assignable to type 'HookActionsFunction<{ readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>; readonly remove: (...'.
const $117ff49c1fb0e68b$export$502d4d04702890ce = (0, $3sQ5x.createActionsHook)($117ff49c1fb0e68b$var$Store);
const $117ff49c1fb0e68b$export$313f907c8e339d1b = (0, $51nlc.createSubscriber)($117ff49c1fb0e68b$var$Store, {
    selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
});

});
parcelRegister("6wesA", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "INACTIVE_LIST", () => $a553a914b9b6f7c9$export$d7fec05af6b928f7);
$parcel$export(module.exports, "FIELD_TYPE_LIST", () => $a553a914b9b6f7c9$export$de26d0d1ef96d0ed);
$parcel$export(module.exports, "DELETE_DROPPABLE_ID", () => $a553a914b9b6f7c9$export$a155cb9d82798d65);
$parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", () => $a553a914b9b6f7c9$export$8191ccc97ff9885c);
$parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", () => $a553a914b9b6f7c9$export$c77ecc59e9e91e60);
$parcel$export(module.exports, "JSD_FIELD_HELPTEXT", () => $a553a914b9b6f7c9$export$663476c4863d5014);
$parcel$export(module.exports, "FORGE_FIELD_TYPE", () => $a553a914b9b6f7c9$export$b1bef6d04e96121a);
$parcel$export(module.exports, "FORGE_FIELD_COLLECTION", () => $a553a914b9b6f7c9$export$991edf9ddbb20d59);
$parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", () => $a553a914b9b6f7c9$export$9be9f574874c9a2f);
$parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", () => $a553a914b9b6f7c9$export$b320c6b352dcb101);
$parcel$export(module.exports, "SUGGESTED_GROUP", () => $a553a914b9b6f7c9$export$e66b34cc29932bbf);
$parcel$export(module.exports, "ASSETS_GROUP", () => $a553a914b9b6f7c9$export$c87c7df18254969e);
$parcel$export(module.exports, "DATES_GROUP", () => $a553a914b9b6f7c9$export$fa8c310a8ac47d47);
$parcel$export(module.exports, "LABELS_GROUP", () => $a553a914b9b6f7c9$export$5b2dd1b457037e13);
$parcel$export(module.exports, "NUMBER_GROUP", () => $a553a914b9b6f7c9$export$2c2f344ca2ba1c03);
$parcel$export(module.exports, "PEOPLE_GROUP", () => $a553a914b9b6f7c9$export$1441c9d524a8c0f2);
$parcel$export(module.exports, "SELECT_GROUP", () => $a553a914b9b6f7c9$export$d3e4788fc90e5f8f);
$parcel$export(module.exports, "SYSTEM_GROUP", () => $a553a914b9b6f7c9$export$724e0d23ac7e9b03);
$parcel$export(module.exports, "TEXT_GROUP", () => $a553a914b9b6f7c9$export$bd76d204d15f4c6a);
$parcel$export(module.exports, "VERSION_GROUP", () => $a553a914b9b6f7c9$export$33d3fa5e989ba460);
$parcel$export(module.exports, "ADVANCED_GROUP", () => $a553a914b9b6f7c9$export$c58a10f3e3456974);
$parcel$export(module.exports, "OTHER_GROUP", () => $a553a914b9b6f7c9$export$591e195d295fd27e);
$parcel$export(module.exports, "RESTRICTED_GROUP", () => $a553a914b9b6f7c9$export$14785d7afcf55619);
$parcel$export(module.exports, "AI_SUGGESTED_GROUP", () => $a553a914b9b6f7c9$export$df593ebd3e7c9c2d);
$parcel$export(module.exports, "INIT", () => $a553a914b9b6f7c9$export$d788bc089976c004);
$parcel$export(module.exports, "LOADING", () => $a553a914b9b6f7c9$export$26d55645375ca9a);
$parcel$export(module.exports, "SUCCESS", () => $a553a914b9b6f7c9$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAILURE", () => $a553a914b9b6f7c9$export$5b1e245d5eac107);
$parcel$export(module.exports, "classicFieldTypesMap", () => $a553a914b9b6f7c9$export$369c1f8ac37104ce);
$parcel$export(module.exports, "ngFieldTypesMap", () => $a553a914b9b6f7c9$export$b361664c16c2ea91);
$parcel$export(module.exports, "SWIFT_VERSION_M2", () => $a553a914b9b6f7c9$export$527472231e0f6045);
$parcel$export(module.exports, "JSD_IS_EMAIL_REQUEST_TYPE", () => $a553a914b9b6f7c9$export$97806a3c861a8076);

var $5fc53 = parcelRequire("5fc53");

var $3XO6n = parcelRequire("3XO6n");
const $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
const $a553a914b9b6f7c9$export$d7fec05af6b928f7 = 'inactive-list';
const $a553a914b9b6f7c9$export$de26d0d1ef96d0ed = 'field-type-list';
const $a553a914b9b6f7c9$export$a155cb9d82798d65 = 'delete-droppable-id';
const $a553a914b9b6f7c9$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
const $a553a914b9b6f7c9$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
const $a553a914b9b6f7c9$export$663476c4863d5014 = 'jsd.field.helpText';
const $a553a914b9b6f7c9$export$b1bef6d04e96121a = 'forge.field.type';
const $a553a914b9b6f7c9$export$991edf9ddbb20d59 = 'forge.field.collection';
const $a553a914b9b6f7c9$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $a553a914b9b6f7c9$export$9be9f574874c9a2f = 'jsm.issue.type.id';
const $a553a914b9b6f7c9$export$b320c6b352dcb101 = 'jsm.issue.type.name';
const $a553a914b9b6f7c9$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
const $a553a914b9b6f7c9$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
const $a553a914b9b6f7c9$export$e66b34cc29932bbf = 'suggestedGroup';
const $a553a914b9b6f7c9$export$c87c7df18254969e = 'assetsGroup';
const $a553a914b9b6f7c9$export$fa8c310a8ac47d47 = 'datesGroup';
const $a553a914b9b6f7c9$export$5b2dd1b457037e13 = 'labelsGroup';
const $a553a914b9b6f7c9$export$2c2f344ca2ba1c03 = 'numberGroup';
const $a553a914b9b6f7c9$export$1441c9d524a8c0f2 = 'peopleGroup';
const $a553a914b9b6f7c9$export$d3e4788fc90e5f8f = 'selectGroup';
const $a553a914b9b6f7c9$export$724e0d23ac7e9b03 = 'systemGroup';
const $a553a914b9b6f7c9$export$bd76d204d15f4c6a = 'textGroup';
const $a553a914b9b6f7c9$export$33d3fa5e989ba460 = 'versionGroup';
const $a553a914b9b6f7c9$export$c58a10f3e3456974 = 'advancedGroup';
const $a553a914b9b6f7c9$export$591e195d295fd27e = 'otherGroup';
const $a553a914b9b6f7c9$export$14785d7afcf55619 = 'restrictedGroup';
const $a553a914b9b6f7c9$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
const $a553a914b9b6f7c9$export$d788bc089976c004 = 'INIT';
const $a553a914b9b6f7c9$export$26d55645375ca9a = 'LOADING';
const $a553a914b9b6f7c9$export$638cc6e36b2a737a = 'SUCCESS';
const $a553a914b9b6f7c9$export$5b1e245d5eac107 = 'FAILURE';
const $a553a914b9b6f7c9$export$369c1f8ac37104ce = {
    assetspicker: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    date: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    datetime: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    labelpicker: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
    number: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
    multiuserpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    userpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    checkbox: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    radio: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    cascadingselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    multiselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    select: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    attachment: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    textarea: $a553a914b9b6f7c9$export$bd76d204d15f4c6a
};
const $a553a914b9b6f7c9$export$b361664c16c2ea91 = {
    [(0, $5fc53.ASSETS_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    [(0, $5fc53.DATE_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    [(0, $5fc53.DATETIME_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
    [(0, $5fc53.LABELS_CF_TYPE)]: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
    [(0, $5fc53.NUMBER_CF_TYPE)]: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
    people: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    [(0, $5fc53.SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
    [(0, $5fc53.ATTACHMENT_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.TEXT_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    [(0, $5fc53.VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
    [(0, $5fc53.SUMMARY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.DESCRIPTION_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.LABELS_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.PEOPLE_CF_TYPE)]: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
    [(0, $5fc53.PRIORITY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.DUE_DATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.REPORTER_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
    [(0, $5fc53.ASSIGNEE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03
};
const $a553a914b9b6f7c9$export$8e333612d4b83b0e = 'M1';
const $a553a914b9b6f7c9$export$527472231e0f6045 = 'M2';
const $a553a914b9b6f7c9$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';

});

parcelRegister("kXBJP", function(module, exports) {

$parcel$export(module.exports, "queryIssueTypesNavigationItems", () => $e8107a8cce63320f$export$d7f9b965a8cdf6ce);

var $7f4tk = parcelRequire("7f4tk");

var $1JUEq = parcelRequire("1JUEq");
const $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
            }
        }
    }
  }`;
const $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
                properties(keys: ${JSON.stringify(keys)})
            }
        }
    }
  }`;
const $e8107a8cce63320f$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
    const propertyKeys = (0, $1JUEq.getAllPropertiesKeys)(productFeatures);
    const query = propertyKeys.length ? $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery(projectId);
    return (0, $7f4tk.default)('/rest/gira/latest/?issue-type-page-navigation', {
        method: 'POST',
        body: JSON.stringify({
            query: query
        })
    });
};

});
parcelRegister("1JUEq", function(module, exports) {

$parcel$export(module.exports, "getAllPropertiesKeys", () => $fec81b5fddfaba4b$export$481a21941383de83);

const $fec81b5fddfaba4b$export$481a21941383de83 = (features)=>{
    const { issueTypeHelpText: issueTypeHelpText } = features;
    const allPropertiesKeys = [
        (0, $052efe0fea3c4d67$export$97806a3c861a8076),
        (0, $052efe0fea3c4d67$export$5a53542e76b69730)
    ];
    return issueTypeHelpText ? allPropertiesKeys : [];
};

});
const $052efe0fea3c4d67$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $052efe0fea3c4d67$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $052efe0fea3c4d67$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $052efe0fea3c4d67$export$663476c4863d5014 = 'jsd.field.helpText';
const $052efe0fea3c4d67$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $052efe0fea3c4d67$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';



parcelRegister("bI4Ju", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", () => $a611b4a47ee97f87$export$fcf99cb11372431f);
$parcel$export(module.exports, "getTrueIssueTypeNavigationItemsLevels", () => $a611b4a47ee97f87$export$882cd3daa26724c4);
$parcel$export(module.exports, "getIsIssueTypeLimitReached", () => $a611b4a47ee97f87$export$f9ef03d331bca3e6);

var $g4tDr = parcelRequire("g4tDr");

var $4cS2K = parcelRequire("4cS2K");

var $4R6GH = parcelRequire("4R6GH");
const $a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
/**
 * getIssueTypeNavigationItemsLevels is the original implementation of the selector
 * to allow for checking  hierarchy levels of issue types, containing an exception for
 * Jira service desk projects Email Request Type to render in the epic/top hierarchy level
 *
 * @param issueTypes A list of raw issue types
 * @returns IssueTypeNavigationItemsCategories
 */ const $a611b4a47ee97f87$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
        const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
        const issueTypeNavigationItem = {
            id: id,
            name: name,
            avatarId: avatarId,
            operations: operations,
            icon: (0, $4cS2K.getProjectAvatarUrl)(avatarId)
        };
        if ((0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
        else if ((0, $g4tDr.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
        else if ((0, $g4tDr.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        return acc;
    }, {
        topLevel: [],
        baseLevel: [],
        bottomLevel: []
    });
/**
 * getTrueIssueTypeNavigationItemsLevels is a seperate implementation of the selector
 * to allow for checking true hierarchy levels of issue types not modified for nav levels
 * e.g. JSM email request type
 *
 * @param issueTypes A list of raw issue types
 * @returns IssueTypeNavigationItemsCategories
 */ const $a611b4a47ee97f87$export$882cd3daa26724c4 = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
        const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
        const issueTypeNavigationItem = {
            id: id,
            name: name,
            avatarId: avatarId,
            operations: operations,
            icon: (0, $4cS2K.getProjectAvatarUrl)(avatarId)
        };
        if ((0, $4R6GH.fg)('jsm-request-type-bug-deletion')) {
            if ((0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel)) acc.topLevel.push(issueTypeNavigationItem);
            else if ((0, $g4tDr.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
            else if ((0, $g4tDr.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        } else {
            // eslint-disable-next-line no-lonely-if
            if ((0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
            else if ((0, $g4tDr.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
            else if ((0, $g4tDr.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        }
        return acc;
    }, {
        topLevel: [],
        baseLevel: [],
        bottomLevel: []
    });
const $a611b4a47ee97f87$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;

});
parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});

parcelRegister("4cS2K", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a2a115a4d046ac6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getProjectAvatarUrl", () => $9a2a115a4d046ac6$export$65a50dd1fe88e116);
$parcel$export(module.exports, "normaliseSavedAvatar", () => $9a2a115a4d046ac6$export$b11f6166803b3fff);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a2a115a4d046ac6$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
            id: Number(raw.id),
            uri: raw.urls['48x48'],
            fileName: raw.fileName
        }));
const $9a2a115a4d046ac6$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
const $9a2a115a4d046ac6$export$b11f6166803b3fff = (avatar)=>({
        id: parseInt(avatar.id, 10),
        uri: $9a2a115a4d046ac6$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
        fileName: avatar.fileName
    });

});



parcelRegister("afIXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b52c5d7d436e6cd4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b52c5d7d436e6cd4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
        "defaultMessage": "Issue types"
    },
    addIssueType: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
        "defaultMessage": "Add issue type"
    },
    issueTypesIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types-issue-term-refresh",
        "defaultMessage": "Work types"
    },
    addIssueTypeIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type-issue-term-refresh",
        "defaultMessage": "Add work type"
    }
});

});


parcelRegister("17zko", function(module, exports) {

$parcel$export(module.exports, "messages", () => $333939f1c0a6953d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $333939f1c0a6953d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
        "defaultMessage": "Project settings"
    },
    itemDetails: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
        "defaultMessage": "Details"
    },
    itemAccess: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
        "defaultMessage": "Access"
    },
    itemFieldsNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-fields-non-final",
        "defaultMessage": "Fields"
    },
    itemIssueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
        "defaultMessage": "Issue types"
    },
    itemAdvancedForms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
        "defaultMessage": "Advanced Forms"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
        "defaultMessage": "New"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
        "defaultMessage": "Automation"
    },
    itemNotifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
        "defaultMessage": "Notifications"
    },
    itemApprovals: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
        "defaultMessage": "Approvals"
    },
    dataClassificationNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
        "defaultMessage": "Data classification"
    },
    itemIssueTypesIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types-issue-term-refresh",
        "defaultMessage": "Work types"
    }
});

});


parcelRegister("4rn3K", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $d5d4618f8b440044$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $gOS29 = parcelRequire("gOS29");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $2MtwW = parcelRequire("2MtwW");

var $xc3fY = parcelRequire("xc3fY");

var $2Uv55 = parcelRequire("2Uv55");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $2gP8z = parcelRequire("2gP8z");

var $3OGaE = parcelRequire("3OGaE");

var $lpwtK = parcelRequire("lpwtK");

var $71bFU = parcelRequire("71bFU");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $5xslo = parcelRequire("5xslo");

var $eOlBz = parcelRequire("eOlBz");

var $g5X3G = parcelRequire("g5X3G");

var $6EZeH = parcelRequire("6EZeH");

var $bkw8F = parcelRequire("bkw8F");

var $69lKq = parcelRequire("69lKq");
const $d5d4618f8b440044$export$a4007dc4843ca7f6 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $d5d4618f8b440044$export$154ecbb867fd48f0 = (0, $7OqB4.withThrowOnError)((0, $bkw8F.useSettingFeatures));
const $d5d4618f8b440044$export$17eaab3b8c213998 = (0, $7OqB4.withThrowOnError)((0, $eOlBz.useNewIssueViewLockedInStatus));
const $d5d4618f8b440044$var$DisplayNotificationsOptions = ({ hasNotifications: hasNotifications, formatMessage: formatMessage, project: project })=>{
    if (!hasNotifications) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        menuItemLabel: formatMessage((0, $69lKq.default).notifications),
        forceExpand: true,
        submenuId: "core-notifications-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71bFU.NotificationsSubMenu), {
        settingsUrl: `/plugins/servlet/project-config/${project.key}/notifications`,
        issueLogsUrl: `/jira/core/projects/${project.key}/settings/notifications/issue-logs?projectId=${project.id}`
    }));
};
// will be cleaned with FG cleanup
const $d5d4618f8b440044$var$IssueLayoutOption = ({ isNewIssueViewLockedIn: isNewIssueViewLockedIn, hasIssueLayout: hasIssueLayout, formatMessage: formatMessage, project: project })=>{
    return hasIssueLayout && isNewIssueViewLockedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-layout'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuelayout`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $69lKq.default).issueLayoutIssueTermRefresh : (0, $69lKq.default).issueLayout));
};
const $d5d4618f8b440044$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
    const { data: features } = $d5d4618f8b440044$export$154ecbb867fd48f0();
    const { data: status } = $d5d4618f8b440044$export$17eaab3b8c213998();
    const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, $eOlBz.DEFAULT_TO_OLD_ISSUE_VIEW);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = $d5d4618f8b440044$export$a4007dc4843ca7f6();
    const hasDlpEnabled = (0, $6EZeH.useDlpEntitlement)();
    if (features == null || project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $69lKq.default).projectSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, features.hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: [
            'project-settings-core-details'
        ],
        href: `/jira/core/projects/${project.key}/settings/details`
    }, formatMessage((0, $69lKq.default).details)), features.hasPeople && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'people'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/people`
    }, formatMessage((0, $69lKq.default).people)), features.hasAutomation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: "spotlight-sidebar-project-automation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: (0, $gOS29.getBaseAutomationUrl)({
            isSimplified: project.isSimplified,
            projectKey: (0, $g5X3G.toProjectKey)(project.key),
            projectType: (0, $2vSU6.CORE_PROJECT)
        })
    }, formatMessage((0, $69lKq.default).automation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-project-automation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Uv55.FireUiAnalytics), {
        actionSubject: "automationNavigationItem",
        action: "viewed"
    })), features.hasSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'summary'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/summary`
    }, formatMessage((0, $69lKq.default).summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, $4R6GH.fg)('proforma_mvp_jwm_project_settings')
    }, features.hasIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-types'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuetypes`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $69lKq.default).issueTypesIssueTermRefresh : (0, $69lKq.default).issueTypes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$IssueLayoutOption, {
        isNewIssueViewLockedIn: isNewIssueViewLockedIn,
        hasIssueLayout: features.hasIssueLayout,
        formatMessage: formatMessage,
        project: project
    }), (0, $4R6GH.fg)('proforma_mvp_jwm_project_settings') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        href: `/jira/core/projects/${project.key}/settings/forms`,
        selectedOn: [
            'project-settings-core-proforma-project-forms'
        ]
    }, formatMessage((0, $69lKq.default).forms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: features.hasProjectGroupTwoSection
    }, features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'workflows'
        },
        href: `/plugins/servlet/project-config/${project.key}/workflows`
    }, formatMessage((0, $69lKq.default).workflows)), features.hasScreens && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'screens'
        },
        href: `/plugins/servlet/project-config/${project.key}/screens`
    }, formatMessage((0, $69lKq.default).screens)), features.hasSystemFieldsConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'fields'
        },
        href: `/plugins/servlet/project-config/${project.key}/fields`
    }, formatMessage((0, $69lKq.default).fields))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: features.hasProjectGroupThreeSection
    }, features.hasVersions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: [
            'project-settings-versions'
        ],
        analytics: {
            itemId: 'versions'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-versions`
    }, formatMessage((0, $69lKq.default).versions)), features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: [
            'project-settings-components'
        ],
        analytics: {
            itemId: 'components'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-components`
    }, formatMessage((0, $69lKq.default).components))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: features.hasProjectGroupFourSection
    }, features.hasPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'permissions'
        },
        href: `/plugins/servlet/project-config/${project.key}/permissions`
    }, formatMessage((0, $69lKq.default).permissions)), features.hasIssueSecurity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-security'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $69lKq.default).issueSecurityIssueTermRefresh : (0, $69lKq.default).issueSecurity)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$DisplayNotificationsOptions, {
        hasNotifications: features.hasNotifications,
        formatMessage: formatMessage,
        project: project
    }), features.hasDevtools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'devtools'
        },
        href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
    }, formatMessage((0, $69lKq.default).devtools))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: features.hasgetIssueCollectorSection
    }, features.hasIssueCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: [
            'legacy-project-settings-collectors'
        ],
        analytics: {
            itemId: 'issue-collectors'
        },
        href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $69lKq.default).issueCollectorsIssueTermRefresh : (0, $69lKq.default).issueCollectors))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5xslo.default), {
        hasSeparator: true,
        items: ecosystemItems,
        forgeModule: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        overrides: {
            BackMenuItem: {
                href: `/plugins/servlet/project-config/${project.key}`,
                title: formatMessage((0, $69lKq.default).itemBack)
            }
        }
    }), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'data-classifications'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/data-classifications`
    }, formatMessage((0, $69lKq.default).dataClassificationsNonFinal))));
};

});
parcelRegister("gOS29", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $b61a7afc01657dc2$export$8e479e490e1e69bc);
const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("2MtwW", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $0e9acf1f50def63d$export$f14689466e4eca7a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0e9acf1f50def63d$export$f14689466e4eca7a = (0, $axUP7.withNestingOptimisation)(({ engagementId: engagementId })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: engagementId
    });
});

});

parcelRegister("2Uv55", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $c81bbbeeb609506c$export$5a67e7291fd4569e);

var $5oFIy = parcelRequire("5oFIy");

var $axUP7 = parcelRequire("axUP7");
const $c81bbbeeb609506c$export$5a67e7291fd4569e = (0, $axUP7.withNestingOptimisation)((0, $5oFIy.FireUiAnalytics));

});

parcelRegister("2gP8z", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $bac5b90628bba66f$export$e29577842f211e22);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $axUP7 = parcelRequire("axUP7");
const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $bac5b90628bba66f$export$e29577842f211e22 = (0, $axUP7.withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);

});

parcelRegister("5xslo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f574dcd99762a8d6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");

var $k51JQ = parcelRequire("k51JQ");
const $f574dcd99762a8d6$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
    const forgeItems = (0, $5uXOq.useMemo)(()=>items.forge || [], [
        items.forge
    ]);
    const connectItems = (0, $au6nA.useFilteredItems)(items.connect, shouldFilter);
    const sortedItems = (0, $5uXOq.useMemo)(()=>[
            ...forgeItems.map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
        connectItems,
        forgeItems
    ]);
    if (!sortedItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'ConnectDataItem | ForgeItemProps' is not assignable to type 'ForgeProjectSettingsItem'.
            const forgeItem = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
                key: forgeItem.id,
                ...forgeItem,
                overrides: overrides,
                showIcon: showIcons,
                nestedMenuActive: nestedMenuActive
            });
        }
        const connectItem = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: connectItem,
            key: connectItem.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        });
    }), forgeItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), null) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f574dcd99762a8d6$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: forgeModule,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f574dcd99762a8d6$export$66569e9b4a285b16, restProps));

});

parcelRegister("69lKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a05b6299fc545f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $40a05b6299fc545f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettings: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
        "defaultMessage": "Project settings"
    },
    details: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
        "defaultMessage": "People"
    },
    summary: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
        "defaultMessage": "Summary"
    },
    deleteProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
        "defaultMessage": "Delete project"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
        "defaultMessage": "Issue layout"
    },
    workflows: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
        "defaultMessage": "Fields"
    },
    versions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
        "defaultMessage": "Versions"
    },
    components: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
        "defaultMessage": "Components"
    },
    permissions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
        "defaultMessage": "Permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
        "defaultMessage": "Issue security"
    },
    notifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
        "defaultMessage": "Notifications"
    },
    notificationsEmail: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
        "defaultMessage": "Notification email"
    },
    hipChat: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
        "defaultMessage": "HipChat integration"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    new: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
        "defaultMessage": "New"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
        "defaultMessage": "Back to project settings"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
        "defaultMessage": "Automation"
    },
    devtools: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
        "defaultMessage": "Development tools"
    },
    forms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
        "defaultMessage": "Advanced Forms"
    },
    dataClassificationsNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
        "defaultMessage": "Data classification"
    },
    issueTypesIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types-issue-term-refresh",
        "defaultMessage": "Work types"
    },
    issueLayoutIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout-issue-term-refresh",
        "defaultMessage": "Work item layout"
    },
    issueSecurityIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security-issue-term-refresh",
        "defaultMessage": "Work item security"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    }
});

});





parcelRegister("1tFZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdfaa99512e485c7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bdfaa99512e485c7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    favorites: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
        "defaultMessage": "Starred"
    },
    recents: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
        "defaultMessage": "Recent"
    },
    expandSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
        "defaultMessage": "Expand {section} projects"
    },
    collapseSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
        "defaultMessage": "Collapse {section} projects"
    }
});

});

parcelRegister("cUsQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $898e57801e4e297c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jzhSN = parcelRequire("jzhSN");

var $dPLwL = parcelRequire("dPLwL");
const $898e57801e4e297c$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
const $898e57801e4e297c$var$ViewAllProjects = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzhSN.default), {
        href: "/jira/projects?selectedProjectType=business",
        testId: $898e57801e4e297c$var$TEST_ID,
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $898e57801e4e297c$var$textStyle
    }, label ?? formatMessage((0, $dPLwL.messages).viewAllProjectsLabel)));
};
var $898e57801e4e297c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($898e57801e4e297c$var$ViewAllProjects);
const $898e57801e4e297c$var$textStyle = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("dPLwL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2a9ab6de28c59d3b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2a9ab6de28c59d3b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    viewAllProjectsLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
        "defaultMessage": "View all projects"
    }
});

});



parcelRegister("k5gug", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74810dab45a4db8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bKCrm = parcelRequire("bKCrm");

var $aFVvc = parcelRequire("aFVvc");

var $iuAuR = parcelRequire("iuAuR");

var $ekH8d = parcelRequire("ekH8d");

var $dcvwL = parcelRequire("dcvwL");
const $a74810dab45a4db8$var$ProjectsHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: data } = (0, $aFVvc.useProjectCreatePermissionsResource)();
    const canCreateProject = Boolean(data?.canCreateProject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuAuR.default), {
        title: formatMessage((0, $ekH8d.messages).projectsHeader)
    }, canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcvwL.default), {
            openProjectCreateDrawer: open
        })));
};
var $a74810dab45a4db8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($a74810dab45a4db8$var$ProjectsHeader);

});
parcelRegister("bKCrm", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $645a52f2fa143509$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $645a52f2fa143509$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $645a52f2fa143509$export$8172ff4ed0f75a1e);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $58GFP = parcelRequire("58GFP");

var $8YEE2 = parcelRequire("8YEE2");

var $lVJAU = parcelRequire("lVJAU");

var $gL2cg = parcelRequire("gL2cg");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $645a52f2fa143509$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }
});
const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        }, // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        }, this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
            });
        }, this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        }, this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        }, this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        }, this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $58GFP.getIsJsmBlankProjectTemplate)(templateKey)) (0, $8YEE2.LazyComponent).preload();
            (0, $gL2cg.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
$645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("8YEE2", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $300188a98a9fded7$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $300188a98a9fded7$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $300188a98a9fded7$export$ff317c5d87147a19);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $9noxX = parcelRequire("9noxX");

var $kxZPA = parcelRequire("kxZPA");

const $300188a98a9fded7$export$31f1740ae531af94 = (0, $kxZPA.lazy)(()=>(parcelRequire("dvgmP")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("dvgmP", function(module, exports) {

let $9d4addd117970a46$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9d4addd117970a46$var$load("5BNUw"),
    $9d4addd117970a46$var$load("kGAgW"),
    $9d4addd117970a46$var$load("kVX56"),
    $9d4addd117970a46$var$load("ffQaD"),
    $9d4addd117970a46$var$load("kvRbA"),
    $9d4addd117970a46$var$load("kNFvF"),
    $9d4addd117970a46$var$load("3yAl4"),
    $9d4addd117970a46$var$load("76n7a"),
    $9d4addd117970a46$var$load("l253H"),
    $9d4addd117970a46$var$load("jbxE1"),
    $9d4addd117970a46$var$load("7imUH"),
    $9d4addd117970a46$var$load("14MdE")
]).then(()=>parcelRequire('c9lEE'));

});


parcelRegister("gL2cg", function(module, exports) {

$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $e1d0138bae1db723$export$c0c81c1828c7638c);

var $jcw0u = parcelRequire("jcw0u");

var $8fYaK = parcelRequire("8fYaK");
const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $8fYaK.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});


parcelRegister("aFVvc", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $9880b75bed11d4d0$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $9880b75bed11d4d0$export$2bd0d3b374549a68);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("5ohEm"));
const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $2M1hQ.createResource)({
    type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
    maxAge: Infinity
});
const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $2YP9W.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);

});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("5ohEm", function(module, exports) {

let $3ecce2897af0bd36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ecce2897af0bd36$var$load("aErQO").then(()=>parcelRequire('5Yzmr'));

});


parcelRegister("ekH8d", function(module, exports) {

$parcel$export(module.exports, "messages", () => $de5b805401f88067$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $de5b805401f88067$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("dcvwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $38d1fe81a75f8a8e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $5jbF3 = parcelRequire("5jbF3");

var $hJE3l = parcelRequire("hJE3l");

const $38d1fe81a75f8a8e$export$ef99f99721eacc0f = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("hJE3l"))), {
    ssr: false,
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
});
const $38d1fe81a75f8a8e$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const renderContent = (0, $5uXOq.useCallback)((data, loading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "sidebar-template-picker",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJE3l.TemplatePickerFallback), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($38d1fe81a75f8a8e$export$ef99f99721eacc0f, {
            data: data,
            loading: loading,
            openProjectCreateDrawer: openProjectCreateDrawer
        })), [
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jbF3.default), {
        renderContent: renderContent,
        openProjectCreateDrawer: openProjectCreateDrawer
    });
};
var $38d1fe81a75f8a8e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($38d1fe81a75f8a8e$var$OneClickProject);

});
parcelRegister("5jbF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c00fe391b3045d6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $172CC = parcelRequire("172CC");

var $gPQRI = parcelRequire("gPQRI");

var $jgJNO = parcelRequire("jgJNO");

var $gb5lQ = parcelRequire("gb5lQ");

var $3BbwT = parcelRequire("3BbwT");

var $8MKpg = parcelRequire("8MKpg");
const $5c00fe391b3045d6$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, $3BbwT.useProjectTemplates)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const { templates: templates, recommendationSessionId: recommendationSessionId } = data;
    const wasFetched = templates != null || loading || error != null;
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && !wasFetched) fetchJwmTemplates();
    }, [
        isOpen,
        wasFetched,
        fetchJwmTemplates
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isLeftSidebarCollapsed && isOpen) onClose();
    }, [
        isLeftSidebarCollapsed,
        isOpen,
        onClose
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error && isOpen) {
            openProjectCreateDrawer((0, $172CC.getJwmCreateProjectDrawerOptions)((0, $gb5lQ.LOCATION), recommendationSessionId));
            setIsOpen(false);
        }
    }, [
        error,
        isOpen,
        openProjectCreateDrawer,
        recommendationSessionId
    ]);
    const content = (0, $5uXOq.useCallback)(()=>renderContent(data, loading), [
        renderContent,
        data,
        loading
    ]);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8MKpg.default), {
            onClick: ()=>setIsOpen(!isOpen)
        })), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.jira-popup",
        messageType: "transactional",
        isOpen: isOpen,
        placement: "right-start",
        onClose: onClose,
        content: content,
        trigger: trigger
    });
};
var $5c00fe391b3045d6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5c00fe391b3045d6$var$OneClickProjectButton);

});
parcelRegister("172CC", function(module, exports) {

$parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", () => $30b27d3ea79ff2d5$export$c1785414279ee192);

var $2vSU6 = parcelRequire("2vSU6");
const $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
const $30b27d3ea79ff2d5$export$c1785414279ee192 = (source, recommendationSessionId)=>({
        isNextGen: true,
        selectedProjectType: (0, $2vSU6.CORE_PROJECT),
        showExperienceSelection: false,
        defaultSelectedTemplateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
        recommendedTemplate: {
            templateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            isSimplified: false
        },
        source: source,
        recommendationSessionId: recommendationSessionId
    });

});

parcelRegister("3BbwT", function(module, exports) {

$parcel$export(module.exports, "useProjectTemplates", () => $f58c037e2d918746$export$45e810e42086790f);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $gb5lQ = parcelRequire("gb5lQ");

var $annwf = parcelRequire("annwf");
const $f58c037e2d918746$var$initialState = {
    data: {
        templates: null
    },
    loading: false,
    error: null
};
const $f58c037e2d918746$export$45e810e42086790f = ()=>{
    const [{ loading: loading, data: data, error: error }, setState] = (0, $5uXOq.useState)($f58c037e2d918746$var$initialState);
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        setState({
            data: {
                templates: null
            },
            loading: true,
            error: null
        });
        try {
            const response = await (0, $7f4tk.default)('/rest/simplified/2.0/project-templates?recommendations');
            const jwmTemplates = (0, $annwf.getFilteredTemplates)(response);
            setState({
                data: {
                    templates: jwmTemplates,
                    recommendationSessionId: response.recommendationSessionId
                },
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useProjectTemplates',
                    packageName: (0, $gb5lQ.PACKAGE_NAME),
                    teamName: 'jira-warepil'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                data: {
                    templates: null
                },
                loading: false,
                error: err
            });
        }
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        fetch: fetch
    };
};

});
parcelRegister("annwf", function(module, exports) {

$parcel$export(module.exports, "getFilteredTemplates", () => $1ee17a992e26086f$export$e9643d22c03c3a30);
const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY = 5;
// note: these 4 templates are hardcoded for the time being
const $1ee17a992e26086f$var$TEMPLATE_KEYS = new Set([
    'jwm.blank-project',
    'jwm.project-management',
    'jwm.personal-task-planner',
    'jwm.task-tracking'
]);
const $1ee17a992e26086f$export$e9643d22c03c3a30 = (response)=>{
    const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey, recommendedTemplates: recommendedTemplateKeys } = response;
    const lastUsedTemplates = [];
    const recommendedTemplates = [];
    const additionalTemplates = [];
    recommendedTemplateKeys?.forEach((key, index)=>{
        const template = templates.find((t)=>t.key === key);
        if (template) {
            const { projectTypeTemplates: projectTypeTemplates } = template;
            // * The first recommended template will be the last used template if there is one
            if (index === 0 && lastUsedTemplateKey) {
                const isLastUsed = lastUsedTemplateKey && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);
                lastUsedTemplates.push({
                    ...template,
                    ...isLastUsed && {
                        isLastUsed: isLastUsed
                    }
                });
                return;
            }
            const isRecommended = recommendedTemplateKey && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);
            recommendedTemplates.push({
                ...template,
                ...isRecommended && {
                    isRecommended: isRecommended
                }
            });
        }
    });
    // * If there are not enough templates to display, add additional templates
    if (lastUsedTemplates.length + recommendedTemplates.length < $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY) {
        // * Get the keys of the templates that are not last used or recommended
        const placeholderTemplateKeys = Array.from($1ee17a992e26086f$var$TEMPLATE_KEYS).filter((key)=>!lastUsedTemplates.some((t)=>t.key === key) && !recommendedTemplates.some((t)=>t.key === key));
        templates.forEach((template)=>{
            if (placeholderTemplateKeys.includes(template.key)) additionalTemplates.push(template);
        });
    }
    // templates are sorted in order of last used, recommended and fallback.
    // only use the first 5 templates
    const filteredTemplates = [
        ...lastUsedTemplates,
        ...recommendedTemplates,
        ...additionalTemplates
    ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY);
    return filteredTemplates;
};

});


parcelRegister("8MKpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7880bbb09ab94b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gb5lQ = parcelRequire("gb5lQ");

var $3MXKI = parcelRequire("3MXKI");

var $acCqn = parcelRequire("acCqn");
const $1f7880bbb09ab94b$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
const $1f7880bbb09ab94b$var$CreateProjectButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3MXKI.default), {
        label: formatMessage((0, $acCqn.default).createProjectLabel),
        testId: $1f7880bbb09ab94b$var$TEST_ID,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $gb5lQ.LOCATION));
            onClick();
        }
    });
};
var $1f7880bbb09ab94b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1f7880bbb09ab94b$var$CreateProjectButton);

});
parcelRegister("acCqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f0808b9a7f055d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f0808b9a7f055d1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProjectLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
        "defaultMessage": "Create project"
    }
});

});



parcelRegister("hJE3l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TemplatePickerFallback", () => $47229cd857e246da$export$675ac63e0637d34d);
$parcel$export(module.exports, "default", () => $47229cd857e246da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aYAc3 = parcelRequire("aYAc3");

var $kJpBP = parcelRequire("kJpBP");
var $h5xhD = parcelRequire("h5xhD");
var $9UCCQ = parcelRequire("9UCCQ");

var $eZJjh = parcelRequire("eZJjh");

var $c04PQ = parcelRequire("c04PQ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gb5lQ = parcelRequire("gb5lQ");

var $2H5YM = parcelRequire("2H5YM");
const $47229cd857e246da$var$POPUP_WIDTH = 272;
const $47229cd857e246da$export$675ac63e0637d34d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
const $47229cd857e246da$var$TemplatePicker = ({ data: { templates: templates, recommendationSessionId: recommendationSessionId }, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleTemplateClick = (0, $5uXOq.useCallback)((projectTypeTemplates, isLastUsed, isRecommended, templateType)=>()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                selectedProjectType: 'business',
                showExperienceSelection: false,
                defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                source: (0, $gb5lQ.LOCATION),
                recommendationSessionId: recommendationSessionId
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                isLastUsed: isLastUsed,
                isRecommended: isRecommended,
                templateType: templateType,
                recommendationSessionId: recommendationSessionId
            });
        }, [
        createAnalyticsEvent,
        openProjectCreateDrawer,
        recommendationSessionId
    ]);
    const handleMoreTemplatesClick = (0, $5uXOq.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $gb5lQ.LOCATION)
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    const handleImportButtonClick = (0, $5uXOq.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $gb5lQ.LOCATION),
            isImportProjectOpenInitially: true
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5xhD.default), {
        minWidth: $47229cd857e246da$var$POPUP_WIDTH,
        testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$export$675ac63e0637d34d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $2H5YM.default).sectionTitle)
    }, Array.isArray(templates) && templates.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$StyledImage, {
                src: iconUrl,
                alt: `${title.label} icon`
            }),
            key: key,
            onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended, key)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$ButtonText, null, title.label), isLastUsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), null, formatMessage((0, $2H5YM.default).lastCreated))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
        onClick: handleMoreTemplatesClick
    }, formatMessage((0, $2H5YM.default).moreTemplatesButtonText)), !(0, $c04PQ.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
        onClick: handleImportButtonClick
    }, formatMessage((0, $2H5YM.default).importButtonText)))));
};
var $47229cd857e246da$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($47229cd857e246da$var$TemplatePicker);
const $47229cd857e246da$var$StyledImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsbzwfg _5ral1dfr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47229cd857e246da$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qpxbi _u5f3idpf _n3tdpxbi _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47229cd857e246da$var$ButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h5xhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a58bdbbfac4ce9$export$2e2bcd8739ae039);
/* popup-menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");
/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */ const $92a58bdbbfac4ce9$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZUJu.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    });
var $92a58bdbbfac4ce9$export$2e2bcd8739ae039 = $92a58bdbbfac4ce9$var$PopupMenuGroup;

});

parcelRegister("2H5YM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad55b7f9c6c06ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6ad55b7f9c6c06ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sectionTitle: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
        "defaultMessage": "Start a new project"
    },
    moreTemplatesButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
        "defaultMessage": "More templates"
    },
    importButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
        "defaultMessage": "Import"
    },
    lastCreated: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
        "defaultMessage": "Last created"
    }
});

});







//# sourceMappingURL=async-sidebar-core.a6ae8dd2.js.map
